/* eslint-disable */
export default [
  {
    "cities": [
      {
        "cityName": "市辖区",
        "cityCode": "110100000000",
        "counties": [
          {
            "countyCode": "110101000000",
            "countyName": "东城区"
          },
          {
            "countyCode": "110102000000",
            "countyName": "西城区"
          },
          {
            "countyCode": "110105000000",
            "countyName": "朝阳区"
          },
          {
            "countyCode": "110106000000",
            "countyName": "丰台区"
          },
          {
            "countyCode": "110107000000",
            "countyName": "石景山区"
          },
          {
            "countyCode": "110108000000",
            "countyName": "海淀区"
          },
          {
            "countyCode": "110109000000",
            "countyName": "门头沟区"
          },
          {
            "countyCode": "110111000000",
            "countyName": "房山区"
          },
          {
            "countyCode": "110112000000",
            "countyName": "通州区"
          },
          {
            "countyCode": "110113000000",
            "countyName": "顺义区"
          },
          {
            "countyCode": "110114000000",
            "countyName": "昌平区"
          },
          {
            "countyCode": "110115000000",
            "countyName": "大兴区"
          },
          {
            "countyCode": "110116000000",
            "countyName": "怀柔区"
          },
          {
            "countyCode": "110117000000",
            "countyName": "平谷区"
          },
          {
            "countyCode": "110118000000",
            "countyName": "密云区"
          },
          {
            "countyCode": "110119000000",
            "countyName": "延庆区"
          }
        ]
      }
    ],
    "provinceCode": "110000000000",
    "provinceName": "北京市"
  },
  {
    "cities": [
      {
        "cityName": "市辖区",
        "cityCode": "120100000000",
        "counties": [
          {
            "countyCode": "120101000000",
            "countyName": "和平区"
          },
          {
            "countyCode": "120102000000",
            "countyName": "河东区"
          },
          {
            "countyCode": "120103000000",
            "countyName": "河西区"
          },
          {
            "countyCode": "120104000000",
            "countyName": "南开区"
          },
          {
            "countyCode": "120105000000",
            "countyName": "河北区"
          },
          {
            "countyCode": "120106000000",
            "countyName": "红桥区"
          },
          {
            "countyCode": "120110000000",
            "countyName": "东丽区"
          },
          {
            "countyCode": "120111000000",
            "countyName": "西青区"
          },
          {
            "countyCode": "120112000000",
            "countyName": "津南区"
          },
          {
            "countyCode": "120113000000",
            "countyName": "北辰区"
          },
          {
            "countyCode": "120114000000",
            "countyName": "武清区"
          },
          {
            "countyCode": "120115000000",
            "countyName": "宝坻区"
          },
          {
            "countyCode": "120116000000",
            "countyName": "滨海新区"
          },
          {
            "countyCode": "120117000000",
            "countyName": "宁河区"
          },
          {
            "countyCode": "120118000000",
            "countyName": "静海区"
          },
          {
            "countyCode": "120119000000",
            "countyName": "蓟州区"
          }
        ]
      }
    ],
    "provinceCode": "120000000000",
    "provinceName": "天津市"
  },
  {
    "cities": [
      {
        "cityName": "石家庄市",
        "cityCode": "130100000000",
        "counties": [
          {
            "countyCode": "130101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130102000000",
            "countyName": "长安区"
          },
          {
            "countyCode": "130104000000",
            "countyName": "桥西区"
          },
          {
            "countyCode": "130105000000",
            "countyName": "新华区"
          },
          {
            "countyCode": "130107000000",
            "countyName": "井陉矿区"
          },
          {
            "countyCode": "130108000000",
            "countyName": "裕华区"
          },
          {
            "countyCode": "130109000000",
            "countyName": "藁城区"
          },
          {
            "countyCode": "130110000000",
            "countyName": "鹿泉区"
          },
          {
            "countyCode": "130111000000",
            "countyName": "栾城区"
          },
          {
            "countyCode": "130121000000",
            "countyName": "井陉县"
          },
          {
            "countyCode": "130123000000",
            "countyName": "正定县"
          },
          {
            "countyCode": "130125000000",
            "countyName": "行唐县"
          },
          {
            "countyCode": "130126000000",
            "countyName": "灵寿县"
          },
          {
            "countyCode": "130127000000",
            "countyName": "高邑县"
          },
          {
            "countyCode": "130128000000",
            "countyName": "深泽县"
          },
          {
            "countyCode": "130129000000",
            "countyName": "赞皇县"
          },
          {
            "countyCode": "130130000000",
            "countyName": "无极县"
          },
          {
            "countyCode": "130131000000",
            "countyName": "平山县"
          },
          {
            "countyCode": "130132000000",
            "countyName": "元氏县"
          },
          {
            "countyCode": "130133000000",
            "countyName": "赵县"
          },
          {
            "countyCode": "130171000000",
            "countyName": "石家庄高新技术产业开发区"
          },
          {
            "countyCode": "130172000000",
            "countyName": "石家庄循环化工园区"
          },
          {
            "countyCode": "130181000000",
            "countyName": "辛集市"
          },
          {
            "countyCode": "130183000000",
            "countyName": "晋州市"
          },
          {
            "countyCode": "130184000000",
            "countyName": "新乐市"
          }
        ]
      },
      {
        "cityName": "唐山市",
        "cityCode": "130200000000",
        "counties": [
          {
            "countyCode": "130201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130202000000",
            "countyName": "路南区"
          },
          {
            "countyCode": "130203000000",
            "countyName": "路北区"
          },
          {
            "countyCode": "130204000000",
            "countyName": "古冶区"
          },
          {
            "countyCode": "130205000000",
            "countyName": "开平区"
          },
          {
            "countyCode": "130207000000",
            "countyName": "丰南区"
          },
          {
            "countyCode": "130208000000",
            "countyName": "丰润区"
          },
          {
            "countyCode": "130209000000",
            "countyName": "曹妃甸区"
          },
          {
            "countyCode": "130224000000",
            "countyName": "滦南县"
          },
          {
            "countyCode": "130225000000",
            "countyName": "乐亭县"
          },
          {
            "countyCode": "130227000000",
            "countyName": "迁西县"
          },
          {
            "countyCode": "130229000000",
            "countyName": "玉田县"
          },
          {
            "countyCode": "130271000000",
            "countyName": "唐山市芦台经济技术开发区"
          },
          {
            "countyCode": "130272000000",
            "countyName": "唐山市汉沽管理区"
          },
          {
            "countyCode": "130273000000",
            "countyName": "唐山高新技术产业开发区"
          },
          {
            "countyCode": "130274000000",
            "countyName": "河北唐山海港经济开发区"
          },
          {
            "countyCode": "130281000000",
            "countyName": "遵化市"
          },
          {
            "countyCode": "130283000000",
            "countyName": "迁安市"
          },
          {
            "countyCode": "130284000000",
            "countyName": "滦州市"
          }
        ]
      },
      {
        "cityName": "秦皇岛市",
        "cityCode": "130300000000",
        "counties": [
          {
            "countyCode": "130301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130302000000",
            "countyName": "海港区"
          },
          {
            "countyCode": "130303000000",
            "countyName": "山海关区"
          },
          {
            "countyCode": "130304000000",
            "countyName": "北戴河区"
          },
          {
            "countyCode": "130306000000",
            "countyName": "抚宁区"
          },
          {
            "countyCode": "130321000000",
            "countyName": "青龙满族自治县"
          },
          {
            "countyCode": "130322000000",
            "countyName": "昌黎县"
          },
          {
            "countyCode": "130324000000",
            "countyName": "卢龙县"
          },
          {
            "countyCode": "130371000000",
            "countyName": "秦皇岛市经济技术开发区"
          },
          {
            "countyCode": "130372000000",
            "countyName": "北戴河新区"
          }
        ]
      },
      {
        "cityName": "邯郸市",
        "cityCode": "130400000000",
        "counties": [
          {
            "countyCode": "130401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130402000000",
            "countyName": "邯山区"
          },
          {
            "countyCode": "130403000000",
            "countyName": "丛台区"
          },
          {
            "countyCode": "130404000000",
            "countyName": "复兴区"
          },
          {
            "countyCode": "130406000000",
            "countyName": "峰峰矿区"
          },
          {
            "countyCode": "130407000000",
            "countyName": "肥乡区"
          },
          {
            "countyCode": "130408000000",
            "countyName": "永年区"
          },
          {
            "countyCode": "130423000000",
            "countyName": "临漳县"
          },
          {
            "countyCode": "130424000000",
            "countyName": "成安县"
          },
          {
            "countyCode": "130425000000",
            "countyName": "大名县"
          },
          {
            "countyCode": "130426000000",
            "countyName": "涉县"
          },
          {
            "countyCode": "130427000000",
            "countyName": "磁县"
          },
          {
            "countyCode": "130430000000",
            "countyName": "邱县"
          },
          {
            "countyCode": "130431000000",
            "countyName": "鸡泽县"
          },
          {
            "countyCode": "130432000000",
            "countyName": "广平县"
          },
          {
            "countyCode": "130433000000",
            "countyName": "馆陶县"
          },
          {
            "countyCode": "130434000000",
            "countyName": "魏县"
          },
          {
            "countyCode": "130435000000",
            "countyName": "曲周县"
          },
          {
            "countyCode": "130471000000",
            "countyName": "邯郸经济技术开发区"
          },
          {
            "countyCode": "130473000000",
            "countyName": "邯郸冀南新区"
          },
          {
            "countyCode": "130481000000",
            "countyName": "武安市"
          }
        ]
      },
      {
        "cityName": "邢台市",
        "cityCode": "130500000000",
        "counties": [
          {
            "countyCode": "130501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130502000000",
            "countyName": "桥东区"
          },
          {
            "countyCode": "130503000000",
            "countyName": "桥西区"
          },
          {
            "countyCode": "130521000000",
            "countyName": "邢台县"
          },
          {
            "countyCode": "130522000000",
            "countyName": "临城县"
          },
          {
            "countyCode": "130523000000",
            "countyName": "内丘县"
          },
          {
            "countyCode": "130524000000",
            "countyName": "柏乡县"
          },
          {
            "countyCode": "130525000000",
            "countyName": "隆尧县"
          },
          {
            "countyCode": "130526000000",
            "countyName": "任县"
          },
          {
            "countyCode": "130527000000",
            "countyName": "南和县"
          },
          {
            "countyCode": "130528000000",
            "countyName": "宁晋县"
          },
          {
            "countyCode": "130529000000",
            "countyName": "巨鹿县"
          },
          {
            "countyCode": "130530000000",
            "countyName": "新河县"
          },
          {
            "countyCode": "130531000000",
            "countyName": "广宗县"
          },
          {
            "countyCode": "130532000000",
            "countyName": "平乡县"
          },
          {
            "countyCode": "130533000000",
            "countyName": "威县"
          },
          {
            "countyCode": "130534000000",
            "countyName": "清河县"
          },
          {
            "countyCode": "130535000000",
            "countyName": "临西县"
          },
          {
            "countyCode": "130571000000",
            "countyName": "河北邢台经济开发区"
          },
          {
            "countyCode": "130581000000",
            "countyName": "南宫市"
          },
          {
            "countyCode": "130582000000",
            "countyName": "沙河市"
          }
        ]
      },
      {
        "cityName": "保定市",
        "cityCode": "130600000000",
        "counties": [
          {
            "countyCode": "130601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130602000000",
            "countyName": "竞秀区"
          },
          {
            "countyCode": "130606000000",
            "countyName": "莲池区"
          },
          {
            "countyCode": "130607000000",
            "countyName": "满城区"
          },
          {
            "countyCode": "130608000000",
            "countyName": "清苑区"
          },
          {
            "countyCode": "130609000000",
            "countyName": "徐水区"
          },
          {
            "countyCode": "130623000000",
            "countyName": "涞水县"
          },
          {
            "countyCode": "130624000000",
            "countyName": "阜平县"
          },
          {
            "countyCode": "130626000000",
            "countyName": "定兴县"
          },
          {
            "countyCode": "130627000000",
            "countyName": "唐县"
          },
          {
            "countyCode": "130628000000",
            "countyName": "高阳县"
          },
          {
            "countyCode": "130629000000",
            "countyName": "容城县"
          },
          {
            "countyCode": "130630000000",
            "countyName": "涞源县"
          },
          {
            "countyCode": "130631000000",
            "countyName": "望都县"
          },
          {
            "countyCode": "130632000000",
            "countyName": "安新县"
          },
          {
            "countyCode": "130633000000",
            "countyName": "易县"
          },
          {
            "countyCode": "130634000000",
            "countyName": "曲阳县"
          },
          {
            "countyCode": "130635000000",
            "countyName": "蠡县"
          },
          {
            "countyCode": "130636000000",
            "countyName": "顺平县"
          },
          {
            "countyCode": "130637000000",
            "countyName": "博野县"
          },
          {
            "countyCode": "130638000000",
            "countyName": "雄县"
          },
          {
            "countyCode": "130671000000",
            "countyName": "保定高新技术产业开发区"
          },
          {
            "countyCode": "130672000000",
            "countyName": "保定白沟新城"
          },
          {
            "countyCode": "130681000000",
            "countyName": "涿州市"
          },
          {
            "countyCode": "130682000000",
            "countyName": "定州市"
          },
          {
            "countyCode": "130683000000",
            "countyName": "安国市"
          },
          {
            "countyCode": "130684000000",
            "countyName": "高碑店市"
          }
        ]
      },
      {
        "cityName": "张家口市",
        "cityCode": "130700000000",
        "counties": [
          {
            "countyCode": "130701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130702000000",
            "countyName": "桥东区"
          },
          {
            "countyCode": "130703000000",
            "countyName": "桥西区"
          },
          {
            "countyCode": "130705000000",
            "countyName": "宣化区"
          },
          {
            "countyCode": "130706000000",
            "countyName": "下花园区"
          },
          {
            "countyCode": "130708000000",
            "countyName": "万全区"
          },
          {
            "countyCode": "130709000000",
            "countyName": "崇礼区"
          },
          {
            "countyCode": "130722000000",
            "countyName": "张北县"
          },
          {
            "countyCode": "130723000000",
            "countyName": "康保县"
          },
          {
            "countyCode": "130724000000",
            "countyName": "沽源县"
          },
          {
            "countyCode": "130725000000",
            "countyName": "尚义县"
          },
          {
            "countyCode": "130726000000",
            "countyName": "蔚县"
          },
          {
            "countyCode": "130727000000",
            "countyName": "阳原县"
          },
          {
            "countyCode": "130728000000",
            "countyName": "怀安县"
          },
          {
            "countyCode": "130730000000",
            "countyName": "怀来县"
          },
          {
            "countyCode": "130731000000",
            "countyName": "涿鹿县"
          },
          {
            "countyCode": "130732000000",
            "countyName": "赤城县"
          },
          {
            "countyCode": "130771000000",
            "countyName": "张家口市高新技术产业开发区"
          },
          {
            "countyCode": "130772000000",
            "countyName": "张家口市察北管理区"
          },
          {
            "countyCode": "130773000000",
            "countyName": "张家口市塞北管理区"
          }
        ]
      },
      {
        "cityName": "承德市",
        "cityCode": "130800000000",
        "counties": [
          {
            "countyCode": "130801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130802000000",
            "countyName": "双桥区"
          },
          {
            "countyCode": "130803000000",
            "countyName": "双滦区"
          },
          {
            "countyCode": "130804000000",
            "countyName": "鹰手营子矿区"
          },
          {
            "countyCode": "130821000000",
            "countyName": "承德县"
          },
          {
            "countyCode": "130822000000",
            "countyName": "兴隆县"
          },
          {
            "countyCode": "130824000000",
            "countyName": "滦平县"
          },
          {
            "countyCode": "130825000000",
            "countyName": "隆化县"
          },
          {
            "countyCode": "130826000000",
            "countyName": "丰宁满族自治县"
          },
          {
            "countyCode": "130827000000",
            "countyName": "宽城满族自治县"
          },
          {
            "countyCode": "130828000000",
            "countyName": "围场满族蒙古族自治县"
          },
          {
            "countyCode": "130871000000",
            "countyName": "承德高新技术产业开发区"
          },
          {
            "countyCode": "130881000000",
            "countyName": "平泉市"
          }
        ]
      },
      {
        "cityName": "沧州市",
        "cityCode": "130900000000",
        "counties": [
          {
            "countyCode": "130901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "130902000000",
            "countyName": "新华区"
          },
          {
            "countyCode": "130903000000",
            "countyName": "运河区"
          },
          {
            "countyCode": "130921000000",
            "countyName": "沧县"
          },
          {
            "countyCode": "130922000000",
            "countyName": "青县"
          },
          {
            "countyCode": "130923000000",
            "countyName": "东光县"
          },
          {
            "countyCode": "130924000000",
            "countyName": "海兴县"
          },
          {
            "countyCode": "130925000000",
            "countyName": "盐山县"
          },
          {
            "countyCode": "130926000000",
            "countyName": "肃宁县"
          },
          {
            "countyCode": "130927000000",
            "countyName": "南皮县"
          },
          {
            "countyCode": "130928000000",
            "countyName": "吴桥县"
          },
          {
            "countyCode": "130929000000",
            "countyName": "献县"
          },
          {
            "countyCode": "130930000000",
            "countyName": "孟村回族自治县"
          },
          {
            "countyCode": "130971000000",
            "countyName": "河北沧州经济开发区"
          },
          {
            "countyCode": "130972000000",
            "countyName": "沧州高新技术产业开发区"
          },
          {
            "countyCode": "130973000000",
            "countyName": "沧州渤海新区"
          },
          {
            "countyCode": "130981000000",
            "countyName": "泊头市"
          },
          {
            "countyCode": "130982000000",
            "countyName": "任丘市"
          },
          {
            "countyCode": "130983000000",
            "countyName": "黄骅市"
          },
          {
            "countyCode": "130984000000",
            "countyName": "河间市"
          }
        ]
      },
      {
        "cityName": "廊坊市",
        "cityCode": "131000000000",
        "counties": [
          {
            "countyCode": "131001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "131002000000",
            "countyName": "安次区"
          },
          {
            "countyCode": "131003000000",
            "countyName": "广阳区"
          },
          {
            "countyCode": "131022000000",
            "countyName": "固安县"
          },
          {
            "countyCode": "131023000000",
            "countyName": "永清县"
          },
          {
            "countyCode": "131024000000",
            "countyName": "香河县"
          },
          {
            "countyCode": "131025000000",
            "countyName": "大城县"
          },
          {
            "countyCode": "131026000000",
            "countyName": "文安县"
          },
          {
            "countyCode": "131028000000",
            "countyName": "大厂回族自治县"
          },
          {
            "countyCode": "131071000000",
            "countyName": "廊坊经济技术开发区"
          },
          {
            "countyCode": "131081000000",
            "countyName": "霸州市"
          },
          {
            "countyCode": "131082000000",
            "countyName": "三河市"
          }
        ]
      },
      {
        "cityName": "衡水市",
        "cityCode": "131100000000",
        "counties": [
          {
            "countyCode": "131101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "131102000000",
            "countyName": "桃城区"
          },
          {
            "countyCode": "131103000000",
            "countyName": "冀州区"
          },
          {
            "countyCode": "131121000000",
            "countyName": "枣强县"
          },
          {
            "countyCode": "131122000000",
            "countyName": "武邑县"
          },
          {
            "countyCode": "131123000000",
            "countyName": "武强县"
          },
          {
            "countyCode": "131124000000",
            "countyName": "饶阳县"
          },
          {
            "countyCode": "131125000000",
            "countyName": "安平县"
          },
          {
            "countyCode": "131126000000",
            "countyName": "故城县"
          },
          {
            "countyCode": "131127000000",
            "countyName": "景县"
          },
          {
            "countyCode": "131128000000",
            "countyName": "阜城县"
          },
          {
            "countyCode": "131171000000",
            "countyName": "河北衡水高新技术产业开发区"
          },
          {
            "countyCode": "131172000000",
            "countyName": "衡水滨湖新区"
          },
          {
            "countyCode": "131182000000",
            "countyName": "深州市"
          }
        ]
      }
    ],
    "provinceCode": "130000000000",
    "provinceName": "河北省"
  },
  {
    "cities": [
      {
        "cityName": "太原市",
        "cityCode": "140100000000",
        "counties": [
          {
            "countyCode": "140101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140105000000",
            "countyName": "小店区"
          },
          {
            "countyCode": "140106000000",
            "countyName": "迎泽区"
          },
          {
            "countyCode": "140107000000",
            "countyName": "杏花岭区"
          },
          {
            "countyCode": "140108000000",
            "countyName": "尖草坪区"
          },
          {
            "countyCode": "140109000000",
            "countyName": "万柏林区"
          },
          {
            "countyCode": "140110000000",
            "countyName": "晋源区"
          },
          {
            "countyCode": "140121000000",
            "countyName": "清徐县"
          },
          {
            "countyCode": "140122000000",
            "countyName": "阳曲县"
          },
          {
            "countyCode": "140123000000",
            "countyName": "娄烦县"
          },
          {
            "countyCode": "140171000000",
            "countyName": "山西转型综合改革示范区"
          },
          {
            "countyCode": "140181000000",
            "countyName": "古交市"
          }
        ]
      },
      {
        "cityName": "大同市",
        "cityCode": "140200000000",
        "counties": [
          {
            "countyCode": "140201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140212000000",
            "countyName": "新荣区"
          },
          {
            "countyCode": "140213000000",
            "countyName": "平城区"
          },
          {
            "countyCode": "140214000000",
            "countyName": "云冈区"
          },
          {
            "countyCode": "140215000000",
            "countyName": "云州区"
          },
          {
            "countyCode": "140221000000",
            "countyName": "阳高县"
          },
          {
            "countyCode": "140222000000",
            "countyName": "天镇县"
          },
          {
            "countyCode": "140223000000",
            "countyName": "广灵县"
          },
          {
            "countyCode": "140224000000",
            "countyName": "灵丘县"
          },
          {
            "countyCode": "140225000000",
            "countyName": "浑源县"
          },
          {
            "countyCode": "140226000000",
            "countyName": "左云县"
          },
          {
            "countyCode": "140271000000",
            "countyName": "山西大同经济开发区"
          }
        ]
      },
      {
        "cityName": "阳泉市",
        "cityCode": "140300000000",
        "counties": [
          {
            "countyCode": "140301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140302000000",
            "countyName": "城区"
          },
          {
            "countyCode": "140303000000",
            "countyName": "矿区"
          },
          {
            "countyCode": "140311000000",
            "countyName": "郊区"
          },
          {
            "countyCode": "140321000000",
            "countyName": "平定县"
          },
          {
            "countyCode": "140322000000",
            "countyName": "盂县"
          }
        ]
      },
      {
        "cityName": "长治市",
        "cityCode": "140400000000",
        "counties": [
          {
            "countyCode": "140401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140403000000",
            "countyName": "潞州区"
          },
          {
            "countyCode": "140404000000",
            "countyName": "上党区"
          },
          {
            "countyCode": "140405000000",
            "countyName": "屯留区"
          },
          {
            "countyCode": "140406000000",
            "countyName": "潞城区"
          },
          {
            "countyCode": "140423000000",
            "countyName": "襄垣县"
          },
          {
            "countyCode": "140425000000",
            "countyName": "平顺县"
          },
          {
            "countyCode": "140426000000",
            "countyName": "黎城县"
          },
          {
            "countyCode": "140427000000",
            "countyName": "壶关县"
          },
          {
            "countyCode": "140428000000",
            "countyName": "长子县"
          },
          {
            "countyCode": "140429000000",
            "countyName": "武乡县"
          },
          {
            "countyCode": "140430000000",
            "countyName": "沁县"
          },
          {
            "countyCode": "140431000000",
            "countyName": "沁源县"
          },
          {
            "countyCode": "140471000000",
            "countyName": "山西长治高新技术产业园区"
          }
        ]
      },
      {
        "cityName": "晋城市",
        "cityCode": "140500000000",
        "counties": [
          {
            "countyCode": "140501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140502000000",
            "countyName": "城区"
          },
          {
            "countyCode": "140521000000",
            "countyName": "沁水县"
          },
          {
            "countyCode": "140522000000",
            "countyName": "阳城县"
          },
          {
            "countyCode": "140524000000",
            "countyName": "陵川县"
          },
          {
            "countyCode": "140525000000",
            "countyName": "泽州县"
          },
          {
            "countyCode": "140581000000",
            "countyName": "高平市"
          }
        ]
      },
      {
        "cityName": "朔州市",
        "cityCode": "140600000000",
        "counties": [
          {
            "countyCode": "140601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140602000000",
            "countyName": "朔城区"
          },
          {
            "countyCode": "140603000000",
            "countyName": "平鲁区"
          },
          {
            "countyCode": "140621000000",
            "countyName": "山阴县"
          },
          {
            "countyCode": "140622000000",
            "countyName": "应县"
          },
          {
            "countyCode": "140623000000",
            "countyName": "右玉县"
          },
          {
            "countyCode": "140671000000",
            "countyName": "山西朔州经济开发区"
          },
          {
            "countyCode": "140681000000",
            "countyName": "怀仁市"
          }
        ]
      },
      {
        "cityName": "晋中市",
        "cityCode": "140700000000",
        "counties": [
          {
            "countyCode": "140701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140702000000",
            "countyName": "榆次区"
          },
          {
            "countyCode": "140721000000",
            "countyName": "榆社县"
          },
          {
            "countyCode": "140722000000",
            "countyName": "左权县"
          },
          {
            "countyCode": "140723000000",
            "countyName": "和顺县"
          },
          {
            "countyCode": "140724000000",
            "countyName": "昔阳县"
          },
          {
            "countyCode": "140725000000",
            "countyName": "寿阳县"
          },
          {
            "countyCode": "140726000000",
            "countyName": "太谷县"
          },
          {
            "countyCode": "140727000000",
            "countyName": "祁县"
          },
          {
            "countyCode": "140728000000",
            "countyName": "平遥县"
          },
          {
            "countyCode": "140729000000",
            "countyName": "灵石县"
          },
          {
            "countyCode": "140781000000",
            "countyName": "介休市"
          }
        ]
      },
      {
        "cityName": "运城市",
        "cityCode": "140800000000",
        "counties": [
          {
            "countyCode": "140801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140802000000",
            "countyName": "盐湖区"
          },
          {
            "countyCode": "140821000000",
            "countyName": "临猗县"
          },
          {
            "countyCode": "140822000000",
            "countyName": "万荣县"
          },
          {
            "countyCode": "140823000000",
            "countyName": "闻喜县"
          },
          {
            "countyCode": "140824000000",
            "countyName": "稷山县"
          },
          {
            "countyCode": "140825000000",
            "countyName": "新绛县"
          },
          {
            "countyCode": "140826000000",
            "countyName": "绛县"
          },
          {
            "countyCode": "140827000000",
            "countyName": "垣曲县"
          },
          {
            "countyCode": "140828000000",
            "countyName": "夏县"
          },
          {
            "countyCode": "140829000000",
            "countyName": "平陆县"
          },
          {
            "countyCode": "140830000000",
            "countyName": "芮城县"
          },
          {
            "countyCode": "140881000000",
            "countyName": "永济市"
          },
          {
            "countyCode": "140882000000",
            "countyName": "河津市"
          }
        ]
      },
      {
        "cityName": "忻州市",
        "cityCode": "140900000000",
        "counties": [
          {
            "countyCode": "140901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "140902000000",
            "countyName": "忻府区"
          },
          {
            "countyCode": "140921000000",
            "countyName": "定襄县"
          },
          {
            "countyCode": "140922000000",
            "countyName": "五台县"
          },
          {
            "countyCode": "140923000000",
            "countyName": "代县"
          },
          {
            "countyCode": "140924000000",
            "countyName": "繁峙县"
          },
          {
            "countyCode": "140925000000",
            "countyName": "宁武县"
          },
          {
            "countyCode": "140926000000",
            "countyName": "静乐县"
          },
          {
            "countyCode": "140927000000",
            "countyName": "神池县"
          },
          {
            "countyCode": "140928000000",
            "countyName": "五寨县"
          },
          {
            "countyCode": "140929000000",
            "countyName": "岢岚县"
          },
          {
            "countyCode": "140930000000",
            "countyName": "河曲县"
          },
          {
            "countyCode": "140931000000",
            "countyName": "保德县"
          },
          {
            "countyCode": "140932000000",
            "countyName": "偏关县"
          },
          {
            "countyCode": "140971000000",
            "countyName": "五台山风景名胜区"
          },
          {
            "countyCode": "140981000000",
            "countyName": "原平市"
          }
        ]
      },
      {
        "cityName": "临汾市",
        "cityCode": "141000000000",
        "counties": [
          {
            "countyCode": "141001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "141002000000",
            "countyName": "尧都区"
          },
          {
            "countyCode": "141021000000",
            "countyName": "曲沃县"
          },
          {
            "countyCode": "141022000000",
            "countyName": "翼城县"
          },
          {
            "countyCode": "141023000000",
            "countyName": "襄汾县"
          },
          {
            "countyCode": "141024000000",
            "countyName": "洪洞县"
          },
          {
            "countyCode": "141025000000",
            "countyName": "古县"
          },
          {
            "countyCode": "141026000000",
            "countyName": "安泽县"
          },
          {
            "countyCode": "141027000000",
            "countyName": "浮山县"
          },
          {
            "countyCode": "141028000000",
            "countyName": "吉县"
          },
          {
            "countyCode": "141029000000",
            "countyName": "乡宁县"
          },
          {
            "countyCode": "141030000000",
            "countyName": "大宁县"
          },
          {
            "countyCode": "141031000000",
            "countyName": "隰县"
          },
          {
            "countyCode": "141032000000",
            "countyName": "永和县"
          },
          {
            "countyCode": "141033000000",
            "countyName": "蒲县"
          },
          {
            "countyCode": "141034000000",
            "countyName": "汾西县"
          },
          {
            "countyCode": "141081000000",
            "countyName": "侯马市"
          },
          {
            "countyCode": "141082000000",
            "countyName": "霍州市"
          }
        ]
      },
      {
        "cityName": "吕梁市",
        "cityCode": "141100000000",
        "counties": [
          {
            "countyCode": "141101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "141102000000",
            "countyName": "离石区"
          },
          {
            "countyCode": "141121000000",
            "countyName": "文水县"
          },
          {
            "countyCode": "141122000000",
            "countyName": "交城县"
          },
          {
            "countyCode": "141123000000",
            "countyName": "兴县"
          },
          {
            "countyCode": "141124000000",
            "countyName": "临县"
          },
          {
            "countyCode": "141125000000",
            "countyName": "柳林县"
          },
          {
            "countyCode": "141126000000",
            "countyName": "石楼县"
          },
          {
            "countyCode": "141127000000",
            "countyName": "岚县"
          },
          {
            "countyCode": "141128000000",
            "countyName": "方山县"
          },
          {
            "countyCode": "141129000000",
            "countyName": "中阳县"
          },
          {
            "countyCode": "141130000000",
            "countyName": "交口县"
          },
          {
            "countyCode": "141181000000",
            "countyName": "孝义市"
          },
          {
            "countyCode": "141182000000",
            "countyName": "汾阳市"
          }
        ]
      }
    ],
    "provinceCode": "140000000000",
    "provinceName": "山西省"
  },
  {
    "cities": [
      {
        "cityName": "呼和浩特市",
        "cityCode": "150100000000",
        "counties": [
          {
            "countyCode": "150101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150102000000",
            "countyName": "新城区"
          },
          {
            "countyCode": "150103000000",
            "countyName": "回民区"
          },
          {
            "countyCode": "150104000000",
            "countyName": "玉泉区"
          },
          {
            "countyCode": "150105000000",
            "countyName": "赛罕区"
          },
          {
            "countyCode": "150121000000",
            "countyName": "土默特左旗"
          },
          {
            "countyCode": "150122000000",
            "countyName": "托克托县"
          },
          {
            "countyCode": "150123000000",
            "countyName": "和林格尔县"
          },
          {
            "countyCode": "150124000000",
            "countyName": "清水河县"
          },
          {
            "countyCode": "150125000000",
            "countyName": "武川县"
          },
          {
            "countyCode": "150171000000",
            "countyName": "呼和浩特金海工业园区"
          },
          {
            "countyCode": "150172000000",
            "countyName": "呼和浩特经济技术开发区"
          }
        ]
      },
      {
        "cityName": "包头市",
        "cityCode": "150200000000",
        "counties": [
          {
            "countyCode": "150201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150202000000",
            "countyName": "东河区"
          },
          {
            "countyCode": "150203000000",
            "countyName": "昆都仑区"
          },
          {
            "countyCode": "150204000000",
            "countyName": "青山区"
          },
          {
            "countyCode": "150205000000",
            "countyName": "石拐区"
          },
          {
            "countyCode": "150206000000",
            "countyName": "白云鄂博矿区"
          },
          {
            "countyCode": "150207000000",
            "countyName": "九原区"
          },
          {
            "countyCode": "150221000000",
            "countyName": "土默特右旗"
          },
          {
            "countyCode": "150222000000",
            "countyName": "固阳县"
          },
          {
            "countyCode": "150223000000",
            "countyName": "达尔罕茂明安联合旗"
          },
          {
            "countyCode": "150271000000",
            "countyName": "包头稀土高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "乌海市",
        "cityCode": "150300000000",
        "counties": [
          {
            "countyCode": "150301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150302000000",
            "countyName": "海勃湾区"
          },
          {
            "countyCode": "150303000000",
            "countyName": "海南区"
          },
          {
            "countyCode": "150304000000",
            "countyName": "乌达区"
          }
        ]
      },
      {
        "cityName": "赤峰市",
        "cityCode": "150400000000",
        "counties": [
          {
            "countyCode": "150401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150402000000",
            "countyName": "红山区"
          },
          {
            "countyCode": "150403000000",
            "countyName": "元宝山区"
          },
          {
            "countyCode": "150404000000",
            "countyName": "松山区"
          },
          {
            "countyCode": "150421000000",
            "countyName": "阿鲁科尔沁旗"
          },
          {
            "countyCode": "150422000000",
            "countyName": "巴林左旗"
          },
          {
            "countyCode": "150423000000",
            "countyName": "巴林右旗"
          },
          {
            "countyCode": "150424000000",
            "countyName": "林西县"
          },
          {
            "countyCode": "150425000000",
            "countyName": "克什克腾旗"
          },
          {
            "countyCode": "150426000000",
            "countyName": "翁牛特旗"
          },
          {
            "countyCode": "150428000000",
            "countyName": "喀喇沁旗"
          },
          {
            "countyCode": "150429000000",
            "countyName": "宁城县"
          },
          {
            "countyCode": "150430000000",
            "countyName": "敖汉旗"
          }
        ]
      },
      {
        "cityName": "通辽市",
        "cityCode": "150500000000",
        "counties": [
          {
            "countyCode": "150501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150502000000",
            "countyName": "科尔沁区"
          },
          {
            "countyCode": "150521000000",
            "countyName": "科尔沁左翼中旗"
          },
          {
            "countyCode": "150522000000",
            "countyName": "科尔沁左翼后旗"
          },
          {
            "countyCode": "150523000000",
            "countyName": "开鲁县"
          },
          {
            "countyCode": "150524000000",
            "countyName": "库伦旗"
          },
          {
            "countyCode": "150525000000",
            "countyName": "奈曼旗"
          },
          {
            "countyCode": "150526000000",
            "countyName": "扎鲁特旗"
          },
          {
            "countyCode": "150571000000",
            "countyName": "通辽经济技术开发区"
          },
          {
            "countyCode": "150581000000",
            "countyName": "霍林郭勒市"
          }
        ]
      },
      {
        "cityName": "鄂尔多斯市",
        "cityCode": "150600000000",
        "counties": [
          {
            "countyCode": "150601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150602000000",
            "countyName": "东胜区"
          },
          {
            "countyCode": "150603000000",
            "countyName": "康巴什区"
          },
          {
            "countyCode": "150621000000",
            "countyName": "达拉特旗"
          },
          {
            "countyCode": "150622000000",
            "countyName": "准格尔旗"
          },
          {
            "countyCode": "150623000000",
            "countyName": "鄂托克前旗"
          },
          {
            "countyCode": "150624000000",
            "countyName": "鄂托克旗"
          },
          {
            "countyCode": "150625000000",
            "countyName": "杭锦旗"
          },
          {
            "countyCode": "150626000000",
            "countyName": "乌审旗"
          },
          {
            "countyCode": "150627000000",
            "countyName": "伊金霍洛旗"
          }
        ]
      },
      {
        "cityName": "呼伦贝尔市",
        "cityCode": "150700000000",
        "counties": [
          {
            "countyCode": "150701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150702000000",
            "countyName": "海拉尔区"
          },
          {
            "countyCode": "150703000000",
            "countyName": "扎赉诺尔区"
          },
          {
            "countyCode": "150721000000",
            "countyName": "阿荣旗"
          },
          {
            "countyCode": "150722000000",
            "countyName": "莫力达瓦达斡尔族自治旗"
          },
          {
            "countyCode": "150723000000",
            "countyName": "鄂伦春自治旗"
          },
          {
            "countyCode": "150724000000",
            "countyName": "鄂温克族自治旗"
          },
          {
            "countyCode": "150725000000",
            "countyName": "陈巴尔虎旗"
          },
          {
            "countyCode": "150726000000",
            "countyName": "新巴尔虎左旗"
          },
          {
            "countyCode": "150727000000",
            "countyName": "新巴尔虎右旗"
          },
          {
            "countyCode": "150781000000",
            "countyName": "满洲里市"
          },
          {
            "countyCode": "150782000000",
            "countyName": "牙克石市"
          },
          {
            "countyCode": "150783000000",
            "countyName": "扎兰屯市"
          },
          {
            "countyCode": "150784000000",
            "countyName": "额尔古纳市"
          },
          {
            "countyCode": "150785000000",
            "countyName": "根河市"
          }
        ]
      },
      {
        "cityName": "巴彦淖尔市",
        "cityCode": "150800000000",
        "counties": [
          {
            "countyCode": "150801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150802000000",
            "countyName": "临河区"
          },
          {
            "countyCode": "150821000000",
            "countyName": "五原县"
          },
          {
            "countyCode": "150822000000",
            "countyName": "磴口县"
          },
          {
            "countyCode": "150823000000",
            "countyName": "乌拉特前旗"
          },
          {
            "countyCode": "150824000000",
            "countyName": "乌拉特中旗"
          },
          {
            "countyCode": "150825000000",
            "countyName": "乌拉特后旗"
          },
          {
            "countyCode": "150826000000",
            "countyName": "杭锦后旗"
          }
        ]
      },
      {
        "cityName": "乌兰察布市",
        "cityCode": "150900000000",
        "counties": [
          {
            "countyCode": "150901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "150902000000",
            "countyName": "集宁区"
          },
          {
            "countyCode": "150921000000",
            "countyName": "卓资县"
          },
          {
            "countyCode": "150922000000",
            "countyName": "化德县"
          },
          {
            "countyCode": "150923000000",
            "countyName": "商都县"
          },
          {
            "countyCode": "150924000000",
            "countyName": "兴和县"
          },
          {
            "countyCode": "150925000000",
            "countyName": "凉城县"
          },
          {
            "countyCode": "150926000000",
            "countyName": "察哈尔右翼前旗"
          },
          {
            "countyCode": "150927000000",
            "countyName": "察哈尔右翼中旗"
          },
          {
            "countyCode": "150928000000",
            "countyName": "察哈尔右翼后旗"
          },
          {
            "countyCode": "150929000000",
            "countyName": "四子王旗"
          },
          {
            "countyCode": "150981000000",
            "countyName": "丰镇市"
          }
        ]
      },
      {
        "cityName": "兴安盟",
        "cityCode": "152200000000",
        "counties": [
          {
            "countyCode": "152201000000",
            "countyName": "乌兰浩特市"
          },
          {
            "countyCode": "152202000000",
            "countyName": "阿尔山市"
          },
          {
            "countyCode": "152221000000",
            "countyName": "科尔沁右翼前旗"
          },
          {
            "countyCode": "152222000000",
            "countyName": "科尔沁右翼中旗"
          },
          {
            "countyCode": "152223000000",
            "countyName": "扎赉特旗"
          },
          {
            "countyCode": "152224000000",
            "countyName": "突泉县"
          }
        ]
      },
      {
        "cityName": "锡林郭勒盟",
        "cityCode": "152500000000",
        "counties": [
          {
            "countyCode": "152501000000",
            "countyName": "二连浩特市"
          },
          {
            "countyCode": "152502000000",
            "countyName": "锡林浩特市"
          },
          {
            "countyCode": "152522000000",
            "countyName": "阿巴嘎旗"
          },
          {
            "countyCode": "152523000000",
            "countyName": "苏尼特左旗"
          },
          {
            "countyCode": "152524000000",
            "countyName": "苏尼特右旗"
          },
          {
            "countyCode": "152525000000",
            "countyName": "东乌珠穆沁旗"
          },
          {
            "countyCode": "152526000000",
            "countyName": "西乌珠穆沁旗"
          },
          {
            "countyCode": "152527000000",
            "countyName": "太仆寺旗"
          },
          {
            "countyCode": "152528000000",
            "countyName": "镶黄旗"
          },
          {
            "countyCode": "152529000000",
            "countyName": "正镶白旗"
          },
          {
            "countyCode": "152530000000",
            "countyName": "正蓝旗"
          },
          {
            "countyCode": "152531000000",
            "countyName": "多伦县"
          },
          {
            "countyCode": "152571000000",
            "countyName": "乌拉盖管委会"
          }
        ]
      },
      {
        "cityName": "阿拉善盟",
        "cityCode": "152900000000",
        "counties": [
          {
            "countyCode": "152921000000",
            "countyName": "阿拉善左旗"
          },
          {
            "countyCode": "152922000000",
            "countyName": "阿拉善右旗"
          },
          {
            "countyCode": "152923000000",
            "countyName": "额济纳旗"
          },
          {
            "countyCode": "152971000000",
            "countyName": "内蒙古阿拉善经济开发区"
          }
        ]
      }
    ],
    "provinceCode": "150000000000",
    "provinceName": "内蒙古自治区"
  },
  {
    "cities": [
      {
        "cityName": "沈阳市",
        "cityCode": "210100000000",
        "counties": [
          {
            "countyCode": "210101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210102000000",
            "countyName": "和平区"
          },
          {
            "countyCode": "210103000000",
            "countyName": "沈河区"
          },
          {
            "countyCode": "210104000000",
            "countyName": "大东区"
          },
          {
            "countyCode": "210105000000",
            "countyName": "皇姑区"
          },
          {
            "countyCode": "210106000000",
            "countyName": "铁西区"
          },
          {
            "countyCode": "210111000000",
            "countyName": "苏家屯区"
          },
          {
            "countyCode": "210112000000",
            "countyName": "浑南区"
          },
          {
            "countyCode": "210113000000",
            "countyName": "沈北新区"
          },
          {
            "countyCode": "210114000000",
            "countyName": "于洪区"
          },
          {
            "countyCode": "210115000000",
            "countyName": "辽中区"
          },
          {
            "countyCode": "210123000000",
            "countyName": "康平县"
          },
          {
            "countyCode": "210124000000",
            "countyName": "法库县"
          },
          {
            "countyCode": "210181000000",
            "countyName": "新民市"
          }
        ]
      },
      {
        "cityName": "大连市",
        "cityCode": "210200000000",
        "counties": [
          {
            "countyCode": "210201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210202000000",
            "countyName": "中山区"
          },
          {
            "countyCode": "210203000000",
            "countyName": "西岗区"
          },
          {
            "countyCode": "210204000000",
            "countyName": "沙河口区"
          },
          {
            "countyCode": "210211000000",
            "countyName": "甘井子区"
          },
          {
            "countyCode": "210212000000",
            "countyName": "旅顺口区"
          },
          {
            "countyCode": "210213000000",
            "countyName": "金州区"
          },
          {
            "countyCode": "210214000000",
            "countyName": "普兰店区"
          },
          {
            "countyCode": "210224000000",
            "countyName": "长海县"
          },
          {
            "countyCode": "210281000000",
            "countyName": "瓦房店市"
          },
          {
            "countyCode": "210283000000",
            "countyName": "庄河市"
          }
        ]
      },
      {
        "cityName": "鞍山市",
        "cityCode": "210300000000",
        "counties": [
          {
            "countyCode": "210301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210302000000",
            "countyName": "铁东区"
          },
          {
            "countyCode": "210303000000",
            "countyName": "铁西区"
          },
          {
            "countyCode": "210304000000",
            "countyName": "立山区"
          },
          {
            "countyCode": "210311000000",
            "countyName": "千山区"
          },
          {
            "countyCode": "210321000000",
            "countyName": "台安县"
          },
          {
            "countyCode": "210323000000",
            "countyName": "岫岩满族自治县"
          },
          {
            "countyCode": "210381000000",
            "countyName": "海城市"
          }
        ]
      },
      {
        "cityName": "抚顺市",
        "cityCode": "210400000000",
        "counties": [
          {
            "countyCode": "210401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210402000000",
            "countyName": "新抚区"
          },
          {
            "countyCode": "210403000000",
            "countyName": "东洲区"
          },
          {
            "countyCode": "210404000000",
            "countyName": "望花区"
          },
          {
            "countyCode": "210411000000",
            "countyName": "顺城区"
          },
          {
            "countyCode": "210421000000",
            "countyName": "抚顺县"
          },
          {
            "countyCode": "210422000000",
            "countyName": "新宾满族自治县"
          },
          {
            "countyCode": "210423000000",
            "countyName": "清原满族自治县"
          }
        ]
      },
      {
        "cityName": "本溪市",
        "cityCode": "210500000000",
        "counties": [
          {
            "countyCode": "210501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210502000000",
            "countyName": "平山区"
          },
          {
            "countyCode": "210503000000",
            "countyName": "溪湖区"
          },
          {
            "countyCode": "210504000000",
            "countyName": "明山区"
          },
          {
            "countyCode": "210505000000",
            "countyName": "南芬区"
          },
          {
            "countyCode": "210521000000",
            "countyName": "本溪满族自治县"
          },
          {
            "countyCode": "210522000000",
            "countyName": "桓仁满族自治县"
          }
        ]
      },
      {
        "cityName": "丹东市",
        "cityCode": "210600000000",
        "counties": [
          {
            "countyCode": "210601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210602000000",
            "countyName": "元宝区"
          },
          {
            "countyCode": "210603000000",
            "countyName": "振兴区"
          },
          {
            "countyCode": "210604000000",
            "countyName": "振安区"
          },
          {
            "countyCode": "210624000000",
            "countyName": "宽甸满族自治县"
          },
          {
            "countyCode": "210681000000",
            "countyName": "东港市"
          },
          {
            "countyCode": "210682000000",
            "countyName": "凤城市"
          }
        ]
      },
      {
        "cityName": "锦州市",
        "cityCode": "210700000000",
        "counties": [
          {
            "countyCode": "210701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210702000000",
            "countyName": "古塔区"
          },
          {
            "countyCode": "210703000000",
            "countyName": "凌河区"
          },
          {
            "countyCode": "210711000000",
            "countyName": "太和区"
          },
          {
            "countyCode": "210726000000",
            "countyName": "黑山县"
          },
          {
            "countyCode": "210727000000",
            "countyName": "义县"
          },
          {
            "countyCode": "210781000000",
            "countyName": "凌海市"
          },
          {
            "countyCode": "210782000000",
            "countyName": "北镇市"
          }
        ]
      },
      {
        "cityName": "营口市",
        "cityCode": "210800000000",
        "counties": [
          {
            "countyCode": "210801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210802000000",
            "countyName": "站前区"
          },
          {
            "countyCode": "210803000000",
            "countyName": "西市区"
          },
          {
            "countyCode": "210804000000",
            "countyName": "鲅鱼圈区"
          },
          {
            "countyCode": "210811000000",
            "countyName": "老边区"
          },
          {
            "countyCode": "210881000000",
            "countyName": "盖州市"
          },
          {
            "countyCode": "210882000000",
            "countyName": "大石桥市"
          }
        ]
      },
      {
        "cityName": "阜新市",
        "cityCode": "210900000000",
        "counties": [
          {
            "countyCode": "210901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "210902000000",
            "countyName": "海州区"
          },
          {
            "countyCode": "210903000000",
            "countyName": "新邱区"
          },
          {
            "countyCode": "210904000000",
            "countyName": "太平区"
          },
          {
            "countyCode": "210905000000",
            "countyName": "清河门区"
          },
          {
            "countyCode": "210911000000",
            "countyName": "细河区"
          },
          {
            "countyCode": "210921000000",
            "countyName": "阜新蒙古族自治县"
          },
          {
            "countyCode": "210922000000",
            "countyName": "彰武县"
          }
        ]
      },
      {
        "cityName": "辽阳市",
        "cityCode": "211000000000",
        "counties": [
          {
            "countyCode": "211001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "211002000000",
            "countyName": "白塔区"
          },
          {
            "countyCode": "211003000000",
            "countyName": "文圣区"
          },
          {
            "countyCode": "211004000000",
            "countyName": "宏伟区"
          },
          {
            "countyCode": "211005000000",
            "countyName": "弓长岭区"
          },
          {
            "countyCode": "211011000000",
            "countyName": "太子河区"
          },
          {
            "countyCode": "211021000000",
            "countyName": "辽阳县"
          },
          {
            "countyCode": "211081000000",
            "countyName": "灯塔市"
          }
        ]
      },
      {
        "cityName": "盘锦市",
        "cityCode": "211100000000",
        "counties": [
          {
            "countyCode": "211101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "211102000000",
            "countyName": "双台子区"
          },
          {
            "countyCode": "211103000000",
            "countyName": "兴隆台区"
          },
          {
            "countyCode": "211104000000",
            "countyName": "大洼区"
          },
          {
            "countyCode": "211122000000",
            "countyName": "盘山县"
          }
        ]
      },
      {
        "cityName": "铁岭市",
        "cityCode": "211200000000",
        "counties": [
          {
            "countyCode": "211201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "211202000000",
            "countyName": "银州区"
          },
          {
            "countyCode": "211204000000",
            "countyName": "清河区"
          },
          {
            "countyCode": "211221000000",
            "countyName": "铁岭县"
          },
          {
            "countyCode": "211223000000",
            "countyName": "西丰县"
          },
          {
            "countyCode": "211224000000",
            "countyName": "昌图县"
          },
          {
            "countyCode": "211281000000",
            "countyName": "调兵山市"
          },
          {
            "countyCode": "211282000000",
            "countyName": "开原市"
          }
        ]
      },
      {
        "cityName": "朝阳市",
        "cityCode": "211300000000",
        "counties": [
          {
            "countyCode": "211301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "211302000000",
            "countyName": "双塔区"
          },
          {
            "countyCode": "211303000000",
            "countyName": "龙城区"
          },
          {
            "countyCode": "211321000000",
            "countyName": "朝阳县"
          },
          {
            "countyCode": "211322000000",
            "countyName": "建平县"
          },
          {
            "countyCode": "211324000000",
            "countyName": "喀喇沁左翼蒙古族自治县"
          },
          {
            "countyCode": "211381000000",
            "countyName": "北票市"
          },
          {
            "countyCode": "211382000000",
            "countyName": "凌源市"
          }
        ]
      },
      {
        "cityName": "葫芦岛市",
        "cityCode": "211400000000",
        "counties": [
          {
            "countyCode": "211401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "211402000000",
            "countyName": "连山区"
          },
          {
            "countyCode": "211403000000",
            "countyName": "龙港区"
          },
          {
            "countyCode": "211404000000",
            "countyName": "南票区"
          },
          {
            "countyCode": "211421000000",
            "countyName": "绥中县"
          },
          {
            "countyCode": "211422000000",
            "countyName": "建昌县"
          },
          {
            "countyCode": "211481000000",
            "countyName": "兴城市"
          }
        ]
      }
    ],
    "provinceCode": "210000000000",
    "provinceName": "辽宁省"
  },
  {
    "cities": [
      {
        "cityName": "长春市",
        "cityCode": "220100000000",
        "counties": [
          {
            "countyCode": "220101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220102000000",
            "countyName": "南关区"
          },
          {
            "countyCode": "220103000000",
            "countyName": "宽城区"
          },
          {
            "countyCode": "220104000000",
            "countyName": "朝阳区"
          },
          {
            "countyCode": "220105000000",
            "countyName": "二道区"
          },
          {
            "countyCode": "220106000000",
            "countyName": "绿园区"
          },
          {
            "countyCode": "220112000000",
            "countyName": "双阳区"
          },
          {
            "countyCode": "220113000000",
            "countyName": "九台区"
          },
          {
            "countyCode": "220122000000",
            "countyName": "农安县"
          },
          {
            "countyCode": "220171000000",
            "countyName": "长春经济技术开发区"
          },
          {
            "countyCode": "220172000000",
            "countyName": "长春净月高新技术产业开发区"
          },
          {
            "countyCode": "220173000000",
            "countyName": "长春高新技术产业开发区"
          },
          {
            "countyCode": "220174000000",
            "countyName": "长春汽车经济技术开发区"
          },
          {
            "countyCode": "220182000000",
            "countyName": "榆树市"
          },
          {
            "countyCode": "220183000000",
            "countyName": "德惠市"
          }
        ]
      },
      {
        "cityName": "吉林市",
        "cityCode": "220200000000",
        "counties": [
          {
            "countyCode": "220201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220202000000",
            "countyName": "昌邑区"
          },
          {
            "countyCode": "220203000000",
            "countyName": "龙潭区"
          },
          {
            "countyCode": "220204000000",
            "countyName": "船营区"
          },
          {
            "countyCode": "220211000000",
            "countyName": "丰满区"
          },
          {
            "countyCode": "220221000000",
            "countyName": "永吉县"
          },
          {
            "countyCode": "220271000000",
            "countyName": "吉林经济开发区"
          },
          {
            "countyCode": "220272000000",
            "countyName": "吉林高新技术产业开发区"
          },
          {
            "countyCode": "220273000000",
            "countyName": "吉林中国新加坡食品区"
          },
          {
            "countyCode": "220281000000",
            "countyName": "蛟河市"
          },
          {
            "countyCode": "220282000000",
            "countyName": "桦甸市"
          },
          {
            "countyCode": "220283000000",
            "countyName": "舒兰市"
          },
          {
            "countyCode": "220284000000",
            "countyName": "磐石市"
          }
        ]
      },
      {
        "cityName": "四平市",
        "cityCode": "220300000000",
        "counties": [
          {
            "countyCode": "220301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220302000000",
            "countyName": "铁西区"
          },
          {
            "countyCode": "220303000000",
            "countyName": "铁东区"
          },
          {
            "countyCode": "220322000000",
            "countyName": "梨树县"
          },
          {
            "countyCode": "220323000000",
            "countyName": "伊通满族自治县"
          },
          {
            "countyCode": "220381000000",
            "countyName": "公主岭市"
          },
          {
            "countyCode": "220382000000",
            "countyName": "双辽市"
          }
        ]
      },
      {
        "cityName": "辽源市",
        "cityCode": "220400000000",
        "counties": [
          {
            "countyCode": "220401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220402000000",
            "countyName": "龙山区"
          },
          {
            "countyCode": "220403000000",
            "countyName": "西安区"
          },
          {
            "countyCode": "220421000000",
            "countyName": "东丰县"
          },
          {
            "countyCode": "220422000000",
            "countyName": "东辽县"
          }
        ]
      },
      {
        "cityName": "通化市",
        "cityCode": "220500000000",
        "counties": [
          {
            "countyCode": "220501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220502000000",
            "countyName": "东昌区"
          },
          {
            "countyCode": "220503000000",
            "countyName": "二道江区"
          },
          {
            "countyCode": "220521000000",
            "countyName": "通化县"
          },
          {
            "countyCode": "220523000000",
            "countyName": "辉南县"
          },
          {
            "countyCode": "220524000000",
            "countyName": "柳河县"
          },
          {
            "countyCode": "220581000000",
            "countyName": "梅河口市"
          },
          {
            "countyCode": "220582000000",
            "countyName": "集安市"
          }
        ]
      },
      {
        "cityName": "白山市",
        "cityCode": "220600000000",
        "counties": [
          {
            "countyCode": "220601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220602000000",
            "countyName": "浑江区"
          },
          {
            "countyCode": "220605000000",
            "countyName": "江源区"
          },
          {
            "countyCode": "220621000000",
            "countyName": "抚松县"
          },
          {
            "countyCode": "220622000000",
            "countyName": "靖宇县"
          },
          {
            "countyCode": "220623000000",
            "countyName": "长白朝鲜族自治县"
          },
          {
            "countyCode": "220681000000",
            "countyName": "临江市"
          }
        ]
      },
      {
        "cityName": "松原市",
        "cityCode": "220700000000",
        "counties": [
          {
            "countyCode": "220701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220702000000",
            "countyName": "宁江区"
          },
          {
            "countyCode": "220721000000",
            "countyName": "前郭尔罗斯蒙古族自治县"
          },
          {
            "countyCode": "220722000000",
            "countyName": "长岭县"
          },
          {
            "countyCode": "220723000000",
            "countyName": "乾安县"
          },
          {
            "countyCode": "220771000000",
            "countyName": "吉林松原经济开发区"
          },
          {
            "countyCode": "220781000000",
            "countyName": "扶余市"
          }
        ]
      },
      {
        "cityName": "白城市",
        "cityCode": "220800000000",
        "counties": [
          {
            "countyCode": "220801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "220802000000",
            "countyName": "洮北区"
          },
          {
            "countyCode": "220821000000",
            "countyName": "镇赉县"
          },
          {
            "countyCode": "220822000000",
            "countyName": "通榆县"
          },
          {
            "countyCode": "220871000000",
            "countyName": "吉林白城经济开发区"
          },
          {
            "countyCode": "220881000000",
            "countyName": "洮南市"
          },
          {
            "countyCode": "220882000000",
            "countyName": "大安市"
          }
        ]
      },
      {
        "cityName": "延边朝鲜族自治州",
        "cityCode": "222400000000",
        "counties": [
          {
            "countyCode": "222401000000",
            "countyName": "延吉市"
          },
          {
            "countyCode": "222402000000",
            "countyName": "图们市"
          },
          {
            "countyCode": "222403000000",
            "countyName": "敦化市"
          },
          {
            "countyCode": "222404000000",
            "countyName": "珲春市"
          },
          {
            "countyCode": "222405000000",
            "countyName": "龙井市"
          },
          {
            "countyCode": "222406000000",
            "countyName": "和龙市"
          },
          {
            "countyCode": "222424000000",
            "countyName": "汪清县"
          },
          {
            "countyCode": "222426000000",
            "countyName": "安图县"
          }
        ]
      }
    ],
    "provinceCode": "220000000000",
    "provinceName": "吉林省"
  },
  {
    "cities": [
      {
        "cityName": "哈尔滨市",
        "cityCode": "230100000000",
        "counties": [
          {
            "countyCode": "230101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230102000000",
            "countyName": "道里区"
          },
          {
            "countyCode": "230103000000",
            "countyName": "南岗区"
          },
          {
            "countyCode": "230104000000",
            "countyName": "道外区"
          },
          {
            "countyCode": "230108000000",
            "countyName": "平房区"
          },
          {
            "countyCode": "230109000000",
            "countyName": "松北区"
          },
          {
            "countyCode": "230110000000",
            "countyName": "香坊区"
          },
          {
            "countyCode": "230111000000",
            "countyName": "呼兰区"
          },
          {
            "countyCode": "230112000000",
            "countyName": "阿城区"
          },
          {
            "countyCode": "230113000000",
            "countyName": "双城区"
          },
          {
            "countyCode": "230123000000",
            "countyName": "依兰县"
          },
          {
            "countyCode": "230124000000",
            "countyName": "方正县"
          },
          {
            "countyCode": "230125000000",
            "countyName": "宾县"
          },
          {
            "countyCode": "230126000000",
            "countyName": "巴彦县"
          },
          {
            "countyCode": "230127000000",
            "countyName": "木兰县"
          },
          {
            "countyCode": "230128000000",
            "countyName": "通河县"
          },
          {
            "countyCode": "230129000000",
            "countyName": "延寿县"
          },
          {
            "countyCode": "230183000000",
            "countyName": "尚志市"
          },
          {
            "countyCode": "230184000000",
            "countyName": "五常市"
          }
        ]
      },
      {
        "cityName": "齐齐哈尔市",
        "cityCode": "230200000000",
        "counties": [
          {
            "countyCode": "230201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230202000000",
            "countyName": "龙沙区"
          },
          {
            "countyCode": "230203000000",
            "countyName": "建华区"
          },
          {
            "countyCode": "230204000000",
            "countyName": "铁锋区"
          },
          {
            "countyCode": "230205000000",
            "countyName": "昂昂溪区"
          },
          {
            "countyCode": "230206000000",
            "countyName": "富拉尔基区"
          },
          {
            "countyCode": "230207000000",
            "countyName": "碾子山区"
          },
          {
            "countyCode": "230208000000",
            "countyName": "梅里斯达斡尔族区"
          },
          {
            "countyCode": "230221000000",
            "countyName": "龙江县"
          },
          {
            "countyCode": "230223000000",
            "countyName": "依安县"
          },
          {
            "countyCode": "230224000000",
            "countyName": "泰来县"
          },
          {
            "countyCode": "230225000000",
            "countyName": "甘南县"
          },
          {
            "countyCode": "230227000000",
            "countyName": "富裕县"
          },
          {
            "countyCode": "230229000000",
            "countyName": "克山县"
          },
          {
            "countyCode": "230230000000",
            "countyName": "克东县"
          },
          {
            "countyCode": "230231000000",
            "countyName": "拜泉县"
          },
          {
            "countyCode": "230281000000",
            "countyName": "讷河市"
          }
        ]
      },
      {
        "cityName": "鸡西市",
        "cityCode": "230300000000",
        "counties": [
          {
            "countyCode": "230301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230302000000",
            "countyName": "鸡冠区"
          },
          {
            "countyCode": "230303000000",
            "countyName": "恒山区"
          },
          {
            "countyCode": "230304000000",
            "countyName": "滴道区"
          },
          {
            "countyCode": "230305000000",
            "countyName": "梨树区"
          },
          {
            "countyCode": "230306000000",
            "countyName": "城子河区"
          },
          {
            "countyCode": "230307000000",
            "countyName": "麻山区"
          },
          {
            "countyCode": "230321000000",
            "countyName": "鸡东县"
          },
          {
            "countyCode": "230381000000",
            "countyName": "虎林市"
          },
          {
            "countyCode": "230382000000",
            "countyName": "密山市"
          }
        ]
      },
      {
        "cityName": "鹤岗市",
        "cityCode": "230400000000",
        "counties": [
          {
            "countyCode": "230401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230402000000",
            "countyName": "向阳区"
          },
          {
            "countyCode": "230403000000",
            "countyName": "工农区"
          },
          {
            "countyCode": "230404000000",
            "countyName": "南山区"
          },
          {
            "countyCode": "230405000000",
            "countyName": "兴安区"
          },
          {
            "countyCode": "230406000000",
            "countyName": "东山区"
          },
          {
            "countyCode": "230407000000",
            "countyName": "兴山区"
          },
          {
            "countyCode": "230421000000",
            "countyName": "萝北县"
          },
          {
            "countyCode": "230422000000",
            "countyName": "绥滨县"
          }
        ]
      },
      {
        "cityName": "双鸭山市",
        "cityCode": "230500000000",
        "counties": [
          {
            "countyCode": "230501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230502000000",
            "countyName": "尖山区"
          },
          {
            "countyCode": "230503000000",
            "countyName": "岭东区"
          },
          {
            "countyCode": "230505000000",
            "countyName": "四方台区"
          },
          {
            "countyCode": "230506000000",
            "countyName": "宝山区"
          },
          {
            "countyCode": "230521000000",
            "countyName": "集贤县"
          },
          {
            "countyCode": "230522000000",
            "countyName": "友谊县"
          },
          {
            "countyCode": "230523000000",
            "countyName": "宝清县"
          },
          {
            "countyCode": "230524000000",
            "countyName": "饶河县"
          }
        ]
      },
      {
        "cityName": "大庆市",
        "cityCode": "230600000000",
        "counties": [
          {
            "countyCode": "230601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230602000000",
            "countyName": "萨尔图区"
          },
          {
            "countyCode": "230603000000",
            "countyName": "龙凤区"
          },
          {
            "countyCode": "230604000000",
            "countyName": "让胡路区"
          },
          {
            "countyCode": "230605000000",
            "countyName": "红岗区"
          },
          {
            "countyCode": "230606000000",
            "countyName": "大同区"
          },
          {
            "countyCode": "230621000000",
            "countyName": "肇州县"
          },
          {
            "countyCode": "230622000000",
            "countyName": "肇源县"
          },
          {
            "countyCode": "230623000000",
            "countyName": "林甸县"
          },
          {
            "countyCode": "230624000000",
            "countyName": "杜尔伯特蒙古族自治县"
          },
          {
            "countyCode": "230671000000",
            "countyName": "大庆高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "伊春市",
        "cityCode": "230700000000",
        "counties": [
          {
            "countyCode": "230701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230702000000",
            "countyName": "伊春区"
          },
          {
            "countyCode": "230703000000",
            "countyName": "南岔区"
          },
          {
            "countyCode": "230704000000",
            "countyName": "友好区"
          },
          {
            "countyCode": "230705000000",
            "countyName": "西林区"
          },
          {
            "countyCode": "230706000000",
            "countyName": "翠峦区"
          },
          {
            "countyCode": "230707000000",
            "countyName": "新青区"
          },
          {
            "countyCode": "230708000000",
            "countyName": "美溪区"
          },
          {
            "countyCode": "230709000000",
            "countyName": "金山屯区"
          },
          {
            "countyCode": "230710000000",
            "countyName": "五营区"
          },
          {
            "countyCode": "230711000000",
            "countyName": "乌马河区"
          },
          {
            "countyCode": "230712000000",
            "countyName": "汤旺河区"
          },
          {
            "countyCode": "230713000000",
            "countyName": "带岭区"
          },
          {
            "countyCode": "230714000000",
            "countyName": "乌伊岭区"
          },
          {
            "countyCode": "230715000000",
            "countyName": "红星区"
          },
          {
            "countyCode": "230716000000",
            "countyName": "上甘岭区"
          },
          {
            "countyCode": "230722000000",
            "countyName": "嘉荫县"
          },
          {
            "countyCode": "230781000000",
            "countyName": "铁力市"
          }
        ]
      },
      {
        "cityName": "佳木斯市",
        "cityCode": "230800000000",
        "counties": [
          {
            "countyCode": "230801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230803000000",
            "countyName": "向阳区"
          },
          {
            "countyCode": "230804000000",
            "countyName": "前进区"
          },
          {
            "countyCode": "230805000000",
            "countyName": "东风区"
          },
          {
            "countyCode": "230811000000",
            "countyName": "郊区"
          },
          {
            "countyCode": "230822000000",
            "countyName": "桦南县"
          },
          {
            "countyCode": "230826000000",
            "countyName": "桦川县"
          },
          {
            "countyCode": "230828000000",
            "countyName": "汤原县"
          },
          {
            "countyCode": "230881000000",
            "countyName": "同江市"
          },
          {
            "countyCode": "230882000000",
            "countyName": "富锦市"
          },
          {
            "countyCode": "230883000000",
            "countyName": "抚远市"
          }
        ]
      },
      {
        "cityName": "七台河市",
        "cityCode": "230900000000",
        "counties": [
          {
            "countyCode": "230901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "230902000000",
            "countyName": "新兴区"
          },
          {
            "countyCode": "230903000000",
            "countyName": "桃山区"
          },
          {
            "countyCode": "230904000000",
            "countyName": "茄子河区"
          },
          {
            "countyCode": "230921000000",
            "countyName": "勃利县"
          }
        ]
      },
      {
        "cityName": "牡丹江市",
        "cityCode": "231000000000",
        "counties": [
          {
            "countyCode": "231001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "231002000000",
            "countyName": "东安区"
          },
          {
            "countyCode": "231003000000",
            "countyName": "阳明区"
          },
          {
            "countyCode": "231004000000",
            "countyName": "爱民区"
          },
          {
            "countyCode": "231005000000",
            "countyName": "西安区"
          },
          {
            "countyCode": "231025000000",
            "countyName": "林口县"
          },
          {
            "countyCode": "231071000000",
            "countyName": "牡丹江经济技术开发区"
          },
          {
            "countyCode": "231081000000",
            "countyName": "绥芬河市"
          },
          {
            "countyCode": "231083000000",
            "countyName": "海林市"
          },
          {
            "countyCode": "231084000000",
            "countyName": "宁安市"
          },
          {
            "countyCode": "231085000000",
            "countyName": "穆棱市"
          },
          {
            "countyCode": "231086000000",
            "countyName": "东宁市"
          }
        ]
      },
      {
        "cityName": "黑河市",
        "cityCode": "231100000000",
        "counties": [
          {
            "countyCode": "231101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "231102000000",
            "countyName": "爱辉区"
          },
          {
            "countyCode": "231121000000",
            "countyName": "嫩江县"
          },
          {
            "countyCode": "231123000000",
            "countyName": "逊克县"
          },
          {
            "countyCode": "231124000000",
            "countyName": "孙吴县"
          },
          {
            "countyCode": "231181000000",
            "countyName": "北安市"
          },
          {
            "countyCode": "231182000000",
            "countyName": "五大连池市"
          }
        ]
      },
      {
        "cityName": "绥化市",
        "cityCode": "231200000000",
        "counties": [
          {
            "countyCode": "231201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "231202000000",
            "countyName": "北林区"
          },
          {
            "countyCode": "231221000000",
            "countyName": "望奎县"
          },
          {
            "countyCode": "231222000000",
            "countyName": "兰西县"
          },
          {
            "countyCode": "231223000000",
            "countyName": "青冈县"
          },
          {
            "countyCode": "231224000000",
            "countyName": "庆安县"
          },
          {
            "countyCode": "231225000000",
            "countyName": "明水县"
          },
          {
            "countyCode": "231226000000",
            "countyName": "绥棱县"
          },
          {
            "countyCode": "231281000000",
            "countyName": "安达市"
          },
          {
            "countyCode": "231282000000",
            "countyName": "肇东市"
          },
          {
            "countyCode": "231283000000",
            "countyName": "海伦市"
          }
        ]
      },
      {
        "cityName": "大兴安岭地区",
        "cityCode": "232700000000",
        "counties": [
          {
            "countyCode": "232701000000",
            "countyName": "漠河市"
          },
          {
            "countyCode": "232721000000",
            "countyName": "呼玛县"
          },
          {
            "countyCode": "232722000000",
            "countyName": "塔河县"
          },
          {
            "countyCode": "232761000000",
            "countyName": "加格达奇区"
          },
          {
            "countyCode": "232762000000",
            "countyName": "松岭区"
          },
          {
            "countyCode": "232763000000",
            "countyName": "新林区"
          },
          {
            "countyCode": "232764000000",
            "countyName": "呼中区"
          }
        ]
      }
    ],
    "provinceCode": "230000000000",
    "provinceName": "黑龙江省"
  },
  {
    "cities": [
      {
        "cityName": "市辖区",
        "cityCode": "310100000000",
        "counties": [
          {
            "countyCode": "310101000000",
            "countyName": "黄浦区"
          },
          {
            "countyCode": "310104000000",
            "countyName": "徐汇区"
          },
          {
            "countyCode": "310105000000",
            "countyName": "长宁区"
          },
          {
            "countyCode": "310106000000",
            "countyName": "静安区"
          },
          {
            "countyCode": "310107000000",
            "countyName": "普陀区"
          },
          {
            "countyCode": "310109000000",
            "countyName": "虹口区"
          },
          {
            "countyCode": "310110000000",
            "countyName": "杨浦区"
          },
          {
            "countyCode": "310112000000",
            "countyName": "闵行区"
          },
          {
            "countyCode": "310113000000",
            "countyName": "宝山区"
          },
          {
            "countyCode": "310114000000",
            "countyName": "嘉定区"
          },
          {
            "countyCode": "310115000000",
            "countyName": "浦东新区"
          },
          {
            "countyCode": "310116000000",
            "countyName": "金山区"
          },
          {
            "countyCode": "310117000000",
            "countyName": "松江区"
          },
          {
            "countyCode": "310118000000",
            "countyName": "青浦区"
          },
          {
            "countyCode": "310120000000",
            "countyName": "奉贤区"
          },
          {
            "countyCode": "310151000000",
            "countyName": "崇明区"
          }
        ]
      }
    ],
    "provinceCode": "310000000000",
    "provinceName": "上海市"
  },
  {
    "cities": [
      {
        "cityName": "南京市",
        "cityCode": "320100000000",
        "counties": [
          {
            "countyCode": "320101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320102000000",
            "countyName": "玄武区"
          },
          {
            "countyCode": "320104000000",
            "countyName": "秦淮区"
          },
          {
            "countyCode": "320105000000",
            "countyName": "建邺区"
          },
          {
            "countyCode": "320106000000",
            "countyName": "鼓楼区"
          },
          {
            "countyCode": "320111000000",
            "countyName": "浦口区"
          },
          {
            "countyCode": "320113000000",
            "countyName": "栖霞区"
          },
          {
            "countyCode": "320114000000",
            "countyName": "雨花台区"
          },
          {
            "countyCode": "320115000000",
            "countyName": "江宁区"
          },
          {
            "countyCode": "320116000000",
            "countyName": "六合区"
          },
          {
            "countyCode": "320117000000",
            "countyName": "溧水区"
          },
          {
            "countyCode": "320118000000",
            "countyName": "高淳区"
          }
        ]
      },
      {
        "cityName": "无锡市",
        "cityCode": "320200000000",
        "counties": [
          {
            "countyCode": "320201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320205000000",
            "countyName": "锡山区"
          },
          {
            "countyCode": "320206000000",
            "countyName": "惠山区"
          },
          {
            "countyCode": "320211000000",
            "countyName": "滨湖区"
          },
          {
            "countyCode": "320213000000",
            "countyName": "梁溪区"
          },
          {
            "countyCode": "320214000000",
            "countyName": "新吴区"
          },
          {
            "countyCode": "320281000000",
            "countyName": "江阴市"
          },
          {
            "countyCode": "320282000000",
            "countyName": "宜兴市"
          }
        ]
      },
      {
        "cityName": "徐州市",
        "cityCode": "320300000000",
        "counties": [
          {
            "countyCode": "320301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320302000000",
            "countyName": "鼓楼区"
          },
          {
            "countyCode": "320303000000",
            "countyName": "云龙区"
          },
          {
            "countyCode": "320305000000",
            "countyName": "贾汪区"
          },
          {
            "countyCode": "320311000000",
            "countyName": "泉山区"
          },
          {
            "countyCode": "320312000000",
            "countyName": "铜山区"
          },
          {
            "countyCode": "320321000000",
            "countyName": "丰县"
          },
          {
            "countyCode": "320322000000",
            "countyName": "沛县"
          },
          {
            "countyCode": "320324000000",
            "countyName": "睢宁县"
          },
          {
            "countyCode": "320371000000",
            "countyName": "徐州经济技术开发区"
          },
          {
            "countyCode": "320381000000",
            "countyName": "新沂市"
          },
          {
            "countyCode": "320382000000",
            "countyName": "邳州市"
          }
        ]
      },
      {
        "cityName": "常州市",
        "cityCode": "320400000000",
        "counties": [
          {
            "countyCode": "320401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320402000000",
            "countyName": "天宁区"
          },
          {
            "countyCode": "320404000000",
            "countyName": "钟楼区"
          },
          {
            "countyCode": "320411000000",
            "countyName": "新北区"
          },
          {
            "countyCode": "320412000000",
            "countyName": "武进区"
          },
          {
            "countyCode": "320413000000",
            "countyName": "金坛区"
          },
          {
            "countyCode": "320481000000",
            "countyName": "溧阳市"
          }
        ]
      },
      {
        "cityName": "苏州市",
        "cityCode": "320500000000",
        "counties": [
          {
            "countyCode": "320501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320505000000",
            "countyName": "虎丘区"
          },
          {
            "countyCode": "320506000000",
            "countyName": "吴中区"
          },
          {
            "countyCode": "320507000000",
            "countyName": "相城区"
          },
          {
            "countyCode": "320508000000",
            "countyName": "姑苏区"
          },
          {
            "countyCode": "320509000000",
            "countyName": "吴江区"
          },
          {
            "countyCode": "320571000000",
            "countyName": "苏州工业园区"
          },
          {
            "countyCode": "320581000000",
            "countyName": "常熟市"
          },
          {
            "countyCode": "320582000000",
            "countyName": "张家港市"
          },
          {
            "countyCode": "320583000000",
            "countyName": "昆山市"
          },
          {
            "countyCode": "320585000000",
            "countyName": "太仓市"
          }
        ]
      },
      {
        "cityName": "南通市",
        "cityCode": "320600000000",
        "counties": [
          {
            "countyCode": "320601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320602000000",
            "countyName": "崇川区"
          },
          {
            "countyCode": "320611000000",
            "countyName": "港闸区"
          },
          {
            "countyCode": "320612000000",
            "countyName": "通州区"
          },
          {
            "countyCode": "320623000000",
            "countyName": "如东县"
          },
          {
            "countyCode": "320671000000",
            "countyName": "南通经济技术开发区"
          },
          {
            "countyCode": "320681000000",
            "countyName": "启东市"
          },
          {
            "countyCode": "320682000000",
            "countyName": "如皋市"
          },
          {
            "countyCode": "320684000000",
            "countyName": "海门市"
          },
          {
            "countyCode": "320685000000",
            "countyName": "海安市"
          }
        ]
      },
      {
        "cityName": "连云港市",
        "cityCode": "320700000000",
        "counties": [
          {
            "countyCode": "320701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320703000000",
            "countyName": "连云区"
          },
          {
            "countyCode": "320706000000",
            "countyName": "海州区"
          },
          {
            "countyCode": "320707000000",
            "countyName": "赣榆区"
          },
          {
            "countyCode": "320722000000",
            "countyName": "东海县"
          },
          {
            "countyCode": "320723000000",
            "countyName": "灌云县"
          },
          {
            "countyCode": "320724000000",
            "countyName": "灌南县"
          },
          {
            "countyCode": "320771000000",
            "countyName": "连云港经济技术开发区"
          },
          {
            "countyCode": "320772000000",
            "countyName": "连云港高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "淮安市",
        "cityCode": "320800000000",
        "counties": [
          {
            "countyCode": "320801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320803000000",
            "countyName": "淮安区"
          },
          {
            "countyCode": "320804000000",
            "countyName": "淮阴区"
          },
          {
            "countyCode": "320812000000",
            "countyName": "清江浦区"
          },
          {
            "countyCode": "320813000000",
            "countyName": "洪泽区"
          },
          {
            "countyCode": "320826000000",
            "countyName": "涟水县"
          },
          {
            "countyCode": "320830000000",
            "countyName": "盱眙县"
          },
          {
            "countyCode": "320831000000",
            "countyName": "金湖县"
          },
          {
            "countyCode": "320871000000",
            "countyName": "淮安经济技术开发区"
          }
        ]
      },
      {
        "cityName": "盐城市",
        "cityCode": "320900000000",
        "counties": [
          {
            "countyCode": "320901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "320902000000",
            "countyName": "亭湖区"
          },
          {
            "countyCode": "320903000000",
            "countyName": "盐都区"
          },
          {
            "countyCode": "320904000000",
            "countyName": "大丰区"
          },
          {
            "countyCode": "320921000000",
            "countyName": "响水县"
          },
          {
            "countyCode": "320922000000",
            "countyName": "滨海县"
          },
          {
            "countyCode": "320923000000",
            "countyName": "阜宁县"
          },
          {
            "countyCode": "320924000000",
            "countyName": "射阳县"
          },
          {
            "countyCode": "320925000000",
            "countyName": "建湖县"
          },
          {
            "countyCode": "320971000000",
            "countyName": "盐城经济技术开发区"
          },
          {
            "countyCode": "320981000000",
            "countyName": "东台市"
          }
        ]
      },
      {
        "cityName": "扬州市",
        "cityCode": "321000000000",
        "counties": [
          {
            "countyCode": "321001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "321002000000",
            "countyName": "广陵区"
          },
          {
            "countyCode": "321003000000",
            "countyName": "邗江区"
          },
          {
            "countyCode": "321012000000",
            "countyName": "江都区"
          },
          {
            "countyCode": "321023000000",
            "countyName": "宝应县"
          },
          {
            "countyCode": "321071000000",
            "countyName": "扬州经济技术开发区"
          },
          {
            "countyCode": "321081000000",
            "countyName": "仪征市"
          },
          {
            "countyCode": "321084000000",
            "countyName": "高邮市"
          }
        ]
      },
      {
        "cityName": "镇江市",
        "cityCode": "321100000000",
        "counties": [
          {
            "countyCode": "321101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "321102000000",
            "countyName": "京口区"
          },
          {
            "countyCode": "321111000000",
            "countyName": "润州区"
          },
          {
            "countyCode": "321112000000",
            "countyName": "丹徒区"
          },
          {
            "countyCode": "321171000000",
            "countyName": "镇江新区"
          },
          {
            "countyCode": "321181000000",
            "countyName": "丹阳市"
          },
          {
            "countyCode": "321182000000",
            "countyName": "扬中市"
          },
          {
            "countyCode": "321183000000",
            "countyName": "句容市"
          }
        ]
      },
      {
        "cityName": "泰州市",
        "cityCode": "321200000000",
        "counties": [
          {
            "countyCode": "321201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "321202000000",
            "countyName": "海陵区"
          },
          {
            "countyCode": "321203000000",
            "countyName": "高港区"
          },
          {
            "countyCode": "321204000000",
            "countyName": "姜堰区"
          },
          {
            "countyCode": "321271000000",
            "countyName": "泰州医药高新技术产业开发区"
          },
          {
            "countyCode": "321281000000",
            "countyName": "兴化市"
          },
          {
            "countyCode": "321282000000",
            "countyName": "靖江市"
          },
          {
            "countyCode": "321283000000",
            "countyName": "泰兴市"
          }
        ]
      },
      {
        "cityName": "宿迁市",
        "cityCode": "321300000000",
        "counties": [
          {
            "countyCode": "321301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "321302000000",
            "countyName": "宿城区"
          },
          {
            "countyCode": "321311000000",
            "countyName": "宿豫区"
          },
          {
            "countyCode": "321322000000",
            "countyName": "沭阳县"
          },
          {
            "countyCode": "321323000000",
            "countyName": "泗阳县"
          },
          {
            "countyCode": "321324000000",
            "countyName": "泗洪县"
          },
          {
            "countyCode": "321371000000",
            "countyName": "宿迁经济技术开发区"
          }
        ]
      }
    ],
    "provinceCode": "320000000000",
    "provinceName": "江苏省"
  },
  {
    "cities": [
      {
        "cityName": "杭州市",
        "cityCode": "330100000000",
        "counties": [
          {
            "countyCode": "330101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330102000000",
            "countyName": "上城区"
          },
          {
            "countyCode": "330103000000",
            "countyName": "下城区"
          },
          {
            "countyCode": "330104000000",
            "countyName": "江干区"
          },
          {
            "countyCode": "330105000000",
            "countyName": "拱墅区"
          },
          {
            "countyCode": "330106000000",
            "countyName": "西湖区"
          },
          {
            "countyCode": "330108000000",
            "countyName": "滨江区"
          },
          {
            "countyCode": "330109000000",
            "countyName": "萧山区"
          },
          {
            "countyCode": "330110000000",
            "countyName": "余杭区"
          },
          {
            "countyCode": "330111000000",
            "countyName": "富阳区"
          },
          {
            "countyCode": "330112000000",
            "countyName": "临安区"
          },
          {
            "countyCode": "330122000000",
            "countyName": "桐庐县"
          },
          {
            "countyCode": "330127000000",
            "countyName": "淳安县"
          },
          {
            "countyCode": "330182000000",
            "countyName": "建德市"
          }
        ]
      },
      {
        "cityName": "宁波市",
        "cityCode": "330200000000",
        "counties": [
          {
            "countyCode": "330201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330203000000",
            "countyName": "海曙区"
          },
          {
            "countyCode": "330205000000",
            "countyName": "江北区"
          },
          {
            "countyCode": "330206000000",
            "countyName": "北仑区"
          },
          {
            "countyCode": "330211000000",
            "countyName": "镇海区"
          },
          {
            "countyCode": "330212000000",
            "countyName": "鄞州区"
          },
          {
            "countyCode": "330213000000",
            "countyName": "奉化区"
          },
          {
            "countyCode": "330225000000",
            "countyName": "象山县"
          },
          {
            "countyCode": "330226000000",
            "countyName": "宁海县"
          },
          {
            "countyCode": "330281000000",
            "countyName": "余姚市"
          },
          {
            "countyCode": "330282000000",
            "countyName": "慈溪市"
          }
        ]
      },
      {
        "cityName": "温州市",
        "cityCode": "330300000000",
        "counties": [
          {
            "countyCode": "330301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330302000000",
            "countyName": "鹿城区"
          },
          {
            "countyCode": "330303000000",
            "countyName": "龙湾区"
          },
          {
            "countyCode": "330304000000",
            "countyName": "瓯海区"
          },
          {
            "countyCode": "330305000000",
            "countyName": "洞头区"
          },
          {
            "countyCode": "330324000000",
            "countyName": "永嘉县"
          },
          {
            "countyCode": "330326000000",
            "countyName": "平阳县"
          },
          {
            "countyCode": "330327000000",
            "countyName": "苍南县"
          },
          {
            "countyCode": "330328000000",
            "countyName": "文成县"
          },
          {
            "countyCode": "330329000000",
            "countyName": "泰顺县"
          },
          {
            "countyCode": "330371000000",
            "countyName": "温州经济技术开发区"
          },
          {
            "countyCode": "330381000000",
            "countyName": "瑞安市"
          },
          {
            "countyCode": "330382000000",
            "countyName": "乐清市"
          }
        ]
      },
      {
        "cityName": "嘉兴市",
        "cityCode": "330400000000",
        "counties": [
          {
            "countyCode": "330401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330402000000",
            "countyName": "南湖区"
          },
          {
            "countyCode": "330411000000",
            "countyName": "秀洲区"
          },
          {
            "countyCode": "330421000000",
            "countyName": "嘉善县"
          },
          {
            "countyCode": "330424000000",
            "countyName": "海盐县"
          },
          {
            "countyCode": "330481000000",
            "countyName": "海宁市"
          },
          {
            "countyCode": "330482000000",
            "countyName": "平湖市"
          },
          {
            "countyCode": "330483000000",
            "countyName": "桐乡市"
          }
        ]
      },
      {
        "cityName": "湖州市",
        "cityCode": "330500000000",
        "counties": [
          {
            "countyCode": "330501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330502000000",
            "countyName": "吴兴区"
          },
          {
            "countyCode": "330503000000",
            "countyName": "南浔区"
          },
          {
            "countyCode": "330521000000",
            "countyName": "德清县"
          },
          {
            "countyCode": "330522000000",
            "countyName": "长兴县"
          },
          {
            "countyCode": "330523000000",
            "countyName": "安吉县"
          }
        ]
      },
      {
        "cityName": "绍兴市",
        "cityCode": "330600000000",
        "counties": [
          {
            "countyCode": "330601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330602000000",
            "countyName": "越城区"
          },
          {
            "countyCode": "330603000000",
            "countyName": "柯桥区"
          },
          {
            "countyCode": "330604000000",
            "countyName": "上虞区"
          },
          {
            "countyCode": "330624000000",
            "countyName": "新昌县"
          },
          {
            "countyCode": "330681000000",
            "countyName": "诸暨市"
          },
          {
            "countyCode": "330683000000",
            "countyName": "嵊州市"
          }
        ]
      },
      {
        "cityName": "金华市",
        "cityCode": "330700000000",
        "counties": [
          {
            "countyCode": "330701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330702000000",
            "countyName": "婺城区"
          },
          {
            "countyCode": "330703000000",
            "countyName": "金东区"
          },
          {
            "countyCode": "330723000000",
            "countyName": "武义县"
          },
          {
            "countyCode": "330726000000",
            "countyName": "浦江县"
          },
          {
            "countyCode": "330727000000",
            "countyName": "磐安县"
          },
          {
            "countyCode": "330781000000",
            "countyName": "兰溪市"
          },
          {
            "countyCode": "330782000000",
            "countyName": "义乌市"
          },
          {
            "countyCode": "330783000000",
            "countyName": "东阳市"
          },
          {
            "countyCode": "330784000000",
            "countyName": "永康市"
          }
        ]
      },
      {
        "cityName": "衢州市",
        "cityCode": "330800000000",
        "counties": [
          {
            "countyCode": "330801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330802000000",
            "countyName": "柯城区"
          },
          {
            "countyCode": "330803000000",
            "countyName": "衢江区"
          },
          {
            "countyCode": "330822000000",
            "countyName": "常山县"
          },
          {
            "countyCode": "330824000000",
            "countyName": "开化县"
          },
          {
            "countyCode": "330825000000",
            "countyName": "龙游县"
          },
          {
            "countyCode": "330881000000",
            "countyName": "江山市"
          }
        ]
      },
      {
        "cityName": "舟山市",
        "cityCode": "330900000000",
        "counties": [
          {
            "countyCode": "330901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "330902000000",
            "countyName": "定海区"
          },
          {
            "countyCode": "330903000000",
            "countyName": "普陀区"
          },
          {
            "countyCode": "330921000000",
            "countyName": "岱山县"
          },
          {
            "countyCode": "330922000000",
            "countyName": "嵊泗县"
          }
        ]
      },
      {
        "cityName": "台州市",
        "cityCode": "331000000000",
        "counties": [
          {
            "countyCode": "331001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "331002000000",
            "countyName": "椒江区"
          },
          {
            "countyCode": "331003000000",
            "countyName": "黄岩区"
          },
          {
            "countyCode": "331004000000",
            "countyName": "路桥区"
          },
          {
            "countyCode": "331022000000",
            "countyName": "三门县"
          },
          {
            "countyCode": "331023000000",
            "countyName": "天台县"
          },
          {
            "countyCode": "331024000000",
            "countyName": "仙居县"
          },
          {
            "countyCode": "331081000000",
            "countyName": "温岭市"
          },
          {
            "countyCode": "331082000000",
            "countyName": "临海市"
          },
          {
            "countyCode": "331083000000",
            "countyName": "玉环市"
          }
        ]
      },
      {
        "cityName": "丽水市",
        "cityCode": "331100000000",
        "counties": [
          {
            "countyCode": "331101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "331102000000",
            "countyName": "莲都区"
          },
          {
            "countyCode": "331121000000",
            "countyName": "青田县"
          },
          {
            "countyCode": "331122000000",
            "countyName": "缙云县"
          },
          {
            "countyCode": "331123000000",
            "countyName": "遂昌县"
          },
          {
            "countyCode": "331124000000",
            "countyName": "松阳县"
          },
          {
            "countyCode": "331125000000",
            "countyName": "云和县"
          },
          {
            "countyCode": "331126000000",
            "countyName": "庆元县"
          },
          {
            "countyCode": "331127000000",
            "countyName": "景宁畲族自治县"
          },
          {
            "countyCode": "331181000000",
            "countyName": "龙泉市"
          }
        ]
      }
    ],
    "provinceCode": "330000000000",
    "provinceName": "浙江省"
  },
  {
    "cities": [
      {
        "cityName": "合肥市",
        "cityCode": "340100000000",
        "counties": [
          {
            "countyCode": "340101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340102000000",
            "countyName": "瑶海区"
          },
          {
            "countyCode": "340103000000",
            "countyName": "庐阳区"
          },
          {
            "countyCode": "340104000000",
            "countyName": "蜀山区"
          },
          {
            "countyCode": "340111000000",
            "countyName": "包河区"
          },
          {
            "countyCode": "340121000000",
            "countyName": "长丰县"
          },
          {
            "countyCode": "340122000000",
            "countyName": "肥东县"
          },
          {
            "countyCode": "340123000000",
            "countyName": "肥西县"
          },
          {
            "countyCode": "340124000000",
            "countyName": "庐江县"
          },
          {
            "countyCode": "340171000000",
            "countyName": "合肥高新技术产业开发区"
          },
          {
            "countyCode": "340172000000",
            "countyName": "合肥经济技术开发区"
          },
          {
            "countyCode": "340173000000",
            "countyName": "合肥新站高新技术产业开发区"
          },
          {
            "countyCode": "340181000000",
            "countyName": "巢湖市"
          }
        ]
      },
      {
        "cityName": "芜湖市",
        "cityCode": "340200000000",
        "counties": [
          {
            "countyCode": "340201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340202000000",
            "countyName": "镜湖区"
          },
          {
            "countyCode": "340203000000",
            "countyName": "弋江区"
          },
          {
            "countyCode": "340207000000",
            "countyName": "鸠江区"
          },
          {
            "countyCode": "340208000000",
            "countyName": "三山区"
          },
          {
            "countyCode": "340221000000",
            "countyName": "芜湖县"
          },
          {
            "countyCode": "340222000000",
            "countyName": "繁昌县"
          },
          {
            "countyCode": "340223000000",
            "countyName": "南陵县"
          },
          {
            "countyCode": "340225000000",
            "countyName": "无为县"
          },
          {
            "countyCode": "340271000000",
            "countyName": "芜湖经济技术开发区"
          },
          {
            "countyCode": "340272000000",
            "countyName": "安徽芜湖长江大桥经济开发区"
          }
        ]
      },
      {
        "cityName": "蚌埠市",
        "cityCode": "340300000000",
        "counties": [
          {
            "countyCode": "340301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340302000000",
            "countyName": "龙子湖区"
          },
          {
            "countyCode": "340303000000",
            "countyName": "蚌山区"
          },
          {
            "countyCode": "340304000000",
            "countyName": "禹会区"
          },
          {
            "countyCode": "340311000000",
            "countyName": "淮上区"
          },
          {
            "countyCode": "340321000000",
            "countyName": "怀远县"
          },
          {
            "countyCode": "340322000000",
            "countyName": "五河县"
          },
          {
            "countyCode": "340323000000",
            "countyName": "固镇县"
          },
          {
            "countyCode": "340371000000",
            "countyName": "蚌埠市高新技术开发区"
          },
          {
            "countyCode": "340372000000",
            "countyName": "蚌埠市经济开发区"
          }
        ]
      },
      {
        "cityName": "淮南市",
        "cityCode": "340400000000",
        "counties": [
          {
            "countyCode": "340401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340402000000",
            "countyName": "大通区"
          },
          {
            "countyCode": "340403000000",
            "countyName": "田家庵区"
          },
          {
            "countyCode": "340404000000",
            "countyName": "谢家集区"
          },
          {
            "countyCode": "340405000000",
            "countyName": "八公山区"
          },
          {
            "countyCode": "340406000000",
            "countyName": "潘集区"
          },
          {
            "countyCode": "340421000000",
            "countyName": "凤台县"
          },
          {
            "countyCode": "340422000000",
            "countyName": "寿县"
          }
        ]
      },
      {
        "cityName": "马鞍山市",
        "cityCode": "340500000000",
        "counties": [
          {
            "countyCode": "340501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340503000000",
            "countyName": "花山区"
          },
          {
            "countyCode": "340504000000",
            "countyName": "雨山区"
          },
          {
            "countyCode": "340506000000",
            "countyName": "博望区"
          },
          {
            "countyCode": "340521000000",
            "countyName": "当涂县"
          },
          {
            "countyCode": "340522000000",
            "countyName": "含山县"
          },
          {
            "countyCode": "340523000000",
            "countyName": "和县"
          }
        ]
      },
      {
        "cityName": "淮北市",
        "cityCode": "340600000000",
        "counties": [
          {
            "countyCode": "340601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340602000000",
            "countyName": "杜集区"
          },
          {
            "countyCode": "340603000000",
            "countyName": "相山区"
          },
          {
            "countyCode": "340604000000",
            "countyName": "烈山区"
          },
          {
            "countyCode": "340621000000",
            "countyName": "濉溪县"
          }
        ]
      },
      {
        "cityName": "铜陵市",
        "cityCode": "340700000000",
        "counties": [
          {
            "countyCode": "340701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340705000000",
            "countyName": "铜官区"
          },
          {
            "countyCode": "340706000000",
            "countyName": "义安区"
          },
          {
            "countyCode": "340711000000",
            "countyName": "郊区"
          },
          {
            "countyCode": "340722000000",
            "countyName": "枞阳县"
          }
        ]
      },
      {
        "cityName": "安庆市",
        "cityCode": "340800000000",
        "counties": [
          {
            "countyCode": "340801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "340802000000",
            "countyName": "迎江区"
          },
          {
            "countyCode": "340803000000",
            "countyName": "大观区"
          },
          {
            "countyCode": "340811000000",
            "countyName": "宜秀区"
          },
          {
            "countyCode": "340822000000",
            "countyName": "怀宁县"
          },
          {
            "countyCode": "340825000000",
            "countyName": "太湖县"
          },
          {
            "countyCode": "340826000000",
            "countyName": "宿松县"
          },
          {
            "countyCode": "340827000000",
            "countyName": "望江县"
          },
          {
            "countyCode": "340828000000",
            "countyName": "岳西县"
          },
          {
            "countyCode": "340871000000",
            "countyName": "安徽安庆经济开发区"
          },
          {
            "countyCode": "340881000000",
            "countyName": "桐城市"
          },
          {
            "countyCode": "340882000000",
            "countyName": "潜山市"
          }
        ]
      },
      {
        "cityName": "黄山市",
        "cityCode": "341000000000",
        "counties": [
          {
            "countyCode": "341001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341002000000",
            "countyName": "屯溪区"
          },
          {
            "countyCode": "341003000000",
            "countyName": "黄山区"
          },
          {
            "countyCode": "341004000000",
            "countyName": "徽州区"
          },
          {
            "countyCode": "341021000000",
            "countyName": "歙县"
          },
          {
            "countyCode": "341022000000",
            "countyName": "休宁县"
          },
          {
            "countyCode": "341023000000",
            "countyName": "黟县"
          },
          {
            "countyCode": "341024000000",
            "countyName": "祁门县"
          }
        ]
      },
      {
        "cityName": "滁州市",
        "cityCode": "341100000000",
        "counties": [
          {
            "countyCode": "341101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341102000000",
            "countyName": "琅琊区"
          },
          {
            "countyCode": "341103000000",
            "countyName": "南谯区"
          },
          {
            "countyCode": "341122000000",
            "countyName": "来安县"
          },
          {
            "countyCode": "341124000000",
            "countyName": "全椒县"
          },
          {
            "countyCode": "341125000000",
            "countyName": "定远县"
          },
          {
            "countyCode": "341126000000",
            "countyName": "凤阳县"
          },
          {
            "countyCode": "341171000000",
            "countyName": "苏滁现代产业园"
          },
          {
            "countyCode": "341172000000",
            "countyName": "滁州经济技术开发区"
          },
          {
            "countyCode": "341181000000",
            "countyName": "天长市"
          },
          {
            "countyCode": "341182000000",
            "countyName": "明光市"
          }
        ]
      },
      {
        "cityName": "阜阳市",
        "cityCode": "341200000000",
        "counties": [
          {
            "countyCode": "341201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341202000000",
            "countyName": "颍州区"
          },
          {
            "countyCode": "341203000000",
            "countyName": "颍东区"
          },
          {
            "countyCode": "341204000000",
            "countyName": "颍泉区"
          },
          {
            "countyCode": "341221000000",
            "countyName": "临泉县"
          },
          {
            "countyCode": "341222000000",
            "countyName": "太和县"
          },
          {
            "countyCode": "341225000000",
            "countyName": "阜南县"
          },
          {
            "countyCode": "341226000000",
            "countyName": "颍上县"
          },
          {
            "countyCode": "341271000000",
            "countyName": "阜阳合肥现代产业园区"
          },
          {
            "countyCode": "341272000000",
            "countyName": "阜阳经济技术开发区"
          },
          {
            "countyCode": "341282000000",
            "countyName": "界首市"
          }
        ]
      },
      {
        "cityName": "宿州市",
        "cityCode": "341300000000",
        "counties": [
          {
            "countyCode": "341301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341302000000",
            "countyName": "埇桥区"
          },
          {
            "countyCode": "341321000000",
            "countyName": "砀山县"
          },
          {
            "countyCode": "341322000000",
            "countyName": "萧县"
          },
          {
            "countyCode": "341323000000",
            "countyName": "灵璧县"
          },
          {
            "countyCode": "341324000000",
            "countyName": "泗县"
          },
          {
            "countyCode": "341371000000",
            "countyName": "宿州马鞍山现代产业园区"
          },
          {
            "countyCode": "341372000000",
            "countyName": "宿州经济技术开发区"
          }
        ]
      },
      {
        "cityName": "六安市",
        "cityCode": "341500000000",
        "counties": [
          {
            "countyCode": "341501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341502000000",
            "countyName": "金安区"
          },
          {
            "countyCode": "341503000000",
            "countyName": "裕安区"
          },
          {
            "countyCode": "341504000000",
            "countyName": "叶集区"
          },
          {
            "countyCode": "341522000000",
            "countyName": "霍邱县"
          },
          {
            "countyCode": "341523000000",
            "countyName": "舒城县"
          },
          {
            "countyCode": "341524000000",
            "countyName": "金寨县"
          },
          {
            "countyCode": "341525000000",
            "countyName": "霍山县"
          }
        ]
      },
      {
        "cityName": "亳州市",
        "cityCode": "341600000000",
        "counties": [
          {
            "countyCode": "341601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341602000000",
            "countyName": "谯城区"
          },
          {
            "countyCode": "341621000000",
            "countyName": "涡阳县"
          },
          {
            "countyCode": "341622000000",
            "countyName": "蒙城县"
          },
          {
            "countyCode": "341623000000",
            "countyName": "利辛县"
          }
        ]
      },
      {
        "cityName": "池州市",
        "cityCode": "341700000000",
        "counties": [
          {
            "countyCode": "341701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341702000000",
            "countyName": "贵池区"
          },
          {
            "countyCode": "341721000000",
            "countyName": "东至县"
          },
          {
            "countyCode": "341722000000",
            "countyName": "石台县"
          },
          {
            "countyCode": "341723000000",
            "countyName": "青阳县"
          }
        ]
      },
      {
        "cityName": "宣城市",
        "cityCode": "341800000000",
        "counties": [
          {
            "countyCode": "341801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "341802000000",
            "countyName": "宣州区"
          },
          {
            "countyCode": "341821000000",
            "countyName": "郎溪县"
          },
          {
            "countyCode": "341822000000",
            "countyName": "广德县"
          },
          {
            "countyCode": "341823000000",
            "countyName": "泾县"
          },
          {
            "countyCode": "341824000000",
            "countyName": "绩溪县"
          },
          {
            "countyCode": "341825000000",
            "countyName": "旌德县"
          },
          {
            "countyCode": "341871000000",
            "countyName": "宣城市经济开发区"
          },
          {
            "countyCode": "341881000000",
            "countyName": "宁国市"
          }
        ]
      }
    ],
    "provinceCode": "340000000000",
    "provinceName": "安徽省"
  },
  {
    "cities": [
      {
        "cityName": "福州市",
        "cityCode": "350100000000",
        "counties": [
          {
            "countyCode": "350101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350102000000",
            "countyName": "鼓楼区"
          },
          {
            "countyCode": "350103000000",
            "countyName": "台江区"
          },
          {
            "countyCode": "350104000000",
            "countyName": "仓山区"
          },
          {
            "countyCode": "350105000000",
            "countyName": "马尾区"
          },
          {
            "countyCode": "350111000000",
            "countyName": "晋安区"
          },
          {
            "countyCode": "350112000000",
            "countyName": "长乐区"
          },
          {
            "countyCode": "350121000000",
            "countyName": "闽侯县"
          },
          {
            "countyCode": "350122000000",
            "countyName": "连江县"
          },
          {
            "countyCode": "350123000000",
            "countyName": "罗源县"
          },
          {
            "countyCode": "350124000000",
            "countyName": "闽清县"
          },
          {
            "countyCode": "350125000000",
            "countyName": "永泰县"
          },
          {
            "countyCode": "350128000000",
            "countyName": "平潭县"
          },
          {
            "countyCode": "350181000000",
            "countyName": "福清市"
          }
        ]
      },
      {
        "cityName": "厦门市",
        "cityCode": "350200000000",
        "counties": [
          {
            "countyCode": "350201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350203000000",
            "countyName": "思明区"
          },
          {
            "countyCode": "350205000000",
            "countyName": "海沧区"
          },
          {
            "countyCode": "350206000000",
            "countyName": "湖里区"
          },
          {
            "countyCode": "350211000000",
            "countyName": "集美区"
          },
          {
            "countyCode": "350212000000",
            "countyName": "同安区"
          },
          {
            "countyCode": "350213000000",
            "countyName": "翔安区"
          }
        ]
      },
      {
        "cityName": "莆田市",
        "cityCode": "350300000000",
        "counties": [
          {
            "countyCode": "350301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350302000000",
            "countyName": "城厢区"
          },
          {
            "countyCode": "350303000000",
            "countyName": "涵江区"
          },
          {
            "countyCode": "350304000000",
            "countyName": "荔城区"
          },
          {
            "countyCode": "350305000000",
            "countyName": "秀屿区"
          },
          {
            "countyCode": "350322000000",
            "countyName": "仙游县"
          }
        ]
      },
      {
        "cityName": "三明市",
        "cityCode": "350400000000",
        "counties": [
          {
            "countyCode": "350401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350402000000",
            "countyName": "梅列区"
          },
          {
            "countyCode": "350403000000",
            "countyName": "三元区"
          },
          {
            "countyCode": "350421000000",
            "countyName": "明溪县"
          },
          {
            "countyCode": "350423000000",
            "countyName": "清流县"
          },
          {
            "countyCode": "350424000000",
            "countyName": "宁化县"
          },
          {
            "countyCode": "350425000000",
            "countyName": "大田县"
          },
          {
            "countyCode": "350426000000",
            "countyName": "尤溪县"
          },
          {
            "countyCode": "350427000000",
            "countyName": "沙县"
          },
          {
            "countyCode": "350428000000",
            "countyName": "将乐县"
          },
          {
            "countyCode": "350429000000",
            "countyName": "泰宁县"
          },
          {
            "countyCode": "350430000000",
            "countyName": "建宁县"
          },
          {
            "countyCode": "350481000000",
            "countyName": "永安市"
          }
        ]
      },
      {
        "cityName": "泉州市",
        "cityCode": "350500000000",
        "counties": [
          {
            "countyCode": "350501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350502000000",
            "countyName": "鲤城区"
          },
          {
            "countyCode": "350503000000",
            "countyName": "丰泽区"
          },
          {
            "countyCode": "350504000000",
            "countyName": "洛江区"
          },
          {
            "countyCode": "350505000000",
            "countyName": "泉港区"
          },
          {
            "countyCode": "350521000000",
            "countyName": "惠安县"
          },
          {
            "countyCode": "350524000000",
            "countyName": "安溪县"
          },
          {
            "countyCode": "350525000000",
            "countyName": "永春县"
          },
          {
            "countyCode": "350526000000",
            "countyName": "德化县"
          },
          {
            "countyCode": "350527000000",
            "countyName": "金门县"
          },
          {
            "countyCode": "350581000000",
            "countyName": "石狮市"
          },
          {
            "countyCode": "350582000000",
            "countyName": "晋江市"
          },
          {
            "countyCode": "350583000000",
            "countyName": "南安市"
          }
        ]
      },
      {
        "cityName": "漳州市",
        "cityCode": "350600000000",
        "counties": [
          {
            "countyCode": "350601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350602000000",
            "countyName": "芗城区"
          },
          {
            "countyCode": "350603000000",
            "countyName": "龙文区"
          },
          {
            "countyCode": "350622000000",
            "countyName": "云霄县"
          },
          {
            "countyCode": "350623000000",
            "countyName": "漳浦县"
          },
          {
            "countyCode": "350624000000",
            "countyName": "诏安县"
          },
          {
            "countyCode": "350625000000",
            "countyName": "长泰县"
          },
          {
            "countyCode": "350626000000",
            "countyName": "东山县"
          },
          {
            "countyCode": "350627000000",
            "countyName": "南靖县"
          },
          {
            "countyCode": "350628000000",
            "countyName": "平和县"
          },
          {
            "countyCode": "350629000000",
            "countyName": "华安县"
          },
          {
            "countyCode": "350681000000",
            "countyName": "龙海市"
          }
        ]
      },
      {
        "cityName": "南平市",
        "cityCode": "350700000000",
        "counties": [
          {
            "countyCode": "350701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350702000000",
            "countyName": "延平区"
          },
          {
            "countyCode": "350703000000",
            "countyName": "建阳区"
          },
          {
            "countyCode": "350721000000",
            "countyName": "顺昌县"
          },
          {
            "countyCode": "350722000000",
            "countyName": "浦城县"
          },
          {
            "countyCode": "350723000000",
            "countyName": "光泽县"
          },
          {
            "countyCode": "350724000000",
            "countyName": "松溪县"
          },
          {
            "countyCode": "350725000000",
            "countyName": "政和县"
          },
          {
            "countyCode": "350781000000",
            "countyName": "邵武市"
          },
          {
            "countyCode": "350782000000",
            "countyName": "武夷山市"
          },
          {
            "countyCode": "350783000000",
            "countyName": "建瓯市"
          }
        ]
      },
      {
        "cityName": "龙岩市",
        "cityCode": "350800000000",
        "counties": [
          {
            "countyCode": "350801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350802000000",
            "countyName": "新罗区"
          },
          {
            "countyCode": "350803000000",
            "countyName": "永定区"
          },
          {
            "countyCode": "350821000000",
            "countyName": "长汀县"
          },
          {
            "countyCode": "350823000000",
            "countyName": "上杭县"
          },
          {
            "countyCode": "350824000000",
            "countyName": "武平县"
          },
          {
            "countyCode": "350825000000",
            "countyName": "连城县"
          },
          {
            "countyCode": "350881000000",
            "countyName": "漳平市"
          }
        ]
      },
      {
        "cityName": "宁德市",
        "cityCode": "350900000000",
        "counties": [
          {
            "countyCode": "350901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "350902000000",
            "countyName": "蕉城区"
          },
          {
            "countyCode": "350921000000",
            "countyName": "霞浦县"
          },
          {
            "countyCode": "350922000000",
            "countyName": "古田县"
          },
          {
            "countyCode": "350923000000",
            "countyName": "屏南县"
          },
          {
            "countyCode": "350924000000",
            "countyName": "寿宁县"
          },
          {
            "countyCode": "350925000000",
            "countyName": "周宁县"
          },
          {
            "countyCode": "350926000000",
            "countyName": "柘荣县"
          },
          {
            "countyCode": "350981000000",
            "countyName": "福安市"
          },
          {
            "countyCode": "350982000000",
            "countyName": "福鼎市"
          }
        ]
      }
    ],
    "provinceCode": "350000000000",
    "provinceName": "福建省"
  },
  {
    "cities": [
      {
        "cityName": "南昌市",
        "cityCode": "360100000000",
        "counties": [
          {
            "countyCode": "360101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360102000000",
            "countyName": "东湖区"
          },
          {
            "countyCode": "360103000000",
            "countyName": "西湖区"
          },
          {
            "countyCode": "360104000000",
            "countyName": "青云谱区"
          },
          {
            "countyCode": "360105000000",
            "countyName": "湾里区"
          },
          {
            "countyCode": "360111000000",
            "countyName": "青山湖区"
          },
          {
            "countyCode": "360112000000",
            "countyName": "新建区"
          },
          {
            "countyCode": "360121000000",
            "countyName": "南昌县"
          },
          {
            "countyCode": "360123000000",
            "countyName": "安义县"
          },
          {
            "countyCode": "360124000000",
            "countyName": "进贤县"
          }
        ]
      },
      {
        "cityName": "景德镇市",
        "cityCode": "360200000000",
        "counties": [
          {
            "countyCode": "360201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360202000000",
            "countyName": "昌江区"
          },
          {
            "countyCode": "360203000000",
            "countyName": "珠山区"
          },
          {
            "countyCode": "360222000000",
            "countyName": "浮梁县"
          },
          {
            "countyCode": "360281000000",
            "countyName": "乐平市"
          }
        ]
      },
      {
        "cityName": "萍乡市",
        "cityCode": "360300000000",
        "counties": [
          {
            "countyCode": "360301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360302000000",
            "countyName": "安源区"
          },
          {
            "countyCode": "360313000000",
            "countyName": "湘东区"
          },
          {
            "countyCode": "360321000000",
            "countyName": "莲花县"
          },
          {
            "countyCode": "360322000000",
            "countyName": "上栗县"
          },
          {
            "countyCode": "360323000000",
            "countyName": "芦溪县"
          }
        ]
      },
      {
        "cityName": "九江市",
        "cityCode": "360400000000",
        "counties": [
          {
            "countyCode": "360401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360402000000",
            "countyName": "濂溪区"
          },
          {
            "countyCode": "360403000000",
            "countyName": "浔阳区"
          },
          {
            "countyCode": "360404000000",
            "countyName": "柴桑区"
          },
          {
            "countyCode": "360423000000",
            "countyName": "武宁县"
          },
          {
            "countyCode": "360424000000",
            "countyName": "修水县"
          },
          {
            "countyCode": "360425000000",
            "countyName": "永修县"
          },
          {
            "countyCode": "360426000000",
            "countyName": "德安县"
          },
          {
            "countyCode": "360428000000",
            "countyName": "都昌县"
          },
          {
            "countyCode": "360429000000",
            "countyName": "湖口县"
          },
          {
            "countyCode": "360430000000",
            "countyName": "彭泽县"
          },
          {
            "countyCode": "360481000000",
            "countyName": "瑞昌市"
          },
          {
            "countyCode": "360482000000",
            "countyName": "共青城市"
          },
          {
            "countyCode": "360483000000",
            "countyName": "庐山市"
          }
        ]
      },
      {
        "cityName": "新余市",
        "cityCode": "360500000000",
        "counties": [
          {
            "countyCode": "360501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360502000000",
            "countyName": "渝水区"
          },
          {
            "countyCode": "360521000000",
            "countyName": "分宜县"
          }
        ]
      },
      {
        "cityName": "鹰潭市",
        "cityCode": "360600000000",
        "counties": [
          {
            "countyCode": "360601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360602000000",
            "countyName": "月湖区"
          },
          {
            "countyCode": "360603000000",
            "countyName": "余江区"
          },
          {
            "countyCode": "360681000000",
            "countyName": "贵溪市"
          }
        ]
      },
      {
        "cityName": "赣州市",
        "cityCode": "360700000000",
        "counties": [
          {
            "countyCode": "360701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360702000000",
            "countyName": "章贡区"
          },
          {
            "countyCode": "360703000000",
            "countyName": "南康区"
          },
          {
            "countyCode": "360704000000",
            "countyName": "赣县区"
          },
          {
            "countyCode": "360722000000",
            "countyName": "信丰县"
          },
          {
            "countyCode": "360723000000",
            "countyName": "大余县"
          },
          {
            "countyCode": "360724000000",
            "countyName": "上犹县"
          },
          {
            "countyCode": "360725000000",
            "countyName": "崇义县"
          },
          {
            "countyCode": "360726000000",
            "countyName": "安远县"
          },
          {
            "countyCode": "360727000000",
            "countyName": "龙南县"
          },
          {
            "countyCode": "360728000000",
            "countyName": "定南县"
          },
          {
            "countyCode": "360729000000",
            "countyName": "全南县"
          },
          {
            "countyCode": "360730000000",
            "countyName": "宁都县"
          },
          {
            "countyCode": "360731000000",
            "countyName": "于都县"
          },
          {
            "countyCode": "360732000000",
            "countyName": "兴国县"
          },
          {
            "countyCode": "360733000000",
            "countyName": "会昌县"
          },
          {
            "countyCode": "360734000000",
            "countyName": "寻乌县"
          },
          {
            "countyCode": "360735000000",
            "countyName": "石城县"
          },
          {
            "countyCode": "360781000000",
            "countyName": "瑞金市"
          }
        ]
      },
      {
        "cityName": "吉安市",
        "cityCode": "360800000000",
        "counties": [
          {
            "countyCode": "360801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360802000000",
            "countyName": "吉州区"
          },
          {
            "countyCode": "360803000000",
            "countyName": "青原区"
          },
          {
            "countyCode": "360821000000",
            "countyName": "吉安县"
          },
          {
            "countyCode": "360822000000",
            "countyName": "吉水县"
          },
          {
            "countyCode": "360823000000",
            "countyName": "峡江县"
          },
          {
            "countyCode": "360824000000",
            "countyName": "新干县"
          },
          {
            "countyCode": "360825000000",
            "countyName": "永丰县"
          },
          {
            "countyCode": "360826000000",
            "countyName": "泰和县"
          },
          {
            "countyCode": "360827000000",
            "countyName": "遂川县"
          },
          {
            "countyCode": "360828000000",
            "countyName": "万安县"
          },
          {
            "countyCode": "360829000000",
            "countyName": "安福县"
          },
          {
            "countyCode": "360830000000",
            "countyName": "永新县"
          },
          {
            "countyCode": "360881000000",
            "countyName": "井冈山市"
          }
        ]
      },
      {
        "cityName": "宜春市",
        "cityCode": "360900000000",
        "counties": [
          {
            "countyCode": "360901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "360902000000",
            "countyName": "袁州区"
          },
          {
            "countyCode": "360921000000",
            "countyName": "奉新县"
          },
          {
            "countyCode": "360922000000",
            "countyName": "万载县"
          },
          {
            "countyCode": "360923000000",
            "countyName": "上高县"
          },
          {
            "countyCode": "360924000000",
            "countyName": "宜丰县"
          },
          {
            "countyCode": "360925000000",
            "countyName": "靖安县"
          },
          {
            "countyCode": "360926000000",
            "countyName": "铜鼓县"
          },
          {
            "countyCode": "360981000000",
            "countyName": "丰城市"
          },
          {
            "countyCode": "360982000000",
            "countyName": "樟树市"
          },
          {
            "countyCode": "360983000000",
            "countyName": "高安市"
          }
        ]
      },
      {
        "cityName": "抚州市",
        "cityCode": "361000000000",
        "counties": [
          {
            "countyCode": "361001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "361002000000",
            "countyName": "临川区"
          },
          {
            "countyCode": "361003000000",
            "countyName": "东乡区"
          },
          {
            "countyCode": "361021000000",
            "countyName": "南城县"
          },
          {
            "countyCode": "361022000000",
            "countyName": "黎川县"
          },
          {
            "countyCode": "361023000000",
            "countyName": "南丰县"
          },
          {
            "countyCode": "361024000000",
            "countyName": "崇仁县"
          },
          {
            "countyCode": "361025000000",
            "countyName": "乐安县"
          },
          {
            "countyCode": "361026000000",
            "countyName": "宜黄县"
          },
          {
            "countyCode": "361027000000",
            "countyName": "金溪县"
          },
          {
            "countyCode": "361028000000",
            "countyName": "资溪县"
          },
          {
            "countyCode": "361030000000",
            "countyName": "广昌县"
          }
        ]
      },
      {
        "cityName": "上饶市",
        "cityCode": "361100000000",
        "counties": [
          {
            "countyCode": "361101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "361102000000",
            "countyName": "信州区"
          },
          {
            "countyCode": "361103000000",
            "countyName": "广丰区"
          },
          {
            "countyCode": "361121000000",
            "countyName": "上饶县"
          },
          {
            "countyCode": "361123000000",
            "countyName": "玉山县"
          },
          {
            "countyCode": "361124000000",
            "countyName": "铅山县"
          },
          {
            "countyCode": "361125000000",
            "countyName": "横峰县"
          },
          {
            "countyCode": "361126000000",
            "countyName": "弋阳县"
          },
          {
            "countyCode": "361127000000",
            "countyName": "余干县"
          },
          {
            "countyCode": "361128000000",
            "countyName": "鄱阳县"
          },
          {
            "countyCode": "361129000000",
            "countyName": "万年县"
          },
          {
            "countyCode": "361130000000",
            "countyName": "婺源县"
          },
          {
            "countyCode": "361181000000",
            "countyName": "德兴市"
          }
        ]
      }
    ],
    "provinceCode": "360000000000",
    "provinceName": "江西省"
  },
  {
    "cities": [
      {
        "cityName": "济南市",
        "cityCode": "370100000000",
        "counties": [
          {
            "countyCode": "370101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370102000000",
            "countyName": "历下区"
          },
          {
            "countyCode": "370103000000",
            "countyName": "市中区"
          },
          {
            "countyCode": "370104000000",
            "countyName": "槐荫区"
          },
          {
            "countyCode": "370105000000",
            "countyName": "天桥区"
          },
          {
            "countyCode": "370112000000",
            "countyName": "历城区"
          },
          {
            "countyCode": "370113000000",
            "countyName": "长清区"
          },
          {
            "countyCode": "370114000000",
            "countyName": "章丘区"
          },
          {
            "countyCode": "370115000000",
            "countyName": "济阳区"
          },
          {
            "countyCode": "370124000000",
            "countyName": "平阴县"
          },
          {
            "countyCode": "370126000000",
            "countyName": "商河县"
          },
          {
            "countyCode": "370171000000",
            "countyName": "济南高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "青岛市",
        "cityCode": "370200000000",
        "counties": [
          {
            "countyCode": "370201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370202000000",
            "countyName": "市南区"
          },
          {
            "countyCode": "370203000000",
            "countyName": "市北区"
          },
          {
            "countyCode": "370211000000",
            "countyName": "黄岛区"
          },
          {
            "countyCode": "370212000000",
            "countyName": "崂山区"
          },
          {
            "countyCode": "370213000000",
            "countyName": "李沧区"
          },
          {
            "countyCode": "370214000000",
            "countyName": "城阳区"
          },
          {
            "countyCode": "370215000000",
            "countyName": "即墨区"
          },
          {
            "countyCode": "370271000000",
            "countyName": "青岛高新技术产业开发区"
          },
          {
            "countyCode": "370281000000",
            "countyName": "胶州市"
          },
          {
            "countyCode": "370283000000",
            "countyName": "平度市"
          },
          {
            "countyCode": "370285000000",
            "countyName": "莱西市"
          }
        ]
      },
      {
        "cityName": "淄博市",
        "cityCode": "370300000000",
        "counties": [
          {
            "countyCode": "370301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370302000000",
            "countyName": "淄川区"
          },
          {
            "countyCode": "370303000000",
            "countyName": "张店区"
          },
          {
            "countyCode": "370304000000",
            "countyName": "博山区"
          },
          {
            "countyCode": "370305000000",
            "countyName": "临淄区"
          },
          {
            "countyCode": "370306000000",
            "countyName": "周村区"
          },
          {
            "countyCode": "370321000000",
            "countyName": "桓台县"
          },
          {
            "countyCode": "370322000000",
            "countyName": "高青县"
          },
          {
            "countyCode": "370323000000",
            "countyName": "沂源县"
          }
        ]
      },
      {
        "cityName": "枣庄市",
        "cityCode": "370400000000",
        "counties": [
          {
            "countyCode": "370401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370402000000",
            "countyName": "市中区"
          },
          {
            "countyCode": "370403000000",
            "countyName": "薛城区"
          },
          {
            "countyCode": "370404000000",
            "countyName": "峄城区"
          },
          {
            "countyCode": "370405000000",
            "countyName": "台儿庄区"
          },
          {
            "countyCode": "370406000000",
            "countyName": "山亭区"
          },
          {
            "countyCode": "370481000000",
            "countyName": "滕州市"
          }
        ]
      },
      {
        "cityName": "东营市",
        "cityCode": "370500000000",
        "counties": [
          {
            "countyCode": "370501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370502000000",
            "countyName": "东营区"
          },
          {
            "countyCode": "370503000000",
            "countyName": "河口区"
          },
          {
            "countyCode": "370505000000",
            "countyName": "垦利区"
          },
          {
            "countyCode": "370522000000",
            "countyName": "利津县"
          },
          {
            "countyCode": "370523000000",
            "countyName": "广饶县"
          },
          {
            "countyCode": "370571000000",
            "countyName": "东营经济技术开发区"
          },
          {
            "countyCode": "370572000000",
            "countyName": "东营港经济开发区"
          }
        ]
      },
      {
        "cityName": "烟台市",
        "cityCode": "370600000000",
        "counties": [
          {
            "countyCode": "370601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370602000000",
            "countyName": "芝罘区"
          },
          {
            "countyCode": "370611000000",
            "countyName": "福山区"
          },
          {
            "countyCode": "370612000000",
            "countyName": "牟平区"
          },
          {
            "countyCode": "370613000000",
            "countyName": "莱山区"
          },
          {
            "countyCode": "370634000000",
            "countyName": "长岛县"
          },
          {
            "countyCode": "370671000000",
            "countyName": "烟台高新技术产业开发区"
          },
          {
            "countyCode": "370672000000",
            "countyName": "烟台经济技术开发区"
          },
          {
            "countyCode": "370681000000",
            "countyName": "龙口市"
          },
          {
            "countyCode": "370682000000",
            "countyName": "莱阳市"
          },
          {
            "countyCode": "370683000000",
            "countyName": "莱州市"
          },
          {
            "countyCode": "370684000000",
            "countyName": "蓬莱市"
          },
          {
            "countyCode": "370685000000",
            "countyName": "招远市"
          },
          {
            "countyCode": "370686000000",
            "countyName": "栖霞市"
          },
          {
            "countyCode": "370687000000",
            "countyName": "海阳市"
          }
        ]
      },
      {
        "cityName": "潍坊市",
        "cityCode": "370700000000",
        "counties": [
          {
            "countyCode": "370701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370702000000",
            "countyName": "潍城区"
          },
          {
            "countyCode": "370703000000",
            "countyName": "寒亭区"
          },
          {
            "countyCode": "370704000000",
            "countyName": "坊子区"
          },
          {
            "countyCode": "370705000000",
            "countyName": "奎文区"
          },
          {
            "countyCode": "370724000000",
            "countyName": "临朐县"
          },
          {
            "countyCode": "370725000000",
            "countyName": "昌乐县"
          },
          {
            "countyCode": "370772000000",
            "countyName": "潍坊滨海经济技术开发区"
          },
          {
            "countyCode": "370781000000",
            "countyName": "青州市"
          },
          {
            "countyCode": "370782000000",
            "countyName": "诸城市"
          },
          {
            "countyCode": "370783000000",
            "countyName": "寿光市"
          },
          {
            "countyCode": "370784000000",
            "countyName": "安丘市"
          },
          {
            "countyCode": "370785000000",
            "countyName": "高密市"
          },
          {
            "countyCode": "370786000000",
            "countyName": "昌邑市"
          }
        ]
      },
      {
        "cityName": "济宁市",
        "cityCode": "370800000000",
        "counties": [
          {
            "countyCode": "370801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370811000000",
            "countyName": "任城区"
          },
          {
            "countyCode": "370812000000",
            "countyName": "兖州区"
          },
          {
            "countyCode": "370826000000",
            "countyName": "微山县"
          },
          {
            "countyCode": "370827000000",
            "countyName": "鱼台县"
          },
          {
            "countyCode": "370828000000",
            "countyName": "金乡县"
          },
          {
            "countyCode": "370829000000",
            "countyName": "嘉祥县"
          },
          {
            "countyCode": "370830000000",
            "countyName": "汶上县"
          },
          {
            "countyCode": "370831000000",
            "countyName": "泗水县"
          },
          {
            "countyCode": "370832000000",
            "countyName": "梁山县"
          },
          {
            "countyCode": "370871000000",
            "countyName": "济宁高新技术产业开发区"
          },
          {
            "countyCode": "370881000000",
            "countyName": "曲阜市"
          },
          {
            "countyCode": "370883000000",
            "countyName": "邹城市"
          }
        ]
      },
      {
        "cityName": "泰安市",
        "cityCode": "370900000000",
        "counties": [
          {
            "countyCode": "370901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "370902000000",
            "countyName": "泰山区"
          },
          {
            "countyCode": "370911000000",
            "countyName": "岱岳区"
          },
          {
            "countyCode": "370921000000",
            "countyName": "宁阳县"
          },
          {
            "countyCode": "370923000000",
            "countyName": "东平县"
          },
          {
            "countyCode": "370982000000",
            "countyName": "新泰市"
          },
          {
            "countyCode": "370983000000",
            "countyName": "肥城市"
          }
        ]
      },
      {
        "cityName": "威海市",
        "cityCode": "371000000000",
        "counties": [
          {
            "countyCode": "371001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371002000000",
            "countyName": "环翠区"
          },
          {
            "countyCode": "371003000000",
            "countyName": "文登区"
          },
          {
            "countyCode": "371071000000",
            "countyName": "威海火炬高技术产业开发区"
          },
          {
            "countyCode": "371072000000",
            "countyName": "威海经济技术开发区"
          },
          {
            "countyCode": "371073000000",
            "countyName": "威海临港经济技术开发区"
          },
          {
            "countyCode": "371082000000",
            "countyName": "荣成市"
          },
          {
            "countyCode": "371083000000",
            "countyName": "乳山市"
          }
        ]
      },
      {
        "cityName": "日照市",
        "cityCode": "371100000000",
        "counties": [
          {
            "countyCode": "371101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371102000000",
            "countyName": "东港区"
          },
          {
            "countyCode": "371103000000",
            "countyName": "岚山区"
          },
          {
            "countyCode": "371121000000",
            "countyName": "五莲县"
          },
          {
            "countyCode": "371122000000",
            "countyName": "莒县"
          },
          {
            "countyCode": "371171000000",
            "countyName": "日照经济技术开发区"
          }
        ]
      },
      {
        "cityName": "莱芜市",
        "cityCode": "371200000000",
        "counties": [
          {
            "countyCode": "371201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371202000000",
            "countyName": "莱城区"
          },
          {
            "countyCode": "371203000000",
            "countyName": "钢城区"
          }
        ]
      },
      {
        "cityName": "临沂市",
        "cityCode": "371300000000",
        "counties": [
          {
            "countyCode": "371301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371302000000",
            "countyName": "兰山区"
          },
          {
            "countyCode": "371311000000",
            "countyName": "罗庄区"
          },
          {
            "countyCode": "371312000000",
            "countyName": "河东区"
          },
          {
            "countyCode": "371321000000",
            "countyName": "沂南县"
          },
          {
            "countyCode": "371322000000",
            "countyName": "郯城县"
          },
          {
            "countyCode": "371323000000",
            "countyName": "沂水县"
          },
          {
            "countyCode": "371324000000",
            "countyName": "兰陵县"
          },
          {
            "countyCode": "371325000000",
            "countyName": "费县"
          },
          {
            "countyCode": "371326000000",
            "countyName": "平邑县"
          },
          {
            "countyCode": "371327000000",
            "countyName": "莒南县"
          },
          {
            "countyCode": "371328000000",
            "countyName": "蒙阴县"
          },
          {
            "countyCode": "371329000000",
            "countyName": "临沭县"
          },
          {
            "countyCode": "371371000000",
            "countyName": "临沂高新技术产业开发区"
          },
          {
            "countyCode": "371372000000",
            "countyName": "临沂经济技术开发区"
          },
          {
            "countyCode": "371373000000",
            "countyName": "临沂临港经济开发区"
          }
        ]
      },
      {
        "cityName": "德州市",
        "cityCode": "371400000000",
        "counties": [
          {
            "countyCode": "371401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371402000000",
            "countyName": "德城区"
          },
          {
            "countyCode": "371403000000",
            "countyName": "陵城区"
          },
          {
            "countyCode": "371422000000",
            "countyName": "宁津县"
          },
          {
            "countyCode": "371423000000",
            "countyName": "庆云县"
          },
          {
            "countyCode": "371424000000",
            "countyName": "临邑县"
          },
          {
            "countyCode": "371425000000",
            "countyName": "齐河县"
          },
          {
            "countyCode": "371426000000",
            "countyName": "平原县"
          },
          {
            "countyCode": "371427000000",
            "countyName": "夏津县"
          },
          {
            "countyCode": "371428000000",
            "countyName": "武城县"
          },
          {
            "countyCode": "371471000000",
            "countyName": "德州经济技术开发区"
          },
          {
            "countyCode": "371472000000",
            "countyName": "德州运河经济开发区"
          },
          {
            "countyCode": "371481000000",
            "countyName": "乐陵市"
          },
          {
            "countyCode": "371482000000",
            "countyName": "禹城市"
          }
        ]
      },
      {
        "cityName": "聊城市",
        "cityCode": "371500000000",
        "counties": [
          {
            "countyCode": "371501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371502000000",
            "countyName": "东昌府区"
          },
          {
            "countyCode": "371521000000",
            "countyName": "阳谷县"
          },
          {
            "countyCode": "371522000000",
            "countyName": "莘县"
          },
          {
            "countyCode": "371523000000",
            "countyName": "茌平县"
          },
          {
            "countyCode": "371524000000",
            "countyName": "东阿县"
          },
          {
            "countyCode": "371525000000",
            "countyName": "冠县"
          },
          {
            "countyCode": "371526000000",
            "countyName": "高唐县"
          },
          {
            "countyCode": "371581000000",
            "countyName": "临清市"
          }
        ]
      },
      {
        "cityName": "滨州市",
        "cityCode": "371600000000",
        "counties": [
          {
            "countyCode": "371601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371602000000",
            "countyName": "滨城区"
          },
          {
            "countyCode": "371603000000",
            "countyName": "沾化区"
          },
          {
            "countyCode": "371621000000",
            "countyName": "惠民县"
          },
          {
            "countyCode": "371622000000",
            "countyName": "阳信县"
          },
          {
            "countyCode": "371623000000",
            "countyName": "无棣县"
          },
          {
            "countyCode": "371625000000",
            "countyName": "博兴县"
          },
          {
            "countyCode": "371681000000",
            "countyName": "邹平市"
          }
        ]
      },
      {
        "cityName": "菏泽市",
        "cityCode": "371700000000",
        "counties": [
          {
            "countyCode": "371701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "371702000000",
            "countyName": "牡丹区"
          },
          {
            "countyCode": "371703000000",
            "countyName": "定陶区"
          },
          {
            "countyCode": "371721000000",
            "countyName": "曹县"
          },
          {
            "countyCode": "371722000000",
            "countyName": "单县"
          },
          {
            "countyCode": "371723000000",
            "countyName": "成武县"
          },
          {
            "countyCode": "371724000000",
            "countyName": "巨野县"
          },
          {
            "countyCode": "371725000000",
            "countyName": "郓城县"
          },
          {
            "countyCode": "371726000000",
            "countyName": "鄄城县"
          },
          {
            "countyCode": "371728000000",
            "countyName": "东明县"
          },
          {
            "countyCode": "371771000000",
            "countyName": "菏泽经济技术开发区"
          },
          {
            "countyCode": "371772000000",
            "countyName": "菏泽高新技术开发区"
          }
        ]
      }
    ],
    "provinceCode": "370000000000",
    "provinceName": "山东省"
  },
  {
    "cities": [
      {
        "cityName": "郑州市",
        "cityCode": "410100000000",
        "counties": [
          {
            "countyCode": "410101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410102000000",
            "countyName": "中原区"
          },
          {
            "countyCode": "410103000000",
            "countyName": "二七区"
          },
          {
            "countyCode": "410104000000",
            "countyName": "管城回族区"
          },
          {
            "countyCode": "410105000000",
            "countyName": "金水区"
          },
          {
            "countyCode": "410106000000",
            "countyName": "上街区"
          },
          {
            "countyCode": "410108000000",
            "countyName": "惠济区"
          },
          {
            "countyCode": "410122000000",
            "countyName": "中牟县"
          },
          {
            "countyCode": "410171000000",
            "countyName": "郑州经济技术开发区"
          },
          {
            "countyCode": "410172000000",
            "countyName": "郑州高新技术产业开发区"
          },
          {
            "countyCode": "410173000000",
            "countyName": "郑州航空港经济综合实验区"
          },
          {
            "countyCode": "410181000000",
            "countyName": "巩义市"
          },
          {
            "countyCode": "410182000000",
            "countyName": "荥阳市"
          },
          {
            "countyCode": "410183000000",
            "countyName": "新密市"
          },
          {
            "countyCode": "410184000000",
            "countyName": "新郑市"
          },
          {
            "countyCode": "410185000000",
            "countyName": "登封市"
          }
        ]
      },
      {
        "cityName": "开封市",
        "cityCode": "410200000000",
        "counties": [
          {
            "countyCode": "410201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410202000000",
            "countyName": "龙亭区"
          },
          {
            "countyCode": "410203000000",
            "countyName": "顺河回族区"
          },
          {
            "countyCode": "410204000000",
            "countyName": "鼓楼区"
          },
          {
            "countyCode": "410205000000",
            "countyName": "禹王台区"
          },
          {
            "countyCode": "410212000000",
            "countyName": "祥符区"
          },
          {
            "countyCode": "410221000000",
            "countyName": "杞县"
          },
          {
            "countyCode": "410222000000",
            "countyName": "通许县"
          },
          {
            "countyCode": "410223000000",
            "countyName": "尉氏县"
          },
          {
            "countyCode": "410225000000",
            "countyName": "兰考县"
          }
        ]
      },
      {
        "cityName": "洛阳市",
        "cityCode": "410300000000",
        "counties": [
          {
            "countyCode": "410301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410302000000",
            "countyName": "老城区"
          },
          {
            "countyCode": "410303000000",
            "countyName": "西工区"
          },
          {
            "countyCode": "410304000000",
            "countyName": "瀍河回族区"
          },
          {
            "countyCode": "410305000000",
            "countyName": "涧西区"
          },
          {
            "countyCode": "410306000000",
            "countyName": "吉利区"
          },
          {
            "countyCode": "410311000000",
            "countyName": "洛龙区"
          },
          {
            "countyCode": "410322000000",
            "countyName": "孟津县"
          },
          {
            "countyCode": "410323000000",
            "countyName": "新安县"
          },
          {
            "countyCode": "410324000000",
            "countyName": "栾川县"
          },
          {
            "countyCode": "410325000000",
            "countyName": "嵩县"
          },
          {
            "countyCode": "410326000000",
            "countyName": "汝阳县"
          },
          {
            "countyCode": "410327000000",
            "countyName": "宜阳县"
          },
          {
            "countyCode": "410328000000",
            "countyName": "洛宁县"
          },
          {
            "countyCode": "410329000000",
            "countyName": "伊川县"
          },
          {
            "countyCode": "410371000000",
            "countyName": "洛阳高新技术产业开发区"
          },
          {
            "countyCode": "410381000000",
            "countyName": "偃师市"
          }
        ]
      },
      {
        "cityName": "平顶山市",
        "cityCode": "410400000000",
        "counties": [
          {
            "countyCode": "410401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410402000000",
            "countyName": "新华区"
          },
          {
            "countyCode": "410403000000",
            "countyName": "卫东区"
          },
          {
            "countyCode": "410404000000",
            "countyName": "石龙区"
          },
          {
            "countyCode": "410411000000",
            "countyName": "湛河区"
          },
          {
            "countyCode": "410421000000",
            "countyName": "宝丰县"
          },
          {
            "countyCode": "410422000000",
            "countyName": "叶县"
          },
          {
            "countyCode": "410423000000",
            "countyName": "鲁山县"
          },
          {
            "countyCode": "410425000000",
            "countyName": "郏县"
          },
          {
            "countyCode": "410471000000",
            "countyName": "平顶山高新技术产业开发区"
          },
          {
            "countyCode": "410472000000",
            "countyName": "平顶山市新城区"
          },
          {
            "countyCode": "410481000000",
            "countyName": "舞钢市"
          },
          {
            "countyCode": "410482000000",
            "countyName": "汝州市"
          }
        ]
      },
      {
        "cityName": "安阳市",
        "cityCode": "410500000000",
        "counties": [
          {
            "countyCode": "410501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410502000000",
            "countyName": "文峰区"
          },
          {
            "countyCode": "410503000000",
            "countyName": "北关区"
          },
          {
            "countyCode": "410505000000",
            "countyName": "殷都区"
          },
          {
            "countyCode": "410506000000",
            "countyName": "龙安区"
          },
          {
            "countyCode": "410522000000",
            "countyName": "安阳县"
          },
          {
            "countyCode": "410523000000",
            "countyName": "汤阴县"
          },
          {
            "countyCode": "410526000000",
            "countyName": "滑县"
          },
          {
            "countyCode": "410527000000",
            "countyName": "内黄县"
          },
          {
            "countyCode": "410571000000",
            "countyName": "安阳高新技术产业开发区"
          },
          {
            "countyCode": "410581000000",
            "countyName": "林州市"
          }
        ]
      },
      {
        "cityName": "鹤壁市",
        "cityCode": "410600000000",
        "counties": [
          {
            "countyCode": "410601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410602000000",
            "countyName": "鹤山区"
          },
          {
            "countyCode": "410603000000",
            "countyName": "山城区"
          },
          {
            "countyCode": "410611000000",
            "countyName": "淇滨区"
          },
          {
            "countyCode": "410621000000",
            "countyName": "浚县"
          },
          {
            "countyCode": "410622000000",
            "countyName": "淇县"
          },
          {
            "countyCode": "410671000000",
            "countyName": "鹤壁经济技术开发区"
          }
        ]
      },
      {
        "cityName": "新乡市",
        "cityCode": "410700000000",
        "counties": [
          {
            "countyCode": "410701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410702000000",
            "countyName": "红旗区"
          },
          {
            "countyCode": "410703000000",
            "countyName": "卫滨区"
          },
          {
            "countyCode": "410704000000",
            "countyName": "凤泉区"
          },
          {
            "countyCode": "410711000000",
            "countyName": "牧野区"
          },
          {
            "countyCode": "410721000000",
            "countyName": "新乡县"
          },
          {
            "countyCode": "410724000000",
            "countyName": "获嘉县"
          },
          {
            "countyCode": "410725000000",
            "countyName": "原阳县"
          },
          {
            "countyCode": "410726000000",
            "countyName": "延津县"
          },
          {
            "countyCode": "410727000000",
            "countyName": "封丘县"
          },
          {
            "countyCode": "410728000000",
            "countyName": "长垣县"
          },
          {
            "countyCode": "410771000000",
            "countyName": "新乡高新技术产业开发区"
          },
          {
            "countyCode": "410772000000",
            "countyName": "新乡经济技术开发区"
          },
          {
            "countyCode": "410773000000",
            "countyName": "新乡市平原城乡一体化示范区"
          },
          {
            "countyCode": "410781000000",
            "countyName": "卫辉市"
          },
          {
            "countyCode": "410782000000",
            "countyName": "辉县市"
          }
        ]
      },
      {
        "cityName": "焦作市",
        "cityCode": "410800000000",
        "counties": [
          {
            "countyCode": "410801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410802000000",
            "countyName": "解放区"
          },
          {
            "countyCode": "410803000000",
            "countyName": "中站区"
          },
          {
            "countyCode": "410804000000",
            "countyName": "马村区"
          },
          {
            "countyCode": "410811000000",
            "countyName": "山阳区"
          },
          {
            "countyCode": "410821000000",
            "countyName": "修武县"
          },
          {
            "countyCode": "410822000000",
            "countyName": "博爱县"
          },
          {
            "countyCode": "410823000000",
            "countyName": "武陟县"
          },
          {
            "countyCode": "410825000000",
            "countyName": "温县"
          },
          {
            "countyCode": "410871000000",
            "countyName": "焦作城乡一体化示范区"
          },
          {
            "countyCode": "410882000000",
            "countyName": "沁阳市"
          },
          {
            "countyCode": "410883000000",
            "countyName": "孟州市"
          }
        ]
      },
      {
        "cityName": "濮阳市",
        "cityCode": "410900000000",
        "counties": [
          {
            "countyCode": "410901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "410902000000",
            "countyName": "华龙区"
          },
          {
            "countyCode": "410922000000",
            "countyName": "清丰县"
          },
          {
            "countyCode": "410923000000",
            "countyName": "南乐县"
          },
          {
            "countyCode": "410926000000",
            "countyName": "范县"
          },
          {
            "countyCode": "410927000000",
            "countyName": "台前县"
          },
          {
            "countyCode": "410928000000",
            "countyName": "濮阳县"
          },
          {
            "countyCode": "410971000000",
            "countyName": "河南濮阳工业园区"
          },
          {
            "countyCode": "410972000000",
            "countyName": "濮阳经济技术开发区"
          }
        ]
      },
      {
        "cityName": "许昌市",
        "cityCode": "411000000000",
        "counties": [
          {
            "countyCode": "411001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411002000000",
            "countyName": "魏都区"
          },
          {
            "countyCode": "411003000000",
            "countyName": "建安区"
          },
          {
            "countyCode": "411024000000",
            "countyName": "鄢陵县"
          },
          {
            "countyCode": "411025000000",
            "countyName": "襄城县"
          },
          {
            "countyCode": "411071000000",
            "countyName": "许昌经济技术开发区"
          },
          {
            "countyCode": "411081000000",
            "countyName": "禹州市"
          },
          {
            "countyCode": "411082000000",
            "countyName": "长葛市"
          }
        ]
      },
      {
        "cityName": "漯河市",
        "cityCode": "411100000000",
        "counties": [
          {
            "countyCode": "411101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411102000000",
            "countyName": "源汇区"
          },
          {
            "countyCode": "411103000000",
            "countyName": "郾城区"
          },
          {
            "countyCode": "411104000000",
            "countyName": "召陵区"
          },
          {
            "countyCode": "411121000000",
            "countyName": "舞阳县"
          },
          {
            "countyCode": "411122000000",
            "countyName": "临颍县"
          },
          {
            "countyCode": "411171000000",
            "countyName": "漯河经济技术开发区"
          }
        ]
      },
      {
        "cityName": "三门峡市",
        "cityCode": "411200000000",
        "counties": [
          {
            "countyCode": "411201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411202000000",
            "countyName": "湖滨区"
          },
          {
            "countyCode": "411203000000",
            "countyName": "陕州区"
          },
          {
            "countyCode": "411221000000",
            "countyName": "渑池县"
          },
          {
            "countyCode": "411224000000",
            "countyName": "卢氏县"
          },
          {
            "countyCode": "411271000000",
            "countyName": "河南三门峡经济开发区"
          },
          {
            "countyCode": "411281000000",
            "countyName": "义马市"
          },
          {
            "countyCode": "411282000000",
            "countyName": "灵宝市"
          }
        ]
      },
      {
        "cityName": "南阳市",
        "cityCode": "411300000000",
        "counties": [
          {
            "countyCode": "411301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411302000000",
            "countyName": "宛城区"
          },
          {
            "countyCode": "411303000000",
            "countyName": "卧龙区"
          },
          {
            "countyCode": "411321000000",
            "countyName": "南召县"
          },
          {
            "countyCode": "411322000000",
            "countyName": "方城县"
          },
          {
            "countyCode": "411323000000",
            "countyName": "西峡县"
          },
          {
            "countyCode": "411324000000",
            "countyName": "镇平县"
          },
          {
            "countyCode": "411325000000",
            "countyName": "内乡县"
          },
          {
            "countyCode": "411326000000",
            "countyName": "淅川县"
          },
          {
            "countyCode": "411327000000",
            "countyName": "社旗县"
          },
          {
            "countyCode": "411328000000",
            "countyName": "唐河县"
          },
          {
            "countyCode": "411329000000",
            "countyName": "新野县"
          },
          {
            "countyCode": "411330000000",
            "countyName": "桐柏县"
          },
          {
            "countyCode": "411371000000",
            "countyName": "南阳高新技术产业开发区"
          },
          {
            "countyCode": "411372000000",
            "countyName": "南阳市城乡一体化示范区"
          },
          {
            "countyCode": "411381000000",
            "countyName": "邓州市"
          }
        ]
      },
      {
        "cityName": "商丘市",
        "cityCode": "411400000000",
        "counties": [
          {
            "countyCode": "411401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411402000000",
            "countyName": "梁园区"
          },
          {
            "countyCode": "411403000000",
            "countyName": "睢阳区"
          },
          {
            "countyCode": "411421000000",
            "countyName": "民权县"
          },
          {
            "countyCode": "411422000000",
            "countyName": "睢县"
          },
          {
            "countyCode": "411423000000",
            "countyName": "宁陵县"
          },
          {
            "countyCode": "411424000000",
            "countyName": "柘城县"
          },
          {
            "countyCode": "411425000000",
            "countyName": "虞城县"
          },
          {
            "countyCode": "411426000000",
            "countyName": "夏邑县"
          },
          {
            "countyCode": "411471000000",
            "countyName": "豫东综合物流产业聚集区"
          },
          {
            "countyCode": "411472000000",
            "countyName": "河南商丘经济开发区"
          },
          {
            "countyCode": "411481000000",
            "countyName": "永城市"
          }
        ]
      },
      {
        "cityName": "信阳市",
        "cityCode": "411500000000",
        "counties": [
          {
            "countyCode": "411501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411502000000",
            "countyName": "浉河区"
          },
          {
            "countyCode": "411503000000",
            "countyName": "平桥区"
          },
          {
            "countyCode": "411521000000",
            "countyName": "罗山县"
          },
          {
            "countyCode": "411522000000",
            "countyName": "光山县"
          },
          {
            "countyCode": "411523000000",
            "countyName": "新县"
          },
          {
            "countyCode": "411524000000",
            "countyName": "商城县"
          },
          {
            "countyCode": "411525000000",
            "countyName": "固始县"
          },
          {
            "countyCode": "411526000000",
            "countyName": "潢川县"
          },
          {
            "countyCode": "411527000000",
            "countyName": "淮滨县"
          },
          {
            "countyCode": "411528000000",
            "countyName": "息县"
          },
          {
            "countyCode": "411571000000",
            "countyName": "信阳高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "周口市",
        "cityCode": "411600000000",
        "counties": [
          {
            "countyCode": "411601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411602000000",
            "countyName": "川汇区"
          },
          {
            "countyCode": "411621000000",
            "countyName": "扶沟县"
          },
          {
            "countyCode": "411622000000",
            "countyName": "西华县"
          },
          {
            "countyCode": "411623000000",
            "countyName": "商水县"
          },
          {
            "countyCode": "411624000000",
            "countyName": "沈丘县"
          },
          {
            "countyCode": "411625000000",
            "countyName": "郸城县"
          },
          {
            "countyCode": "411626000000",
            "countyName": "淮阳县"
          },
          {
            "countyCode": "411627000000",
            "countyName": "太康县"
          },
          {
            "countyCode": "411628000000",
            "countyName": "鹿邑县"
          },
          {
            "countyCode": "411671000000",
            "countyName": "河南周口经济开发区"
          },
          {
            "countyCode": "411681000000",
            "countyName": "项城市"
          }
        ]
      },
      {
        "cityName": "驻马店市",
        "cityCode": "411700000000",
        "counties": [
          {
            "countyCode": "411701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "411702000000",
            "countyName": "驿城区"
          },
          {
            "countyCode": "411721000000",
            "countyName": "西平县"
          },
          {
            "countyCode": "411722000000",
            "countyName": "上蔡县"
          },
          {
            "countyCode": "411723000000",
            "countyName": "平舆县"
          },
          {
            "countyCode": "411724000000",
            "countyName": "正阳县"
          },
          {
            "countyCode": "411725000000",
            "countyName": "确山县"
          },
          {
            "countyCode": "411726000000",
            "countyName": "泌阳县"
          },
          {
            "countyCode": "411727000000",
            "countyName": "汝南县"
          },
          {
            "countyCode": "411728000000",
            "countyName": "遂平县"
          },
          {
            "countyCode": "411729000000",
            "countyName": "新蔡县"
          },
          {
            "countyCode": "411771000000",
            "countyName": "河南驻马店经济开发区"
          }
        ]
      },
      {
        "cityName": "省直辖县级行政区划",
        "cityCode": "419000000000",
        "counties": [
          {
            "countyCode": "419001000000",
            "countyName": "济源市"
          }
        ]
      }
    ],
    "provinceCode": "410000000000",
    "provinceName": "河南省"
  },
  {
    "cities": [
      {
        "cityName": "武汉市",
        "cityCode": "420100000000",
        "counties": [
          {
            "countyCode": "420101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420102000000",
            "countyName": "江岸区"
          },
          {
            "countyCode": "420103000000",
            "countyName": "江汉区"
          },
          {
            "countyCode": "420104000000",
            "countyName": "硚口区"
          },
          {
            "countyCode": "420105000000",
            "countyName": "汉阳区"
          },
          {
            "countyCode": "420106000000",
            "countyName": "武昌区"
          },
          {
            "countyCode": "420107000000",
            "countyName": "青山区"
          },
          {
            "countyCode": "420111000000",
            "countyName": "洪山区"
          },
          {
            "countyCode": "420112000000",
            "countyName": "东西湖区"
          },
          {
            "countyCode": "420113000000",
            "countyName": "汉南区"
          },
          {
            "countyCode": "420114000000",
            "countyName": "蔡甸区"
          },
          {
            "countyCode": "420115000000",
            "countyName": "江夏区"
          },
          {
            "countyCode": "420116000000",
            "countyName": "黄陂区"
          },
          {
            "countyCode": "420117000000",
            "countyName": "新洲区"
          }
        ]
      },
      {
        "cityName": "黄石市",
        "cityCode": "420200000000",
        "counties": [
          {
            "countyCode": "420201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420202000000",
            "countyName": "黄石港区"
          },
          {
            "countyCode": "420203000000",
            "countyName": "西塞山区"
          },
          {
            "countyCode": "420204000000",
            "countyName": "下陆区"
          },
          {
            "countyCode": "420205000000",
            "countyName": "铁山区"
          },
          {
            "countyCode": "420222000000",
            "countyName": "阳新县"
          },
          {
            "countyCode": "420281000000",
            "countyName": "大冶市"
          }
        ]
      },
      {
        "cityName": "十堰市",
        "cityCode": "420300000000",
        "counties": [
          {
            "countyCode": "420301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420302000000",
            "countyName": "茅箭区"
          },
          {
            "countyCode": "420303000000",
            "countyName": "张湾区"
          },
          {
            "countyCode": "420304000000",
            "countyName": "郧阳区"
          },
          {
            "countyCode": "420322000000",
            "countyName": "郧西县"
          },
          {
            "countyCode": "420323000000",
            "countyName": "竹山县"
          },
          {
            "countyCode": "420324000000",
            "countyName": "竹溪县"
          },
          {
            "countyCode": "420325000000",
            "countyName": "房县"
          },
          {
            "countyCode": "420381000000",
            "countyName": "丹江口市"
          }
        ]
      },
      {
        "cityName": "宜昌市",
        "cityCode": "420500000000",
        "counties": [
          {
            "countyCode": "420501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420502000000",
            "countyName": "西陵区"
          },
          {
            "countyCode": "420503000000",
            "countyName": "伍家岗区"
          },
          {
            "countyCode": "420504000000",
            "countyName": "点军区"
          },
          {
            "countyCode": "420505000000",
            "countyName": "猇亭区"
          },
          {
            "countyCode": "420506000000",
            "countyName": "夷陵区"
          },
          {
            "countyCode": "420525000000",
            "countyName": "远安县"
          },
          {
            "countyCode": "420526000000",
            "countyName": "兴山县"
          },
          {
            "countyCode": "420527000000",
            "countyName": "秭归县"
          },
          {
            "countyCode": "420528000000",
            "countyName": "长阳土家族自治县"
          },
          {
            "countyCode": "420529000000",
            "countyName": "五峰土家族自治县"
          },
          {
            "countyCode": "420581000000",
            "countyName": "宜都市"
          },
          {
            "countyCode": "420582000000",
            "countyName": "当阳市"
          },
          {
            "countyCode": "420583000000",
            "countyName": "枝江市"
          }
        ]
      },
      {
        "cityName": "襄阳市",
        "cityCode": "420600000000",
        "counties": [
          {
            "countyCode": "420601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420602000000",
            "countyName": "襄城区"
          },
          {
            "countyCode": "420606000000",
            "countyName": "樊城区"
          },
          {
            "countyCode": "420607000000",
            "countyName": "襄州区"
          },
          {
            "countyCode": "420624000000",
            "countyName": "南漳县"
          },
          {
            "countyCode": "420625000000",
            "countyName": "谷城县"
          },
          {
            "countyCode": "420626000000",
            "countyName": "保康县"
          },
          {
            "countyCode": "420682000000",
            "countyName": "老河口市"
          },
          {
            "countyCode": "420683000000",
            "countyName": "枣阳市"
          },
          {
            "countyCode": "420684000000",
            "countyName": "宜城市"
          }
        ]
      },
      {
        "cityName": "鄂州市",
        "cityCode": "420700000000",
        "counties": [
          {
            "countyCode": "420701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420702000000",
            "countyName": "梁子湖区"
          },
          {
            "countyCode": "420703000000",
            "countyName": "华容区"
          },
          {
            "countyCode": "420704000000",
            "countyName": "鄂城区"
          }
        ]
      },
      {
        "cityName": "荆门市",
        "cityCode": "420800000000",
        "counties": [
          {
            "countyCode": "420801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420802000000",
            "countyName": "东宝区"
          },
          {
            "countyCode": "420804000000",
            "countyName": "掇刀区"
          },
          {
            "countyCode": "420822000000",
            "countyName": "沙洋县"
          },
          {
            "countyCode": "420881000000",
            "countyName": "钟祥市"
          },
          {
            "countyCode": "420882000000",
            "countyName": "京山市"
          }
        ]
      },
      {
        "cityName": "孝感市",
        "cityCode": "420900000000",
        "counties": [
          {
            "countyCode": "420901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "420902000000",
            "countyName": "孝南区"
          },
          {
            "countyCode": "420921000000",
            "countyName": "孝昌县"
          },
          {
            "countyCode": "420922000000",
            "countyName": "大悟县"
          },
          {
            "countyCode": "420923000000",
            "countyName": "云梦县"
          },
          {
            "countyCode": "420981000000",
            "countyName": "应城市"
          },
          {
            "countyCode": "420982000000",
            "countyName": "安陆市"
          },
          {
            "countyCode": "420984000000",
            "countyName": "汉川市"
          }
        ]
      },
      {
        "cityName": "荆州市",
        "cityCode": "421000000000",
        "counties": [
          {
            "countyCode": "421001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "421002000000",
            "countyName": "沙市区"
          },
          {
            "countyCode": "421003000000",
            "countyName": "荆州区"
          },
          {
            "countyCode": "421022000000",
            "countyName": "公安县"
          },
          {
            "countyCode": "421023000000",
            "countyName": "监利县"
          },
          {
            "countyCode": "421024000000",
            "countyName": "江陵县"
          },
          {
            "countyCode": "421071000000",
            "countyName": "荆州经济技术开发区"
          },
          {
            "countyCode": "421081000000",
            "countyName": "石首市"
          },
          {
            "countyCode": "421083000000",
            "countyName": "洪湖市"
          },
          {
            "countyCode": "421087000000",
            "countyName": "松滋市"
          }
        ]
      },
      {
        "cityName": "黄冈市",
        "cityCode": "421100000000",
        "counties": [
          {
            "countyCode": "421101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "421102000000",
            "countyName": "黄州区"
          },
          {
            "countyCode": "421121000000",
            "countyName": "团风县"
          },
          {
            "countyCode": "421122000000",
            "countyName": "红安县"
          },
          {
            "countyCode": "421123000000",
            "countyName": "罗田县"
          },
          {
            "countyCode": "421124000000",
            "countyName": "英山县"
          },
          {
            "countyCode": "421125000000",
            "countyName": "浠水县"
          },
          {
            "countyCode": "421126000000",
            "countyName": "蕲春县"
          },
          {
            "countyCode": "421127000000",
            "countyName": "黄梅县"
          },
          {
            "countyCode": "421171000000",
            "countyName": "龙感湖管理区"
          },
          {
            "countyCode": "421181000000",
            "countyName": "麻城市"
          },
          {
            "countyCode": "421182000000",
            "countyName": "武穴市"
          }
        ]
      },
      {
        "cityName": "咸宁市",
        "cityCode": "421200000000",
        "counties": [
          {
            "countyCode": "421201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "421202000000",
            "countyName": "咸安区"
          },
          {
            "countyCode": "421221000000",
            "countyName": "嘉鱼县"
          },
          {
            "countyCode": "421222000000",
            "countyName": "通城县"
          },
          {
            "countyCode": "421223000000",
            "countyName": "崇阳县"
          },
          {
            "countyCode": "421224000000",
            "countyName": "通山县"
          },
          {
            "countyCode": "421281000000",
            "countyName": "赤壁市"
          }
        ]
      },
      {
        "cityName": "随州市",
        "cityCode": "421300000000",
        "counties": [
          {
            "countyCode": "421301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "421303000000",
            "countyName": "曾都区"
          },
          {
            "countyCode": "421321000000",
            "countyName": "随县"
          },
          {
            "countyCode": "421381000000",
            "countyName": "广水市"
          }
        ]
      },
      {
        "cityName": "恩施土家族苗族自治州",
        "cityCode": "422800000000",
        "counties": [
          {
            "countyCode": "422801000000",
            "countyName": "恩施市"
          },
          {
            "countyCode": "422802000000",
            "countyName": "利川市"
          },
          {
            "countyCode": "422822000000",
            "countyName": "建始县"
          },
          {
            "countyCode": "422823000000",
            "countyName": "巴东县"
          },
          {
            "countyCode": "422825000000",
            "countyName": "宣恩县"
          },
          {
            "countyCode": "422826000000",
            "countyName": "咸丰县"
          },
          {
            "countyCode": "422827000000",
            "countyName": "来凤县"
          },
          {
            "countyCode": "422828000000",
            "countyName": "鹤峰县"
          }
        ]
      },
      {
        "cityName": "省直辖县级行政区划",
        "cityCode": "429000000000",
        "counties": [
          {
            "countyCode": "429004000000",
            "countyName": "仙桃市"
          },
          {
            "countyCode": "429005000000",
            "countyName": "潜江市"
          },
          {
            "countyCode": "429006000000",
            "countyName": "天门市"
          },
          {
            "countyCode": "429021000000",
            "countyName": "神农架林区"
          }
        ]
      }
    ],
    "provinceCode": "420000000000",
    "provinceName": "湖北省"
  },
  {
    "cities": [
      {
        "cityName": "长沙市",
        "cityCode": "430100000000",
        "counties": [
          {
            "countyCode": "430101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430102000000",
            "countyName": "芙蓉区"
          },
          {
            "countyCode": "430103000000",
            "countyName": "天心区"
          },
          {
            "countyCode": "430104000000",
            "countyName": "岳麓区"
          },
          {
            "countyCode": "430105000000",
            "countyName": "开福区"
          },
          {
            "countyCode": "430111000000",
            "countyName": "雨花区"
          },
          {
            "countyCode": "430112000000",
            "countyName": "望城区"
          },
          {
            "countyCode": "430121000000",
            "countyName": "长沙县"
          },
          {
            "countyCode": "430181000000",
            "countyName": "浏阳市"
          },
          {
            "countyCode": "430182000000",
            "countyName": "宁乡市"
          }
        ]
      },
      {
        "cityName": "株洲市",
        "cityCode": "430200000000",
        "counties": [
          {
            "countyCode": "430201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430202000000",
            "countyName": "荷塘区"
          },
          {
            "countyCode": "430203000000",
            "countyName": "芦淞区"
          },
          {
            "countyCode": "430204000000",
            "countyName": "石峰区"
          },
          {
            "countyCode": "430211000000",
            "countyName": "天元区"
          },
          {
            "countyCode": "430212000000",
            "countyName": "渌口区"
          },
          {
            "countyCode": "430223000000",
            "countyName": "攸县"
          },
          {
            "countyCode": "430224000000",
            "countyName": "茶陵县"
          },
          {
            "countyCode": "430225000000",
            "countyName": "炎陵县"
          },
          {
            "countyCode": "430271000000",
            "countyName": "云龙示范区"
          },
          {
            "countyCode": "430281000000",
            "countyName": "醴陵市"
          }
        ]
      },
      {
        "cityName": "湘潭市",
        "cityCode": "430300000000",
        "counties": [
          {
            "countyCode": "430301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430302000000",
            "countyName": "雨湖区"
          },
          {
            "countyCode": "430304000000",
            "countyName": "岳塘区"
          },
          {
            "countyCode": "430321000000",
            "countyName": "湘潭县"
          },
          {
            "countyCode": "430371000000",
            "countyName": "湖南湘潭高新技术产业园区"
          },
          {
            "countyCode": "430372000000",
            "countyName": "湘潭昭山示范区"
          },
          {
            "countyCode": "430373000000",
            "countyName": "湘潭九华示范区"
          },
          {
            "countyCode": "430381000000",
            "countyName": "湘乡市"
          },
          {
            "countyCode": "430382000000",
            "countyName": "韶山市"
          }
        ]
      },
      {
        "cityName": "衡阳市",
        "cityCode": "430400000000",
        "counties": [
          {
            "countyCode": "430401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430405000000",
            "countyName": "珠晖区"
          },
          {
            "countyCode": "430406000000",
            "countyName": "雁峰区"
          },
          {
            "countyCode": "430407000000",
            "countyName": "石鼓区"
          },
          {
            "countyCode": "430408000000",
            "countyName": "蒸湘区"
          },
          {
            "countyCode": "430412000000",
            "countyName": "南岳区"
          },
          {
            "countyCode": "430421000000",
            "countyName": "衡阳县"
          },
          {
            "countyCode": "430422000000",
            "countyName": "衡南县"
          },
          {
            "countyCode": "430423000000",
            "countyName": "衡山县"
          },
          {
            "countyCode": "430424000000",
            "countyName": "衡东县"
          },
          {
            "countyCode": "430426000000",
            "countyName": "祁东县"
          },
          {
            "countyCode": "430471000000",
            "countyName": "衡阳综合保税区"
          },
          {
            "countyCode": "430472000000",
            "countyName": "湖南衡阳高新技术产业园区"
          },
          {
            "countyCode": "430473000000",
            "countyName": "湖南衡阳松木经济开发区"
          },
          {
            "countyCode": "430481000000",
            "countyName": "耒阳市"
          },
          {
            "countyCode": "430482000000",
            "countyName": "常宁市"
          }
        ]
      },
      {
        "cityName": "邵阳市",
        "cityCode": "430500000000",
        "counties": [
          {
            "countyCode": "430501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430502000000",
            "countyName": "双清区"
          },
          {
            "countyCode": "430503000000",
            "countyName": "大祥区"
          },
          {
            "countyCode": "430511000000",
            "countyName": "北塔区"
          },
          {
            "countyCode": "430521000000",
            "countyName": "邵东县"
          },
          {
            "countyCode": "430522000000",
            "countyName": "新邵县"
          },
          {
            "countyCode": "430523000000",
            "countyName": "邵阳县"
          },
          {
            "countyCode": "430524000000",
            "countyName": "隆回县"
          },
          {
            "countyCode": "430525000000",
            "countyName": "洞口县"
          },
          {
            "countyCode": "430527000000",
            "countyName": "绥宁县"
          },
          {
            "countyCode": "430528000000",
            "countyName": "新宁县"
          },
          {
            "countyCode": "430529000000",
            "countyName": "城步苗族自治县"
          },
          {
            "countyCode": "430581000000",
            "countyName": "武冈市"
          }
        ]
      },
      {
        "cityName": "岳阳市",
        "cityCode": "430600000000",
        "counties": [
          {
            "countyCode": "430601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430602000000",
            "countyName": "岳阳楼区"
          },
          {
            "countyCode": "430603000000",
            "countyName": "云溪区"
          },
          {
            "countyCode": "430611000000",
            "countyName": "君山区"
          },
          {
            "countyCode": "430621000000",
            "countyName": "岳阳县"
          },
          {
            "countyCode": "430623000000",
            "countyName": "华容县"
          },
          {
            "countyCode": "430624000000",
            "countyName": "湘阴县"
          },
          {
            "countyCode": "430626000000",
            "countyName": "平江县"
          },
          {
            "countyCode": "430671000000",
            "countyName": "岳阳市屈原管理区"
          },
          {
            "countyCode": "430681000000",
            "countyName": "汨罗市"
          },
          {
            "countyCode": "430682000000",
            "countyName": "临湘市"
          }
        ]
      },
      {
        "cityName": "常德市",
        "cityCode": "430700000000",
        "counties": [
          {
            "countyCode": "430701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430702000000",
            "countyName": "武陵区"
          },
          {
            "countyCode": "430703000000",
            "countyName": "鼎城区"
          },
          {
            "countyCode": "430721000000",
            "countyName": "安乡县"
          },
          {
            "countyCode": "430722000000",
            "countyName": "汉寿县"
          },
          {
            "countyCode": "430723000000",
            "countyName": "澧县"
          },
          {
            "countyCode": "430724000000",
            "countyName": "临澧县"
          },
          {
            "countyCode": "430725000000",
            "countyName": "桃源县"
          },
          {
            "countyCode": "430726000000",
            "countyName": "石门县"
          },
          {
            "countyCode": "430771000000",
            "countyName": "常德市西洞庭管理区"
          },
          {
            "countyCode": "430781000000",
            "countyName": "津市市"
          }
        ]
      },
      {
        "cityName": "张家界市",
        "cityCode": "430800000000",
        "counties": [
          {
            "countyCode": "430801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430802000000",
            "countyName": "永定区"
          },
          {
            "countyCode": "430811000000",
            "countyName": "武陵源区"
          },
          {
            "countyCode": "430821000000",
            "countyName": "慈利县"
          },
          {
            "countyCode": "430822000000",
            "countyName": "桑植县"
          }
        ]
      },
      {
        "cityName": "益阳市",
        "cityCode": "430900000000",
        "counties": [
          {
            "countyCode": "430901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "430902000000",
            "countyName": "资阳区"
          },
          {
            "countyCode": "430903000000",
            "countyName": "赫山区"
          },
          {
            "countyCode": "430921000000",
            "countyName": "南县"
          },
          {
            "countyCode": "430922000000",
            "countyName": "桃江县"
          },
          {
            "countyCode": "430923000000",
            "countyName": "安化县"
          },
          {
            "countyCode": "430971000000",
            "countyName": "益阳市大通湖管理区"
          },
          {
            "countyCode": "430972000000",
            "countyName": "湖南益阳高新技术产业园区"
          },
          {
            "countyCode": "430981000000",
            "countyName": "沅江市"
          }
        ]
      },
      {
        "cityName": "郴州市",
        "cityCode": "431000000000",
        "counties": [
          {
            "countyCode": "431001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "431002000000",
            "countyName": "北湖区"
          },
          {
            "countyCode": "431003000000",
            "countyName": "苏仙区"
          },
          {
            "countyCode": "431021000000",
            "countyName": "桂阳县"
          },
          {
            "countyCode": "431022000000",
            "countyName": "宜章县"
          },
          {
            "countyCode": "431023000000",
            "countyName": "永兴县"
          },
          {
            "countyCode": "431024000000",
            "countyName": "嘉禾县"
          },
          {
            "countyCode": "431025000000",
            "countyName": "临武县"
          },
          {
            "countyCode": "431026000000",
            "countyName": "汝城县"
          },
          {
            "countyCode": "431027000000",
            "countyName": "桂东县"
          },
          {
            "countyCode": "431028000000",
            "countyName": "安仁县"
          },
          {
            "countyCode": "431081000000",
            "countyName": "资兴市"
          }
        ]
      },
      {
        "cityName": "永州市",
        "cityCode": "431100000000",
        "counties": [
          {
            "countyCode": "431101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "431102000000",
            "countyName": "零陵区"
          },
          {
            "countyCode": "431103000000",
            "countyName": "冷水滩区"
          },
          {
            "countyCode": "431121000000",
            "countyName": "祁阳县"
          },
          {
            "countyCode": "431122000000",
            "countyName": "东安县"
          },
          {
            "countyCode": "431123000000",
            "countyName": "双牌县"
          },
          {
            "countyCode": "431124000000",
            "countyName": "道县"
          },
          {
            "countyCode": "431125000000",
            "countyName": "江永县"
          },
          {
            "countyCode": "431126000000",
            "countyName": "宁远县"
          },
          {
            "countyCode": "431127000000",
            "countyName": "蓝山县"
          },
          {
            "countyCode": "431128000000",
            "countyName": "新田县"
          },
          {
            "countyCode": "431129000000",
            "countyName": "江华瑶族自治县"
          },
          {
            "countyCode": "431171000000",
            "countyName": "永州经济技术开发区"
          },
          {
            "countyCode": "431172000000",
            "countyName": "永州市金洞管理区"
          },
          {
            "countyCode": "431173000000",
            "countyName": "永州市回龙圩管理区"
          }
        ]
      },
      {
        "cityName": "怀化市",
        "cityCode": "431200000000",
        "counties": [
          {
            "countyCode": "431201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "431202000000",
            "countyName": "鹤城区"
          },
          {
            "countyCode": "431221000000",
            "countyName": "中方县"
          },
          {
            "countyCode": "431222000000",
            "countyName": "沅陵县"
          },
          {
            "countyCode": "431223000000",
            "countyName": "辰溪县"
          },
          {
            "countyCode": "431224000000",
            "countyName": "溆浦县"
          },
          {
            "countyCode": "431225000000",
            "countyName": "会同县"
          },
          {
            "countyCode": "431226000000",
            "countyName": "麻阳苗族自治县"
          },
          {
            "countyCode": "431227000000",
            "countyName": "新晃侗族自治县"
          },
          {
            "countyCode": "431228000000",
            "countyName": "芷江侗族自治县"
          },
          {
            "countyCode": "431229000000",
            "countyName": "靖州苗族侗族自治县"
          },
          {
            "countyCode": "431230000000",
            "countyName": "通道侗族自治县"
          },
          {
            "countyCode": "431271000000",
            "countyName": "怀化市洪江管理区"
          },
          {
            "countyCode": "431281000000",
            "countyName": "洪江市"
          }
        ]
      },
      {
        "cityName": "娄底市",
        "cityCode": "431300000000",
        "counties": [
          {
            "countyCode": "431301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "431302000000",
            "countyName": "娄星区"
          },
          {
            "countyCode": "431321000000",
            "countyName": "双峰县"
          },
          {
            "countyCode": "431322000000",
            "countyName": "新化县"
          },
          {
            "countyCode": "431381000000",
            "countyName": "冷水江市"
          },
          {
            "countyCode": "431382000000",
            "countyName": "涟源市"
          }
        ]
      },
      {
        "cityName": "湘西土家族苗族自治州",
        "cityCode": "433100000000",
        "counties": [
          {
            "countyCode": "433101000000",
            "countyName": "吉首市"
          },
          {
            "countyCode": "433122000000",
            "countyName": "泸溪县"
          },
          {
            "countyCode": "433123000000",
            "countyName": "凤凰县"
          },
          {
            "countyCode": "433124000000",
            "countyName": "花垣县"
          },
          {
            "countyCode": "433125000000",
            "countyName": "保靖县"
          },
          {
            "countyCode": "433126000000",
            "countyName": "古丈县"
          },
          {
            "countyCode": "433127000000",
            "countyName": "永顺县"
          },
          {
            "countyCode": "433130000000",
            "countyName": "龙山县"
          },
          {
            "countyCode": "433172000000",
            "countyName": "湖南吉首经济开发区"
          },
          {
            "countyCode": "433173000000",
            "countyName": "湖南永顺经济开发区"
          }
        ]
      }
    ],
    "provinceCode": "430000000000",
    "provinceName": "湖南省"
  },
  {
    "cities": [
      {
        "cityName": "广州市",
        "cityCode": "440100000000",
        "counties": [
          {
            "countyCode": "440101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440103000000",
            "countyName": "荔湾区"
          },
          {
            "countyCode": "440104000000",
            "countyName": "越秀区"
          },
          {
            "countyCode": "440105000000",
            "countyName": "海珠区"
          },
          {
            "countyCode": "440106000000",
            "countyName": "天河区"
          },
          {
            "countyCode": "440111000000",
            "countyName": "白云区"
          },
          {
            "countyCode": "440112000000",
            "countyName": "黄埔区"
          },
          {
            "countyCode": "440113000000",
            "countyName": "番禺区"
          },
          {
            "countyCode": "440114000000",
            "countyName": "花都区"
          },
          {
            "countyCode": "440115000000",
            "countyName": "南沙区"
          },
          {
            "countyCode": "440117000000",
            "countyName": "从化区"
          },
          {
            "countyCode": "440118000000",
            "countyName": "增城区"
          }
        ]
      },
      {
        "cityName": "韶关市",
        "cityCode": "440200000000",
        "counties": [
          {
            "countyCode": "440201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440203000000",
            "countyName": "武江区"
          },
          {
            "countyCode": "440204000000",
            "countyName": "浈江区"
          },
          {
            "countyCode": "440205000000",
            "countyName": "曲江区"
          },
          {
            "countyCode": "440222000000",
            "countyName": "始兴县"
          },
          {
            "countyCode": "440224000000",
            "countyName": "仁化县"
          },
          {
            "countyCode": "440229000000",
            "countyName": "翁源县"
          },
          {
            "countyCode": "440232000000",
            "countyName": "乳源瑶族自治县"
          },
          {
            "countyCode": "440233000000",
            "countyName": "新丰县"
          },
          {
            "countyCode": "440281000000",
            "countyName": "乐昌市"
          },
          {
            "countyCode": "440282000000",
            "countyName": "南雄市"
          }
        ]
      },
      {
        "cityName": "深圳市",
        "cityCode": "440300000000",
        "counties": [
          {
            "countyCode": "440301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440303000000",
            "countyName": "罗湖区"
          },
          {
            "countyCode": "440304000000",
            "countyName": "福田区"
          },
          {
            "countyCode": "440305000000",
            "countyName": "南山区"
          },
          {
            "countyCode": "440306000000",
            "countyName": "宝安区"
          },
          {
            "countyCode": "440307000000",
            "countyName": "龙岗区"
          },
          {
            "countyCode": "440308000000",
            "countyName": "盐田区"
          },
          {
            "countyCode": "440309000000",
            "countyName": "龙华区"
          },
          {
            "countyCode": "440310000000",
            "countyName": "坪山区"
          },
          {
            "countyCode": "440311000000",
            "countyName": "光明区"
          }
        ]
      },
      {
        "cityName": "珠海市",
        "cityCode": "440400000000",
        "counties": [
          {
            "countyCode": "440401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440402000000",
            "countyName": "香洲区"
          },
          {
            "countyCode": "440403000000",
            "countyName": "斗门区"
          },
          {
            "countyCode": "440404000000",
            "countyName": "金湾区"
          }
        ]
      },
      {
        "cityName": "汕头市",
        "cityCode": "440500000000",
        "counties": [
          {
            "countyCode": "440501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440507000000",
            "countyName": "龙湖区"
          },
          {
            "countyCode": "440511000000",
            "countyName": "金平区"
          },
          {
            "countyCode": "440512000000",
            "countyName": "濠江区"
          },
          {
            "countyCode": "440513000000",
            "countyName": "潮阳区"
          },
          {
            "countyCode": "440514000000",
            "countyName": "潮南区"
          },
          {
            "countyCode": "440515000000",
            "countyName": "澄海区"
          },
          {
            "countyCode": "440523000000",
            "countyName": "南澳县"
          }
        ]
      },
      {
        "cityName": "佛山市",
        "cityCode": "440600000000",
        "counties": [
          {
            "countyCode": "440601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440604000000",
            "countyName": "禅城区"
          },
          {
            "countyCode": "440605000000",
            "countyName": "南海区"
          },
          {
            "countyCode": "440606000000",
            "countyName": "顺德区"
          },
          {
            "countyCode": "440607000000",
            "countyName": "三水区"
          },
          {
            "countyCode": "440608000000",
            "countyName": "高明区"
          }
        ]
      },
      {
        "cityName": "江门市",
        "cityCode": "440700000000",
        "counties": [
          {
            "countyCode": "440701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440703000000",
            "countyName": "蓬江区"
          },
          {
            "countyCode": "440704000000",
            "countyName": "江海区"
          },
          {
            "countyCode": "440705000000",
            "countyName": "新会区"
          },
          {
            "countyCode": "440781000000",
            "countyName": "台山市"
          },
          {
            "countyCode": "440783000000",
            "countyName": "开平市"
          },
          {
            "countyCode": "440784000000",
            "countyName": "鹤山市"
          },
          {
            "countyCode": "440785000000",
            "countyName": "恩平市"
          }
        ]
      },
      {
        "cityName": "湛江市",
        "cityCode": "440800000000",
        "counties": [
          {
            "countyCode": "440801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440802000000",
            "countyName": "赤坎区"
          },
          {
            "countyCode": "440803000000",
            "countyName": "霞山区"
          },
          {
            "countyCode": "440804000000",
            "countyName": "坡头区"
          },
          {
            "countyCode": "440811000000",
            "countyName": "麻章区"
          },
          {
            "countyCode": "440823000000",
            "countyName": "遂溪县"
          },
          {
            "countyCode": "440825000000",
            "countyName": "徐闻县"
          },
          {
            "countyCode": "440881000000",
            "countyName": "廉江市"
          },
          {
            "countyCode": "440882000000",
            "countyName": "雷州市"
          },
          {
            "countyCode": "440883000000",
            "countyName": "吴川市"
          }
        ]
      },
      {
        "cityName": "茂名市",
        "cityCode": "440900000000",
        "counties": [
          {
            "countyCode": "440901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "440902000000",
            "countyName": "茂南区"
          },
          {
            "countyCode": "440904000000",
            "countyName": "电白区"
          },
          {
            "countyCode": "440981000000",
            "countyName": "高州市"
          },
          {
            "countyCode": "440982000000",
            "countyName": "化州市"
          },
          {
            "countyCode": "440983000000",
            "countyName": "信宜市"
          }
        ]
      },
      {
        "cityName": "肇庆市",
        "cityCode": "441200000000",
        "counties": [
          {
            "countyCode": "441201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441202000000",
            "countyName": "端州区"
          },
          {
            "countyCode": "441203000000",
            "countyName": "鼎湖区"
          },
          {
            "countyCode": "441204000000",
            "countyName": "高要区"
          },
          {
            "countyCode": "441223000000",
            "countyName": "广宁县"
          },
          {
            "countyCode": "441224000000",
            "countyName": "怀集县"
          },
          {
            "countyCode": "441225000000",
            "countyName": "封开县"
          },
          {
            "countyCode": "441226000000",
            "countyName": "德庆县"
          },
          {
            "countyCode": "441284000000",
            "countyName": "四会市"
          }
        ]
      },
      {
        "cityName": "惠州市",
        "cityCode": "441300000000",
        "counties": [
          {
            "countyCode": "441301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441302000000",
            "countyName": "惠城区"
          },
          {
            "countyCode": "441303000000",
            "countyName": "惠阳区"
          },
          {
            "countyCode": "441322000000",
            "countyName": "博罗县"
          },
          {
            "countyCode": "441323000000",
            "countyName": "惠东县"
          },
          {
            "countyCode": "441324000000",
            "countyName": "龙门县"
          }
        ]
      },
      {
        "cityName": "梅州市",
        "cityCode": "441400000000",
        "counties": [
          {
            "countyCode": "441401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441402000000",
            "countyName": "梅江区"
          },
          {
            "countyCode": "441403000000",
            "countyName": "梅县区"
          },
          {
            "countyCode": "441422000000",
            "countyName": "大埔县"
          },
          {
            "countyCode": "441423000000",
            "countyName": "丰顺县"
          },
          {
            "countyCode": "441424000000",
            "countyName": "五华县"
          },
          {
            "countyCode": "441426000000",
            "countyName": "平远县"
          },
          {
            "countyCode": "441427000000",
            "countyName": "蕉岭县"
          },
          {
            "countyCode": "441481000000",
            "countyName": "兴宁市"
          }
        ]
      },
      {
        "cityName": "汕尾市",
        "cityCode": "441500000000",
        "counties": [
          {
            "countyCode": "441501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441502000000",
            "countyName": "城区"
          },
          {
            "countyCode": "441521000000",
            "countyName": "海丰县"
          },
          {
            "countyCode": "441523000000",
            "countyName": "陆河县"
          },
          {
            "countyCode": "441581000000",
            "countyName": "陆丰市"
          }
        ]
      },
      {
        "cityName": "河源市",
        "cityCode": "441600000000",
        "counties": [
          {
            "countyCode": "441601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441602000000",
            "countyName": "源城区"
          },
          {
            "countyCode": "441621000000",
            "countyName": "紫金县"
          },
          {
            "countyCode": "441622000000",
            "countyName": "龙川县"
          },
          {
            "countyCode": "441623000000",
            "countyName": "连平县"
          },
          {
            "countyCode": "441624000000",
            "countyName": "和平县"
          },
          {
            "countyCode": "441625000000",
            "countyName": "东源县"
          }
        ]
      },
      {
        "cityName": "阳江市",
        "cityCode": "441700000000",
        "counties": [
          {
            "countyCode": "441701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441702000000",
            "countyName": "江城区"
          },
          {
            "countyCode": "441704000000",
            "countyName": "阳东区"
          },
          {
            "countyCode": "441721000000",
            "countyName": "阳西县"
          },
          {
            "countyCode": "441781000000",
            "countyName": "阳春市"
          }
        ]
      },
      {
        "cityName": "清远市",
        "cityCode": "441800000000",
        "counties": [
          {
            "countyCode": "441801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "441802000000",
            "countyName": "清城区"
          },
          {
            "countyCode": "441803000000",
            "countyName": "清新区"
          },
          {
            "countyCode": "441821000000",
            "countyName": "佛冈县"
          },
          {
            "countyCode": "441823000000",
            "countyName": "阳山县"
          },
          {
            "countyCode": "441825000000",
            "countyName": "连山壮族瑶族自治县"
          },
          {
            "countyCode": "441826000000",
            "countyName": "连南瑶族自治县"
          },
          {
            "countyCode": "441881000000",
            "countyName": "英德市"
          },
          {
            "countyCode": "441882000000",
            "countyName": "连州市"
          }
        ]
      },
      {
        "cityName": "东莞市",
        "cityCode": "441900000000",
        "counties": [
          {
            "countyCode": "441900000000",
            "countyName": "东莞市"
          }
        ]
      },
      {
        "cityName": "中山市",
        "cityCode": "442000000000",
        "counties": [
          {
            "countyCode": "442000000000",
            "countyName": "中山市"
          }
        ]
      },
      {
        "cityName": "潮州市",
        "cityCode": "445100000000",
        "counties": [
          {
            "countyCode": "445101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "445102000000",
            "countyName": "湘桥区"
          },
          {
            "countyCode": "445103000000",
            "countyName": "潮安区"
          },
          {
            "countyCode": "445122000000",
            "countyName": "饶平县"
          }
        ]
      },
      {
        "cityName": "揭阳市",
        "cityCode": "445200000000",
        "counties": [
          {
            "countyCode": "445201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "445202000000",
            "countyName": "榕城区"
          },
          {
            "countyCode": "445203000000",
            "countyName": "揭东区"
          },
          {
            "countyCode": "445222000000",
            "countyName": "揭西县"
          },
          {
            "countyCode": "445224000000",
            "countyName": "惠来县"
          },
          {
            "countyCode": "445281000000",
            "countyName": "普宁市"
          }
        ]
      },
      {
        "cityName": "云浮市",
        "cityCode": "445300000000",
        "counties": [
          {
            "countyCode": "445301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "445302000000",
            "countyName": "云城区"
          },
          {
            "countyCode": "445303000000",
            "countyName": "云安区"
          },
          {
            "countyCode": "445321000000",
            "countyName": "新兴县"
          },
          {
            "countyCode": "445322000000",
            "countyName": "郁南县"
          },
          {
            "countyCode": "445381000000",
            "countyName": "罗定市"
          }
        ]
      }
    ],
    "provinceCode": "440000000000",
    "provinceName": "广东省"
  },
  {
    "cities": [
      {
        "cityName": "南宁市",
        "cityCode": "450100000000",
        "counties": [
          {
            "countyCode": "450101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450102000000",
            "countyName": "兴宁区"
          },
          {
            "countyCode": "450103000000",
            "countyName": "青秀区"
          },
          {
            "countyCode": "450105000000",
            "countyName": "江南区"
          },
          {
            "countyCode": "450107000000",
            "countyName": "西乡塘区"
          },
          {
            "countyCode": "450108000000",
            "countyName": "良庆区"
          },
          {
            "countyCode": "450109000000",
            "countyName": "邕宁区"
          },
          {
            "countyCode": "450110000000",
            "countyName": "武鸣区"
          },
          {
            "countyCode": "450123000000",
            "countyName": "隆安县"
          },
          {
            "countyCode": "450124000000",
            "countyName": "马山县"
          },
          {
            "countyCode": "450125000000",
            "countyName": "上林县"
          },
          {
            "countyCode": "450126000000",
            "countyName": "宾阳县"
          },
          {
            "countyCode": "450127000000",
            "countyName": "横县"
          }
        ]
      },
      {
        "cityName": "柳州市",
        "cityCode": "450200000000",
        "counties": [
          {
            "countyCode": "450201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450202000000",
            "countyName": "城中区"
          },
          {
            "countyCode": "450203000000",
            "countyName": "鱼峰区"
          },
          {
            "countyCode": "450204000000",
            "countyName": "柳南区"
          },
          {
            "countyCode": "450205000000",
            "countyName": "柳北区"
          },
          {
            "countyCode": "450206000000",
            "countyName": "柳江区"
          },
          {
            "countyCode": "450222000000",
            "countyName": "柳城县"
          },
          {
            "countyCode": "450223000000",
            "countyName": "鹿寨县"
          },
          {
            "countyCode": "450224000000",
            "countyName": "融安县"
          },
          {
            "countyCode": "450225000000",
            "countyName": "融水苗族自治县"
          },
          {
            "countyCode": "450226000000",
            "countyName": "三江侗族自治县"
          }
        ]
      },
      {
        "cityName": "桂林市",
        "cityCode": "450300000000",
        "counties": [
          {
            "countyCode": "450301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450302000000",
            "countyName": "秀峰区"
          },
          {
            "countyCode": "450303000000",
            "countyName": "叠彩区"
          },
          {
            "countyCode": "450304000000",
            "countyName": "象山区"
          },
          {
            "countyCode": "450305000000",
            "countyName": "七星区"
          },
          {
            "countyCode": "450311000000",
            "countyName": "雁山区"
          },
          {
            "countyCode": "450312000000",
            "countyName": "临桂区"
          },
          {
            "countyCode": "450321000000",
            "countyName": "阳朔县"
          },
          {
            "countyCode": "450323000000",
            "countyName": "灵川县"
          },
          {
            "countyCode": "450324000000",
            "countyName": "全州县"
          },
          {
            "countyCode": "450325000000",
            "countyName": "兴安县"
          },
          {
            "countyCode": "450326000000",
            "countyName": "永福县"
          },
          {
            "countyCode": "450327000000",
            "countyName": "灌阳县"
          },
          {
            "countyCode": "450328000000",
            "countyName": "龙胜各族自治县"
          },
          {
            "countyCode": "450329000000",
            "countyName": "资源县"
          },
          {
            "countyCode": "450330000000",
            "countyName": "平乐县"
          },
          {
            "countyCode": "450332000000",
            "countyName": "恭城瑶族自治县"
          },
          {
            "countyCode": "450381000000",
            "countyName": "荔浦市"
          }
        ]
      },
      {
        "cityName": "梧州市",
        "cityCode": "450400000000",
        "counties": [
          {
            "countyCode": "450401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450403000000",
            "countyName": "万秀区"
          },
          {
            "countyCode": "450405000000",
            "countyName": "长洲区"
          },
          {
            "countyCode": "450406000000",
            "countyName": "龙圩区"
          },
          {
            "countyCode": "450421000000",
            "countyName": "苍梧县"
          },
          {
            "countyCode": "450422000000",
            "countyName": "藤县"
          },
          {
            "countyCode": "450423000000",
            "countyName": "蒙山县"
          },
          {
            "countyCode": "450481000000",
            "countyName": "岑溪市"
          }
        ]
      },
      {
        "cityName": "北海市",
        "cityCode": "450500000000",
        "counties": [
          {
            "countyCode": "450501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450502000000",
            "countyName": "海城区"
          },
          {
            "countyCode": "450503000000",
            "countyName": "银海区"
          },
          {
            "countyCode": "450512000000",
            "countyName": "铁山港区"
          },
          {
            "countyCode": "450521000000",
            "countyName": "合浦县"
          }
        ]
      },
      {
        "cityName": "防城港市",
        "cityCode": "450600000000",
        "counties": [
          {
            "countyCode": "450601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450602000000",
            "countyName": "港口区"
          },
          {
            "countyCode": "450603000000",
            "countyName": "防城区"
          },
          {
            "countyCode": "450621000000",
            "countyName": "上思县"
          },
          {
            "countyCode": "450681000000",
            "countyName": "东兴市"
          }
        ]
      },
      {
        "cityName": "钦州市",
        "cityCode": "450700000000",
        "counties": [
          {
            "countyCode": "450701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450702000000",
            "countyName": "钦南区"
          },
          {
            "countyCode": "450703000000",
            "countyName": "钦北区"
          },
          {
            "countyCode": "450721000000",
            "countyName": "灵山县"
          },
          {
            "countyCode": "450722000000",
            "countyName": "浦北县"
          }
        ]
      },
      {
        "cityName": "贵港市",
        "cityCode": "450800000000",
        "counties": [
          {
            "countyCode": "450801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450802000000",
            "countyName": "港北区"
          },
          {
            "countyCode": "450803000000",
            "countyName": "港南区"
          },
          {
            "countyCode": "450804000000",
            "countyName": "覃塘区"
          },
          {
            "countyCode": "450821000000",
            "countyName": "平南县"
          },
          {
            "countyCode": "450881000000",
            "countyName": "桂平市"
          }
        ]
      },
      {
        "cityName": "玉林市",
        "cityCode": "450900000000",
        "counties": [
          {
            "countyCode": "450901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "450902000000",
            "countyName": "玉州区"
          },
          {
            "countyCode": "450903000000",
            "countyName": "福绵区"
          },
          {
            "countyCode": "450921000000",
            "countyName": "容县"
          },
          {
            "countyCode": "450922000000",
            "countyName": "陆川县"
          },
          {
            "countyCode": "450923000000",
            "countyName": "博白县"
          },
          {
            "countyCode": "450924000000",
            "countyName": "兴业县"
          },
          {
            "countyCode": "450981000000",
            "countyName": "北流市"
          }
        ]
      },
      {
        "cityName": "百色市",
        "cityCode": "451000000000",
        "counties": [
          {
            "countyCode": "451001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "451002000000",
            "countyName": "右江区"
          },
          {
            "countyCode": "451021000000",
            "countyName": "田阳县"
          },
          {
            "countyCode": "451022000000",
            "countyName": "田东县"
          },
          {
            "countyCode": "451023000000",
            "countyName": "平果县"
          },
          {
            "countyCode": "451024000000",
            "countyName": "德保县"
          },
          {
            "countyCode": "451026000000",
            "countyName": "那坡县"
          },
          {
            "countyCode": "451027000000",
            "countyName": "凌云县"
          },
          {
            "countyCode": "451028000000",
            "countyName": "乐业县"
          },
          {
            "countyCode": "451029000000",
            "countyName": "田林县"
          },
          {
            "countyCode": "451030000000",
            "countyName": "西林县"
          },
          {
            "countyCode": "451031000000",
            "countyName": "隆林各族自治县"
          },
          {
            "countyCode": "451081000000",
            "countyName": "靖西市"
          }
        ]
      },
      {
        "cityName": "贺州市",
        "cityCode": "451100000000",
        "counties": [
          {
            "countyCode": "451101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "451102000000",
            "countyName": "八步区"
          },
          {
            "countyCode": "451103000000",
            "countyName": "平桂区"
          },
          {
            "countyCode": "451121000000",
            "countyName": "昭平县"
          },
          {
            "countyCode": "451122000000",
            "countyName": "钟山县"
          },
          {
            "countyCode": "451123000000",
            "countyName": "富川瑶族自治县"
          }
        ]
      },
      {
        "cityName": "河池市",
        "cityCode": "451200000000",
        "counties": [
          {
            "countyCode": "451201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "451202000000",
            "countyName": "金城江区"
          },
          {
            "countyCode": "451203000000",
            "countyName": "宜州区"
          },
          {
            "countyCode": "451221000000",
            "countyName": "南丹县"
          },
          {
            "countyCode": "451222000000",
            "countyName": "天峨县"
          },
          {
            "countyCode": "451223000000",
            "countyName": "凤山县"
          },
          {
            "countyCode": "451224000000",
            "countyName": "东兰县"
          },
          {
            "countyCode": "451225000000",
            "countyName": "罗城仫佬族自治县"
          },
          {
            "countyCode": "451226000000",
            "countyName": "环江毛南族自治县"
          },
          {
            "countyCode": "451227000000",
            "countyName": "巴马瑶族自治县"
          },
          {
            "countyCode": "451228000000",
            "countyName": "都安瑶族自治县"
          },
          {
            "countyCode": "451229000000",
            "countyName": "大化瑶族自治县"
          }
        ]
      },
      {
        "cityName": "来宾市",
        "cityCode": "451300000000",
        "counties": [
          {
            "countyCode": "451301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "451302000000",
            "countyName": "兴宾区"
          },
          {
            "countyCode": "451321000000",
            "countyName": "忻城县"
          },
          {
            "countyCode": "451322000000",
            "countyName": "象州县"
          },
          {
            "countyCode": "451323000000",
            "countyName": "武宣县"
          },
          {
            "countyCode": "451324000000",
            "countyName": "金秀瑶族自治县"
          },
          {
            "countyCode": "451381000000",
            "countyName": "合山市"
          }
        ]
      },
      {
        "cityName": "崇左市",
        "cityCode": "451400000000",
        "counties": [
          {
            "countyCode": "451401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "451402000000",
            "countyName": "江州区"
          },
          {
            "countyCode": "451421000000",
            "countyName": "扶绥县"
          },
          {
            "countyCode": "451422000000",
            "countyName": "宁明县"
          },
          {
            "countyCode": "451423000000",
            "countyName": "龙州县"
          },
          {
            "countyCode": "451424000000",
            "countyName": "大新县"
          },
          {
            "countyCode": "451425000000",
            "countyName": "天等县"
          },
          {
            "countyCode": "451481000000",
            "countyName": "凭祥市"
          }
        ]
      }
    ],
    "provinceCode": "450000000000",
    "provinceName": "广西壮族自治区"
  },
  {
    "cities": [
      {
        "cityName": "海口市",
        "cityCode": "460100000000",
        "counties": [
          {
            "countyCode": "460101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "460105000000",
            "countyName": "秀英区"
          },
          {
            "countyCode": "460106000000",
            "countyName": "龙华区"
          },
          {
            "countyCode": "460107000000",
            "countyName": "琼山区"
          },
          {
            "countyCode": "460108000000",
            "countyName": "美兰区"
          }
        ]
      },
      {
        "cityName": "三亚市",
        "cityCode": "460200000000",
        "counties": [
          {
            "countyCode": "460201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "460202000000",
            "countyName": "海棠区"
          },
          {
            "countyCode": "460203000000",
            "countyName": "吉阳区"
          },
          {
            "countyCode": "460204000000",
            "countyName": "天涯区"
          },
          {
            "countyCode": "460205000000",
            "countyName": "崖州区"
          }
        ]
      },
      {
        "cityName": "三沙市",
        "cityCode": "460300000000",
        "counties": [
          {
            "countyCode": "460321000000",
            "countyName": "西沙群岛"
          },
          {
            "countyCode": "460322000000",
            "countyName": "南沙群岛"
          },
          {
            "countyCode": "460323000000",
            "countyName": "中沙群岛的岛礁及其海域"
          }
        ]
      },
      {
        "cityName": "儋州市",
        "cityCode": "460400000000",
        "counties": [
          {
            "countyCode": "460400000000",
            "countyName": "儋州市"
          }
        ]
      },
      {
        "cityName": "省直辖县级行政区划",
        "cityCode": "469000000000",
        "counties": [
          {
            "countyCode": "469001000000",
            "countyName": "五指山市"
          },
          {
            "countyCode": "469002000000",
            "countyName": "琼海市"
          },
          {
            "countyCode": "469005000000",
            "countyName": "文昌市"
          },
          {
            "countyCode": "469006000000",
            "countyName": "万宁市"
          },
          {
            "countyCode": "469007000000",
            "countyName": "东方市"
          },
          {
            "countyCode": "469021000000",
            "countyName": "定安县"
          },
          {
            "countyCode": "469022000000",
            "countyName": "屯昌县"
          },
          {
            "countyCode": "469023000000",
            "countyName": "澄迈县"
          },
          {
            "countyCode": "469024000000",
            "countyName": "临高县"
          },
          {
            "countyCode": "469025000000",
            "countyName": "白沙黎族自治县"
          },
          {
            "countyCode": "469026000000",
            "countyName": "昌江黎族自治县"
          },
          {
            "countyCode": "469027000000",
            "countyName": "乐东黎族自治县"
          },
          {
            "countyCode": "469028000000",
            "countyName": "陵水黎族自治县"
          },
          {
            "countyCode": "469029000000",
            "countyName": "保亭黎族苗族自治县"
          },
          {
            "countyCode": "469030000000",
            "countyName": "琼中黎族苗族自治县"
          }
        ]
      }
    ],
    "provinceCode": "460000000000",
    "provinceName": "海南省"
  },
  {
    "cities": [
      {
        "cityName": "市辖区",
        "cityCode": "500100000000",
        "counties": [
          {
            "countyCode": "500101000000",
            "countyName": "万州区"
          },
          {
            "countyCode": "500102000000",
            "countyName": "涪陵区"
          },
          {
            "countyCode": "500103000000",
            "countyName": "渝中区"
          },
          {
            "countyCode": "500104000000",
            "countyName": "大渡口区"
          },
          {
            "countyCode": "500105000000",
            "countyName": "江北区"
          },
          {
            "countyCode": "500106000000",
            "countyName": "沙坪坝区"
          },
          {
            "countyCode": "500107000000",
            "countyName": "九龙坡区"
          },
          {
            "countyCode": "500108000000",
            "countyName": "南岸区"
          },
          {
            "countyCode": "500109000000",
            "countyName": "北碚区"
          },
          {
            "countyCode": "500110000000",
            "countyName": "綦江区"
          },
          {
            "countyCode": "500111000000",
            "countyName": "大足区"
          },
          {
            "countyCode": "500112000000",
            "countyName": "渝北区"
          },
          {
            "countyCode": "500113000000",
            "countyName": "巴南区"
          },
          {
            "countyCode": "500114000000",
            "countyName": "黔江区"
          },
          {
            "countyCode": "500115000000",
            "countyName": "长寿区"
          },
          {
            "countyCode": "500116000000",
            "countyName": "江津区"
          },
          {
            "countyCode": "500117000000",
            "countyName": "合川区"
          },
          {
            "countyCode": "500118000000",
            "countyName": "永川区"
          },
          {
            "countyCode": "500119000000",
            "countyName": "南川区"
          },
          {
            "countyCode": "500120000000",
            "countyName": "璧山区"
          },
          {
            "countyCode": "500151000000",
            "countyName": "铜梁区"
          },
          {
            "countyCode": "500152000000",
            "countyName": "潼南区"
          },
          {
            "countyCode": "500153000000",
            "countyName": "荣昌区"
          },
          {
            "countyCode": "500154000000",
            "countyName": "开州区"
          },
          {
            "countyCode": "500155000000",
            "countyName": "梁平区"
          },
          {
            "countyCode": "500156000000",
            "countyName": "武隆区"
          }
        ]
      },
      {
        "cityName": "县",
        "cityCode": "500200000000",
        "counties": [
          {
            "countyCode": "500229000000",
            "countyName": "城口县"
          },
          {
            "countyCode": "500230000000",
            "countyName": "丰都县"
          },
          {
            "countyCode": "500231000000",
            "countyName": "垫江县"
          },
          {
            "countyCode": "500233000000",
            "countyName": "忠县"
          },
          {
            "countyCode": "500235000000",
            "countyName": "云阳县"
          },
          {
            "countyCode": "500236000000",
            "countyName": "奉节县"
          },
          {
            "countyCode": "500237000000",
            "countyName": "巫山县"
          },
          {
            "countyCode": "500238000000",
            "countyName": "巫溪县"
          },
          {
            "countyCode": "500240000000",
            "countyName": "石柱土家族自治县"
          },
          {
            "countyCode": "500241000000",
            "countyName": "秀山土家族苗族自治县"
          },
          {
            "countyCode": "500242000000",
            "countyName": "酉阳土家族苗族自治县"
          },
          {
            "countyCode": "500243000000",
            "countyName": "彭水苗族土家族自治县"
          }
        ]
      }
    ],
    "provinceCode": "500000000000",
    "provinceName": "重庆市"
  },
  {
    "cities": [
      {
        "cityName": "成都市",
        "cityCode": "510100000000",
        "counties": [
          {
            "countyCode": "510101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510104000000",
            "countyName": "锦江区"
          },
          {
            "countyCode": "510105000000",
            "countyName": "青羊区"
          },
          {
            "countyCode": "510106000000",
            "countyName": "金牛区"
          },
          {
            "countyCode": "510107000000",
            "countyName": "武侯区"
          },
          {
            "countyCode": "510108000000",
            "countyName": "成华区"
          },
          {
            "countyCode": "510112000000",
            "countyName": "龙泉驿区"
          },
          {
            "countyCode": "510113000000",
            "countyName": "青白江区"
          },
          {
            "countyCode": "510114000000",
            "countyName": "新都区"
          },
          {
            "countyCode": "510115000000",
            "countyName": "温江区"
          },
          {
            "countyCode": "510116000000",
            "countyName": "双流区"
          },
          {
            "countyCode": "510117000000",
            "countyName": "郫都区"
          },
          {
            "countyCode": "510121000000",
            "countyName": "金堂县"
          },
          {
            "countyCode": "510129000000",
            "countyName": "大邑县"
          },
          {
            "countyCode": "510131000000",
            "countyName": "蒲江县"
          },
          {
            "countyCode": "510132000000",
            "countyName": "新津县"
          },
          {
            "countyCode": "510181000000",
            "countyName": "都江堰市"
          },
          {
            "countyCode": "510182000000",
            "countyName": "彭州市"
          },
          {
            "countyCode": "510183000000",
            "countyName": "邛崃市"
          },
          {
            "countyCode": "510184000000",
            "countyName": "崇州市"
          },
          {
            "countyCode": "510185000000",
            "countyName": "简阳市"
          }
        ]
      },
      {
        "cityName": "自贡市",
        "cityCode": "510300000000",
        "counties": [
          {
            "countyCode": "510301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510302000000",
            "countyName": "自流井区"
          },
          {
            "countyCode": "510303000000",
            "countyName": "贡井区"
          },
          {
            "countyCode": "510304000000",
            "countyName": "大安区"
          },
          {
            "countyCode": "510311000000",
            "countyName": "沿滩区"
          },
          {
            "countyCode": "510321000000",
            "countyName": "荣县"
          },
          {
            "countyCode": "510322000000",
            "countyName": "富顺县"
          }
        ]
      },
      {
        "cityName": "攀枝花市",
        "cityCode": "510400000000",
        "counties": [
          {
            "countyCode": "510401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510402000000",
            "countyName": "东区"
          },
          {
            "countyCode": "510403000000",
            "countyName": "西区"
          },
          {
            "countyCode": "510411000000",
            "countyName": "仁和区"
          },
          {
            "countyCode": "510421000000",
            "countyName": "米易县"
          },
          {
            "countyCode": "510422000000",
            "countyName": "盐边县"
          }
        ]
      },
      {
        "cityName": "泸州市",
        "cityCode": "510500000000",
        "counties": [
          {
            "countyCode": "510501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510502000000",
            "countyName": "江阳区"
          },
          {
            "countyCode": "510503000000",
            "countyName": "纳溪区"
          },
          {
            "countyCode": "510504000000",
            "countyName": "龙马潭区"
          },
          {
            "countyCode": "510521000000",
            "countyName": "泸县"
          },
          {
            "countyCode": "510522000000",
            "countyName": "合江县"
          },
          {
            "countyCode": "510524000000",
            "countyName": "叙永县"
          },
          {
            "countyCode": "510525000000",
            "countyName": "古蔺县"
          }
        ]
      },
      {
        "cityName": "德阳市",
        "cityCode": "510600000000",
        "counties": [
          {
            "countyCode": "510601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510603000000",
            "countyName": "旌阳区"
          },
          {
            "countyCode": "510604000000",
            "countyName": "罗江区"
          },
          {
            "countyCode": "510623000000",
            "countyName": "中江县"
          },
          {
            "countyCode": "510681000000",
            "countyName": "广汉市"
          },
          {
            "countyCode": "510682000000",
            "countyName": "什邡市"
          },
          {
            "countyCode": "510683000000",
            "countyName": "绵竹市"
          }
        ]
      },
      {
        "cityName": "绵阳市",
        "cityCode": "510700000000",
        "counties": [
          {
            "countyCode": "510701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510703000000",
            "countyName": "涪城区"
          },
          {
            "countyCode": "510704000000",
            "countyName": "游仙区"
          },
          {
            "countyCode": "510705000000",
            "countyName": "安州区"
          },
          {
            "countyCode": "510722000000",
            "countyName": "三台县"
          },
          {
            "countyCode": "510723000000",
            "countyName": "盐亭县"
          },
          {
            "countyCode": "510725000000",
            "countyName": "梓潼县"
          },
          {
            "countyCode": "510726000000",
            "countyName": "北川羌族自治县"
          },
          {
            "countyCode": "510727000000",
            "countyName": "平武县"
          },
          {
            "countyCode": "510781000000",
            "countyName": "江油市"
          }
        ]
      },
      {
        "cityName": "广元市",
        "cityCode": "510800000000",
        "counties": [
          {
            "countyCode": "510801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510802000000",
            "countyName": "利州区"
          },
          {
            "countyCode": "510811000000",
            "countyName": "昭化区"
          },
          {
            "countyCode": "510812000000",
            "countyName": "朝天区"
          },
          {
            "countyCode": "510821000000",
            "countyName": "旺苍县"
          },
          {
            "countyCode": "510822000000",
            "countyName": "青川县"
          },
          {
            "countyCode": "510823000000",
            "countyName": "剑阁县"
          },
          {
            "countyCode": "510824000000",
            "countyName": "苍溪县"
          }
        ]
      },
      {
        "cityName": "遂宁市",
        "cityCode": "510900000000",
        "counties": [
          {
            "countyCode": "510901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "510903000000",
            "countyName": "船山区"
          },
          {
            "countyCode": "510904000000",
            "countyName": "安居区"
          },
          {
            "countyCode": "510921000000",
            "countyName": "蓬溪县"
          },
          {
            "countyCode": "510922000000",
            "countyName": "射洪县"
          },
          {
            "countyCode": "510923000000",
            "countyName": "大英县"
          }
        ]
      },
      {
        "cityName": "内江市",
        "cityCode": "511000000000",
        "counties": [
          {
            "countyCode": "511001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511002000000",
            "countyName": "市中区"
          },
          {
            "countyCode": "511011000000",
            "countyName": "东兴区"
          },
          {
            "countyCode": "511024000000",
            "countyName": "威远县"
          },
          {
            "countyCode": "511025000000",
            "countyName": "资中县"
          },
          {
            "countyCode": "511071000000",
            "countyName": "内江经济开发区"
          },
          {
            "countyCode": "511083000000",
            "countyName": "隆昌市"
          }
        ]
      },
      {
        "cityName": "乐山市",
        "cityCode": "511100000000",
        "counties": [
          {
            "countyCode": "511101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511102000000",
            "countyName": "市中区"
          },
          {
            "countyCode": "511111000000",
            "countyName": "沙湾区"
          },
          {
            "countyCode": "511112000000",
            "countyName": "五通桥区"
          },
          {
            "countyCode": "511113000000",
            "countyName": "金口河区"
          },
          {
            "countyCode": "511123000000",
            "countyName": "犍为县"
          },
          {
            "countyCode": "511124000000",
            "countyName": "井研县"
          },
          {
            "countyCode": "511126000000",
            "countyName": "夹江县"
          },
          {
            "countyCode": "511129000000",
            "countyName": "沐川县"
          },
          {
            "countyCode": "511132000000",
            "countyName": "峨边彝族自治县"
          },
          {
            "countyCode": "511133000000",
            "countyName": "马边彝族自治县"
          },
          {
            "countyCode": "511181000000",
            "countyName": "峨眉山市"
          }
        ]
      },
      {
        "cityName": "南充市",
        "cityCode": "511300000000",
        "counties": [
          {
            "countyCode": "511301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511302000000",
            "countyName": "顺庆区"
          },
          {
            "countyCode": "511303000000",
            "countyName": "高坪区"
          },
          {
            "countyCode": "511304000000",
            "countyName": "嘉陵区"
          },
          {
            "countyCode": "511321000000",
            "countyName": "南部县"
          },
          {
            "countyCode": "511322000000",
            "countyName": "营山县"
          },
          {
            "countyCode": "511323000000",
            "countyName": "蓬安县"
          },
          {
            "countyCode": "511324000000",
            "countyName": "仪陇县"
          },
          {
            "countyCode": "511325000000",
            "countyName": "西充县"
          },
          {
            "countyCode": "511381000000",
            "countyName": "阆中市"
          }
        ]
      },
      {
        "cityName": "眉山市",
        "cityCode": "511400000000",
        "counties": [
          {
            "countyCode": "511401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511402000000",
            "countyName": "东坡区"
          },
          {
            "countyCode": "511403000000",
            "countyName": "彭山区"
          },
          {
            "countyCode": "511421000000",
            "countyName": "仁寿县"
          },
          {
            "countyCode": "511423000000",
            "countyName": "洪雅县"
          },
          {
            "countyCode": "511424000000",
            "countyName": "丹棱县"
          },
          {
            "countyCode": "511425000000",
            "countyName": "青神县"
          }
        ]
      },
      {
        "cityName": "宜宾市",
        "cityCode": "511500000000",
        "counties": [
          {
            "countyCode": "511501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511502000000",
            "countyName": "翠屏区"
          },
          {
            "countyCode": "511503000000",
            "countyName": "南溪区"
          },
          {
            "countyCode": "511504000000",
            "countyName": "叙州区"
          },
          {
            "countyCode": "511523000000",
            "countyName": "江安县"
          },
          {
            "countyCode": "511524000000",
            "countyName": "长宁县"
          },
          {
            "countyCode": "511525000000",
            "countyName": "高县"
          },
          {
            "countyCode": "511526000000",
            "countyName": "珙县"
          },
          {
            "countyCode": "511527000000",
            "countyName": "筠连县"
          },
          {
            "countyCode": "511528000000",
            "countyName": "兴文县"
          },
          {
            "countyCode": "511529000000",
            "countyName": "屏山县"
          }
        ]
      },
      {
        "cityName": "广安市",
        "cityCode": "511600000000",
        "counties": [
          {
            "countyCode": "511601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511602000000",
            "countyName": "广安区"
          },
          {
            "countyCode": "511603000000",
            "countyName": "前锋区"
          },
          {
            "countyCode": "511621000000",
            "countyName": "岳池县"
          },
          {
            "countyCode": "511622000000",
            "countyName": "武胜县"
          },
          {
            "countyCode": "511623000000",
            "countyName": "邻水县"
          },
          {
            "countyCode": "511681000000",
            "countyName": "华蓥市"
          }
        ]
      },
      {
        "cityName": "达州市",
        "cityCode": "511700000000",
        "counties": [
          {
            "countyCode": "511701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511702000000",
            "countyName": "通川区"
          },
          {
            "countyCode": "511703000000",
            "countyName": "达川区"
          },
          {
            "countyCode": "511722000000",
            "countyName": "宣汉县"
          },
          {
            "countyCode": "511723000000",
            "countyName": "开江县"
          },
          {
            "countyCode": "511724000000",
            "countyName": "大竹县"
          },
          {
            "countyCode": "511725000000",
            "countyName": "渠县"
          },
          {
            "countyCode": "511771000000",
            "countyName": "达州经济开发区"
          },
          {
            "countyCode": "511781000000",
            "countyName": "万源市"
          }
        ]
      },
      {
        "cityName": "雅安市",
        "cityCode": "511800000000",
        "counties": [
          {
            "countyCode": "511801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511802000000",
            "countyName": "雨城区"
          },
          {
            "countyCode": "511803000000",
            "countyName": "名山区"
          },
          {
            "countyCode": "511822000000",
            "countyName": "荥经县"
          },
          {
            "countyCode": "511823000000",
            "countyName": "汉源县"
          },
          {
            "countyCode": "511824000000",
            "countyName": "石棉县"
          },
          {
            "countyCode": "511825000000",
            "countyName": "天全县"
          },
          {
            "countyCode": "511826000000",
            "countyName": "芦山县"
          },
          {
            "countyCode": "511827000000",
            "countyName": "宝兴县"
          }
        ]
      },
      {
        "cityName": "巴中市",
        "cityCode": "511900000000",
        "counties": [
          {
            "countyCode": "511901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "511902000000",
            "countyName": "巴州区"
          },
          {
            "countyCode": "511903000000",
            "countyName": "恩阳区"
          },
          {
            "countyCode": "511921000000",
            "countyName": "通江县"
          },
          {
            "countyCode": "511922000000",
            "countyName": "南江县"
          },
          {
            "countyCode": "511923000000",
            "countyName": "平昌县"
          },
          {
            "countyCode": "511971000000",
            "countyName": "巴中经济开发区"
          }
        ]
      },
      {
        "cityName": "资阳市",
        "cityCode": "512000000000",
        "counties": [
          {
            "countyCode": "512001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "512002000000",
            "countyName": "雁江区"
          },
          {
            "countyCode": "512021000000",
            "countyName": "安岳县"
          },
          {
            "countyCode": "512022000000",
            "countyName": "乐至县"
          }
        ]
      },
      {
        "cityName": "阿坝藏族羌族自治州",
        "cityCode": "513200000000",
        "counties": [
          {
            "countyCode": "513201000000",
            "countyName": "马尔康市"
          },
          {
            "countyCode": "513221000000",
            "countyName": "汶川县"
          },
          {
            "countyCode": "513222000000",
            "countyName": "理县"
          },
          {
            "countyCode": "513223000000",
            "countyName": "茂县"
          },
          {
            "countyCode": "513224000000",
            "countyName": "松潘县"
          },
          {
            "countyCode": "513225000000",
            "countyName": "九寨沟县"
          },
          {
            "countyCode": "513226000000",
            "countyName": "金川县"
          },
          {
            "countyCode": "513227000000",
            "countyName": "小金县"
          },
          {
            "countyCode": "513228000000",
            "countyName": "黑水县"
          },
          {
            "countyCode": "513230000000",
            "countyName": "壤塘县"
          },
          {
            "countyCode": "513231000000",
            "countyName": "阿坝县"
          },
          {
            "countyCode": "513232000000",
            "countyName": "若尔盖县"
          },
          {
            "countyCode": "513233000000",
            "countyName": "红原县"
          }
        ]
      },
      {
        "cityName": "甘孜藏族自治州",
        "cityCode": "513300000000",
        "counties": [
          {
            "countyCode": "513301000000",
            "countyName": "康定市"
          },
          {
            "countyCode": "513322000000",
            "countyName": "泸定县"
          },
          {
            "countyCode": "513323000000",
            "countyName": "丹巴县"
          },
          {
            "countyCode": "513324000000",
            "countyName": "九龙县"
          },
          {
            "countyCode": "513325000000",
            "countyName": "雅江县"
          },
          {
            "countyCode": "513326000000",
            "countyName": "道孚县"
          },
          {
            "countyCode": "513327000000",
            "countyName": "炉霍县"
          },
          {
            "countyCode": "513328000000",
            "countyName": "甘孜县"
          },
          {
            "countyCode": "513329000000",
            "countyName": "新龙县"
          },
          {
            "countyCode": "513330000000",
            "countyName": "德格县"
          },
          {
            "countyCode": "513331000000",
            "countyName": "白玉县"
          },
          {
            "countyCode": "513332000000",
            "countyName": "石渠县"
          },
          {
            "countyCode": "513333000000",
            "countyName": "色达县"
          },
          {
            "countyCode": "513334000000",
            "countyName": "理塘县"
          },
          {
            "countyCode": "513335000000",
            "countyName": "巴塘县"
          },
          {
            "countyCode": "513336000000",
            "countyName": "乡城县"
          },
          {
            "countyCode": "513337000000",
            "countyName": "稻城县"
          },
          {
            "countyCode": "513338000000",
            "countyName": "得荣县"
          }
        ]
      },
      {
        "cityName": "凉山彝族自治州",
        "cityCode": "513400000000",
        "counties": [
          {
            "countyCode": "513401000000",
            "countyName": "西昌市"
          },
          {
            "countyCode": "513422000000",
            "countyName": "木里藏族自治县"
          },
          {
            "countyCode": "513423000000",
            "countyName": "盐源县"
          },
          {
            "countyCode": "513424000000",
            "countyName": "德昌县"
          },
          {
            "countyCode": "513425000000",
            "countyName": "会理县"
          },
          {
            "countyCode": "513426000000",
            "countyName": "会东县"
          },
          {
            "countyCode": "513427000000",
            "countyName": "宁南县"
          },
          {
            "countyCode": "513428000000",
            "countyName": "普格县"
          },
          {
            "countyCode": "513429000000",
            "countyName": "布拖县"
          },
          {
            "countyCode": "513430000000",
            "countyName": "金阳县"
          },
          {
            "countyCode": "513431000000",
            "countyName": "昭觉县"
          },
          {
            "countyCode": "513432000000",
            "countyName": "喜德县"
          },
          {
            "countyCode": "513433000000",
            "countyName": "冕宁县"
          },
          {
            "countyCode": "513434000000",
            "countyName": "越西县"
          },
          {
            "countyCode": "513435000000",
            "countyName": "甘洛县"
          },
          {
            "countyCode": "513436000000",
            "countyName": "美姑县"
          },
          {
            "countyCode": "513437000000",
            "countyName": "雷波县"
          }
        ]
      }
    ],
    "provinceCode": "510000000000",
    "provinceName": "四川省"
  },
  {
    "cities": [
      {
        "cityName": "贵阳市",
        "cityCode": "520100000000",
        "counties": [
          {
            "countyCode": "520101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "520102000000",
            "countyName": "南明区"
          },
          {
            "countyCode": "520103000000",
            "countyName": "云岩区"
          },
          {
            "countyCode": "520111000000",
            "countyName": "花溪区"
          },
          {
            "countyCode": "520112000000",
            "countyName": "乌当区"
          },
          {
            "countyCode": "520113000000",
            "countyName": "白云区"
          },
          {
            "countyCode": "520115000000",
            "countyName": "观山湖区"
          },
          {
            "countyCode": "520121000000",
            "countyName": "开阳县"
          },
          {
            "countyCode": "520122000000",
            "countyName": "息烽县"
          },
          {
            "countyCode": "520123000000",
            "countyName": "修文县"
          },
          {
            "countyCode": "520181000000",
            "countyName": "清镇市"
          }
        ]
      },
      {
        "cityName": "六盘水市",
        "cityCode": "520200000000",
        "counties": [
          {
            "countyCode": "520201000000",
            "countyName": "钟山区"
          },
          {
            "countyCode": "520203000000",
            "countyName": "六枝特区"
          },
          {
            "countyCode": "520221000000",
            "countyName": "水城县"
          },
          {
            "countyCode": "520281000000",
            "countyName": "盘州市"
          }
        ]
      },
      {
        "cityName": "遵义市",
        "cityCode": "520300000000",
        "counties": [
          {
            "countyCode": "520301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "520302000000",
            "countyName": "红花岗区"
          },
          {
            "countyCode": "520303000000",
            "countyName": "汇川区"
          },
          {
            "countyCode": "520304000000",
            "countyName": "播州区"
          },
          {
            "countyCode": "520322000000",
            "countyName": "桐梓县"
          },
          {
            "countyCode": "520323000000",
            "countyName": "绥阳县"
          },
          {
            "countyCode": "520324000000",
            "countyName": "正安县"
          },
          {
            "countyCode": "520325000000",
            "countyName": "道真仡佬族苗族自治县"
          },
          {
            "countyCode": "520326000000",
            "countyName": "务川仡佬族苗族自治县"
          },
          {
            "countyCode": "520327000000",
            "countyName": "凤冈县"
          },
          {
            "countyCode": "520328000000",
            "countyName": "湄潭县"
          },
          {
            "countyCode": "520329000000",
            "countyName": "余庆县"
          },
          {
            "countyCode": "520330000000",
            "countyName": "习水县"
          },
          {
            "countyCode": "520381000000",
            "countyName": "赤水市"
          },
          {
            "countyCode": "520382000000",
            "countyName": "仁怀市"
          }
        ]
      },
      {
        "cityName": "安顺市",
        "cityCode": "520400000000",
        "counties": [
          {
            "countyCode": "520401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "520402000000",
            "countyName": "西秀区"
          },
          {
            "countyCode": "520403000000",
            "countyName": "平坝区"
          },
          {
            "countyCode": "520422000000",
            "countyName": "普定县"
          },
          {
            "countyCode": "520423000000",
            "countyName": "镇宁布依族苗族自治县"
          },
          {
            "countyCode": "520424000000",
            "countyName": "关岭布依族苗族自治县"
          },
          {
            "countyCode": "520425000000",
            "countyName": "紫云苗族布依族自治县"
          }
        ]
      },
      {
        "cityName": "毕节市",
        "cityCode": "520500000000",
        "counties": [
          {
            "countyCode": "520501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "520502000000",
            "countyName": "七星关区"
          },
          {
            "countyCode": "520521000000",
            "countyName": "大方县"
          },
          {
            "countyCode": "520522000000",
            "countyName": "黔西县"
          },
          {
            "countyCode": "520523000000",
            "countyName": "金沙县"
          },
          {
            "countyCode": "520524000000",
            "countyName": "织金县"
          },
          {
            "countyCode": "520525000000",
            "countyName": "纳雍县"
          },
          {
            "countyCode": "520526000000",
            "countyName": "威宁彝族回族苗族自治县"
          },
          {
            "countyCode": "520527000000",
            "countyName": "赫章县"
          }
        ]
      },
      {
        "cityName": "铜仁市",
        "cityCode": "520600000000",
        "counties": [
          {
            "countyCode": "520601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "520602000000",
            "countyName": "碧江区"
          },
          {
            "countyCode": "520603000000",
            "countyName": "万山区"
          },
          {
            "countyCode": "520621000000",
            "countyName": "江口县"
          },
          {
            "countyCode": "520622000000",
            "countyName": "玉屏侗族自治县"
          },
          {
            "countyCode": "520623000000",
            "countyName": "石阡县"
          },
          {
            "countyCode": "520624000000",
            "countyName": "思南县"
          },
          {
            "countyCode": "520625000000",
            "countyName": "印江土家族苗族自治县"
          },
          {
            "countyCode": "520626000000",
            "countyName": "德江县"
          },
          {
            "countyCode": "520627000000",
            "countyName": "沿河土家族自治县"
          },
          {
            "countyCode": "520628000000",
            "countyName": "松桃苗族自治县"
          }
        ]
      },
      {
        "cityName": "黔西南布依族苗族自治州",
        "cityCode": "522300000000",
        "counties": [
          {
            "countyCode": "522301000000",
            "countyName": "兴义市"
          },
          {
            "countyCode": "522302000000",
            "countyName": "兴仁市"
          },
          {
            "countyCode": "522323000000",
            "countyName": "普安县"
          },
          {
            "countyCode": "522324000000",
            "countyName": "晴隆县"
          },
          {
            "countyCode": "522325000000",
            "countyName": "贞丰县"
          },
          {
            "countyCode": "522326000000",
            "countyName": "望谟县"
          },
          {
            "countyCode": "522327000000",
            "countyName": "册亨县"
          },
          {
            "countyCode": "522328000000",
            "countyName": "安龙县"
          }
        ]
      },
      {
        "cityName": "黔东南苗族侗族自治州",
        "cityCode": "522600000000",
        "counties": [
          {
            "countyCode": "522601000000",
            "countyName": "凯里市"
          },
          {
            "countyCode": "522622000000",
            "countyName": "黄平县"
          },
          {
            "countyCode": "522623000000",
            "countyName": "施秉县"
          },
          {
            "countyCode": "522624000000",
            "countyName": "三穗县"
          },
          {
            "countyCode": "522625000000",
            "countyName": "镇远县"
          },
          {
            "countyCode": "522626000000",
            "countyName": "岑巩县"
          },
          {
            "countyCode": "522627000000",
            "countyName": "天柱县"
          },
          {
            "countyCode": "522628000000",
            "countyName": "锦屏县"
          },
          {
            "countyCode": "522629000000",
            "countyName": "剑河县"
          },
          {
            "countyCode": "522630000000",
            "countyName": "台江县"
          },
          {
            "countyCode": "522631000000",
            "countyName": "黎平县"
          },
          {
            "countyCode": "522632000000",
            "countyName": "榕江县"
          },
          {
            "countyCode": "522633000000",
            "countyName": "从江县"
          },
          {
            "countyCode": "522634000000",
            "countyName": "雷山县"
          },
          {
            "countyCode": "522635000000",
            "countyName": "麻江县"
          },
          {
            "countyCode": "522636000000",
            "countyName": "丹寨县"
          }
        ]
      },
      {
        "cityName": "黔南布依族苗族自治州",
        "cityCode": "522700000000",
        "counties": [
          {
            "countyCode": "522701000000",
            "countyName": "都匀市"
          },
          {
            "countyCode": "522702000000",
            "countyName": "福泉市"
          },
          {
            "countyCode": "522722000000",
            "countyName": "荔波县"
          },
          {
            "countyCode": "522723000000",
            "countyName": "贵定县"
          },
          {
            "countyCode": "522725000000",
            "countyName": "瓮安县"
          },
          {
            "countyCode": "522726000000",
            "countyName": "独山县"
          },
          {
            "countyCode": "522727000000",
            "countyName": "平塘县"
          },
          {
            "countyCode": "522728000000",
            "countyName": "罗甸县"
          },
          {
            "countyCode": "522729000000",
            "countyName": "长顺县"
          },
          {
            "countyCode": "522730000000",
            "countyName": "龙里县"
          },
          {
            "countyCode": "522731000000",
            "countyName": "惠水县"
          },
          {
            "countyCode": "522732000000",
            "countyName": "三都水族自治县"
          }
        ]
      }
    ],
    "provinceCode": "520000000000",
    "provinceName": "贵州省"
  },
  {
    "cities": [
      {
        "cityName": "昆明市",
        "cityCode": "530100000000",
        "counties": [
          {
            "countyCode": "530101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530102000000",
            "countyName": "五华区"
          },
          {
            "countyCode": "530103000000",
            "countyName": "盘龙区"
          },
          {
            "countyCode": "530111000000",
            "countyName": "官渡区"
          },
          {
            "countyCode": "530112000000",
            "countyName": "西山区"
          },
          {
            "countyCode": "530113000000",
            "countyName": "东川区"
          },
          {
            "countyCode": "530114000000",
            "countyName": "呈贡区"
          },
          {
            "countyCode": "530115000000",
            "countyName": "晋宁区"
          },
          {
            "countyCode": "530124000000",
            "countyName": "富民县"
          },
          {
            "countyCode": "530125000000",
            "countyName": "宜良县"
          },
          {
            "countyCode": "530126000000",
            "countyName": "石林彝族自治县"
          },
          {
            "countyCode": "530127000000",
            "countyName": "嵩明县"
          },
          {
            "countyCode": "530128000000",
            "countyName": "禄劝彝族苗族自治县"
          },
          {
            "countyCode": "530129000000",
            "countyName": "寻甸回族彝族自治县"
          },
          {
            "countyCode": "530181000000",
            "countyName": "安宁市"
          }
        ]
      },
      {
        "cityName": "曲靖市",
        "cityCode": "530300000000",
        "counties": [
          {
            "countyCode": "530301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530302000000",
            "countyName": "麒麟区"
          },
          {
            "countyCode": "530303000000",
            "countyName": "沾益区"
          },
          {
            "countyCode": "530304000000",
            "countyName": "马龙区"
          },
          {
            "countyCode": "530322000000",
            "countyName": "陆良县"
          },
          {
            "countyCode": "530323000000",
            "countyName": "师宗县"
          },
          {
            "countyCode": "530324000000",
            "countyName": "罗平县"
          },
          {
            "countyCode": "530325000000",
            "countyName": "富源县"
          },
          {
            "countyCode": "530326000000",
            "countyName": "会泽县"
          },
          {
            "countyCode": "530381000000",
            "countyName": "宣威市"
          }
        ]
      },
      {
        "cityName": "玉溪市",
        "cityCode": "530400000000",
        "counties": [
          {
            "countyCode": "530401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530402000000",
            "countyName": "红塔区"
          },
          {
            "countyCode": "530403000000",
            "countyName": "江川区"
          },
          {
            "countyCode": "530422000000",
            "countyName": "澄江县"
          },
          {
            "countyCode": "530423000000",
            "countyName": "通海县"
          },
          {
            "countyCode": "530424000000",
            "countyName": "华宁县"
          },
          {
            "countyCode": "530425000000",
            "countyName": "易门县"
          },
          {
            "countyCode": "530426000000",
            "countyName": "峨山彝族自治县"
          },
          {
            "countyCode": "530427000000",
            "countyName": "新平彝族傣族自治县"
          },
          {
            "countyCode": "530428000000",
            "countyName": "元江哈尼族彝族傣族自治县"
          }
        ]
      },
      {
        "cityName": "保山市",
        "cityCode": "530500000000",
        "counties": [
          {
            "countyCode": "530501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530502000000",
            "countyName": "隆阳区"
          },
          {
            "countyCode": "530521000000",
            "countyName": "施甸县"
          },
          {
            "countyCode": "530523000000",
            "countyName": "龙陵县"
          },
          {
            "countyCode": "530524000000",
            "countyName": "昌宁县"
          },
          {
            "countyCode": "530581000000",
            "countyName": "腾冲市"
          }
        ]
      },
      {
        "cityName": "昭通市",
        "cityCode": "530600000000",
        "counties": [
          {
            "countyCode": "530601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530602000000",
            "countyName": "昭阳区"
          },
          {
            "countyCode": "530621000000",
            "countyName": "鲁甸县"
          },
          {
            "countyCode": "530622000000",
            "countyName": "巧家县"
          },
          {
            "countyCode": "530623000000",
            "countyName": "盐津县"
          },
          {
            "countyCode": "530624000000",
            "countyName": "大关县"
          },
          {
            "countyCode": "530625000000",
            "countyName": "永善县"
          },
          {
            "countyCode": "530626000000",
            "countyName": "绥江县"
          },
          {
            "countyCode": "530627000000",
            "countyName": "镇雄县"
          },
          {
            "countyCode": "530628000000",
            "countyName": "彝良县"
          },
          {
            "countyCode": "530629000000",
            "countyName": "威信县"
          },
          {
            "countyCode": "530681000000",
            "countyName": "水富市"
          }
        ]
      },
      {
        "cityName": "丽江市",
        "cityCode": "530700000000",
        "counties": [
          {
            "countyCode": "530701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530702000000",
            "countyName": "古城区"
          },
          {
            "countyCode": "530721000000",
            "countyName": "玉龙纳西族自治县"
          },
          {
            "countyCode": "530722000000",
            "countyName": "永胜县"
          },
          {
            "countyCode": "530723000000",
            "countyName": "华坪县"
          },
          {
            "countyCode": "530724000000",
            "countyName": "宁蒗彝族自治县"
          }
        ]
      },
      {
        "cityName": "普洱市",
        "cityCode": "530800000000",
        "counties": [
          {
            "countyCode": "530801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530802000000",
            "countyName": "思茅区"
          },
          {
            "countyCode": "530821000000",
            "countyName": "宁洱哈尼族彝族自治县"
          },
          {
            "countyCode": "530822000000",
            "countyName": "墨江哈尼族自治县"
          },
          {
            "countyCode": "530823000000",
            "countyName": "景东彝族自治县"
          },
          {
            "countyCode": "530824000000",
            "countyName": "景谷傣族彝族自治县"
          },
          {
            "countyCode": "530825000000",
            "countyName": "镇沅彝族哈尼族拉祜族自治县"
          },
          {
            "countyCode": "530826000000",
            "countyName": "江城哈尼族彝族自治县"
          },
          {
            "countyCode": "530827000000",
            "countyName": "孟连傣族拉祜族佤族自治县"
          },
          {
            "countyCode": "530828000000",
            "countyName": "澜沧拉祜族自治县"
          },
          {
            "countyCode": "530829000000",
            "countyName": "西盟佤族自治县"
          }
        ]
      },
      {
        "cityName": "临沧市",
        "cityCode": "530900000000",
        "counties": [
          {
            "countyCode": "530901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "530902000000",
            "countyName": "临翔区"
          },
          {
            "countyCode": "530921000000",
            "countyName": "凤庆县"
          },
          {
            "countyCode": "530922000000",
            "countyName": "云县"
          },
          {
            "countyCode": "530923000000",
            "countyName": "永德县"
          },
          {
            "countyCode": "530924000000",
            "countyName": "镇康县"
          },
          {
            "countyCode": "530925000000",
            "countyName": "双江拉祜族佤族布朗族傣族自治县"
          },
          {
            "countyCode": "530926000000",
            "countyName": "耿马傣族佤族自治县"
          },
          {
            "countyCode": "530927000000",
            "countyName": "沧源佤族自治县"
          }
        ]
      },
      {
        "cityName": "楚雄彝族自治州",
        "cityCode": "532300000000",
        "counties": [
          {
            "countyCode": "532301000000",
            "countyName": "楚雄市"
          },
          {
            "countyCode": "532322000000",
            "countyName": "双柏县"
          },
          {
            "countyCode": "532323000000",
            "countyName": "牟定县"
          },
          {
            "countyCode": "532324000000",
            "countyName": "南华县"
          },
          {
            "countyCode": "532325000000",
            "countyName": "姚安县"
          },
          {
            "countyCode": "532326000000",
            "countyName": "大姚县"
          },
          {
            "countyCode": "532327000000",
            "countyName": "永仁县"
          },
          {
            "countyCode": "532328000000",
            "countyName": "元谋县"
          },
          {
            "countyCode": "532329000000",
            "countyName": "武定县"
          },
          {
            "countyCode": "532331000000",
            "countyName": "禄丰县"
          }
        ]
      },
      {
        "cityName": "红河哈尼族彝族自治州",
        "cityCode": "532500000000",
        "counties": [
          {
            "countyCode": "532501000000",
            "countyName": "个旧市"
          },
          {
            "countyCode": "532502000000",
            "countyName": "开远市"
          },
          {
            "countyCode": "532503000000",
            "countyName": "蒙自市"
          },
          {
            "countyCode": "532504000000",
            "countyName": "弥勒市"
          },
          {
            "countyCode": "532523000000",
            "countyName": "屏边苗族自治县"
          },
          {
            "countyCode": "532524000000",
            "countyName": "建水县"
          },
          {
            "countyCode": "532525000000",
            "countyName": "石屏县"
          },
          {
            "countyCode": "532527000000",
            "countyName": "泸西县"
          },
          {
            "countyCode": "532528000000",
            "countyName": "元阳县"
          },
          {
            "countyCode": "532529000000",
            "countyName": "红河县"
          },
          {
            "countyCode": "532530000000",
            "countyName": "金平苗族瑶族傣族自治县"
          },
          {
            "countyCode": "532531000000",
            "countyName": "绿春县"
          },
          {
            "countyCode": "532532000000",
            "countyName": "河口瑶族自治县"
          }
        ]
      },
      {
        "cityName": "文山壮族苗族自治州",
        "cityCode": "532600000000",
        "counties": [
          {
            "countyCode": "532601000000",
            "countyName": "文山市"
          },
          {
            "countyCode": "532622000000",
            "countyName": "砚山县"
          },
          {
            "countyCode": "532623000000",
            "countyName": "西畴县"
          },
          {
            "countyCode": "532624000000",
            "countyName": "麻栗坡县"
          },
          {
            "countyCode": "532625000000",
            "countyName": "马关县"
          },
          {
            "countyCode": "532626000000",
            "countyName": "丘北县"
          },
          {
            "countyCode": "532627000000",
            "countyName": "广南县"
          },
          {
            "countyCode": "532628000000",
            "countyName": "富宁县"
          }
        ]
      },
      {
        "cityName": "西双版纳傣族自治州",
        "cityCode": "532800000000",
        "counties": [
          {
            "countyCode": "532801000000",
            "countyName": "景洪市"
          },
          {
            "countyCode": "532822000000",
            "countyName": "勐海县"
          },
          {
            "countyCode": "532823000000",
            "countyName": "勐腊县"
          }
        ]
      },
      {
        "cityName": "大理白族自治州",
        "cityCode": "532900000000",
        "counties": [
          {
            "countyCode": "532901000000",
            "countyName": "大理市"
          },
          {
            "countyCode": "532922000000",
            "countyName": "漾濞彝族自治县"
          },
          {
            "countyCode": "532923000000",
            "countyName": "祥云县"
          },
          {
            "countyCode": "532924000000",
            "countyName": "宾川县"
          },
          {
            "countyCode": "532925000000",
            "countyName": "弥渡县"
          },
          {
            "countyCode": "532926000000",
            "countyName": "南涧彝族自治县"
          },
          {
            "countyCode": "532927000000",
            "countyName": "巍山彝族回族自治县"
          },
          {
            "countyCode": "532928000000",
            "countyName": "永平县"
          },
          {
            "countyCode": "532929000000",
            "countyName": "云龙县"
          },
          {
            "countyCode": "532930000000",
            "countyName": "洱源县"
          },
          {
            "countyCode": "532931000000",
            "countyName": "剑川县"
          },
          {
            "countyCode": "532932000000",
            "countyName": "鹤庆县"
          }
        ]
      },
      {
        "cityName": "德宏傣族景颇族自治州",
        "cityCode": "533100000000",
        "counties": [
          {
            "countyCode": "533102000000",
            "countyName": "瑞丽市"
          },
          {
            "countyCode": "533103000000",
            "countyName": "芒市"
          },
          {
            "countyCode": "533122000000",
            "countyName": "梁河县"
          },
          {
            "countyCode": "533123000000",
            "countyName": "盈江县"
          },
          {
            "countyCode": "533124000000",
            "countyName": "陇川县"
          }
        ]
      },
      {
        "cityName": "怒江傈僳族自治州",
        "cityCode": "533300000000",
        "counties": [
          {
            "countyCode": "533301000000",
            "countyName": "泸水市"
          },
          {
            "countyCode": "533323000000",
            "countyName": "福贡县"
          },
          {
            "countyCode": "533324000000",
            "countyName": "贡山独龙族怒族自治县"
          },
          {
            "countyCode": "533325000000",
            "countyName": "兰坪白族普米族自治县"
          }
        ]
      },
      {
        "cityName": "迪庆藏族自治州",
        "cityCode": "533400000000",
        "counties": [
          {
            "countyCode": "533401000000",
            "countyName": "香格里拉市"
          },
          {
            "countyCode": "533422000000",
            "countyName": "德钦县"
          },
          {
            "countyCode": "533423000000",
            "countyName": "维西傈僳族自治县"
          }
        ]
      }
    ],
    "provinceCode": "530000000000",
    "provinceName": "云南省"
  },
  {
    "cities": [
      {
        "cityName": "拉萨市",
        "cityCode": "540100000000",
        "counties": [
          {
            "countyCode": "540101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "540102000000",
            "countyName": "城关区"
          },
          {
            "countyCode": "540103000000",
            "countyName": "堆龙德庆区"
          },
          {
            "countyCode": "540104000000",
            "countyName": "达孜区"
          },
          {
            "countyCode": "540121000000",
            "countyName": "林周县"
          },
          {
            "countyCode": "540122000000",
            "countyName": "当雄县"
          },
          {
            "countyCode": "540123000000",
            "countyName": "尼木县"
          },
          {
            "countyCode": "540124000000",
            "countyName": "曲水县"
          },
          {
            "countyCode": "540127000000",
            "countyName": "墨竹工卡县"
          },
          {
            "countyCode": "540171000000",
            "countyName": "格尔木藏青工业园区"
          },
          {
            "countyCode": "540172000000",
            "countyName": "拉萨经济技术开发区"
          },
          {
            "countyCode": "540173000000",
            "countyName": "西藏文化旅游创意园区"
          },
          {
            "countyCode": "540174000000",
            "countyName": "达孜工业园区"
          }
        ]
      },
      {
        "cityName": "日喀则市",
        "cityCode": "540200000000",
        "counties": [
          {
            "countyCode": "540202000000",
            "countyName": "桑珠孜区"
          },
          {
            "countyCode": "540221000000",
            "countyName": "南木林县"
          },
          {
            "countyCode": "540222000000",
            "countyName": "江孜县"
          },
          {
            "countyCode": "540223000000",
            "countyName": "定日县"
          },
          {
            "countyCode": "540224000000",
            "countyName": "萨迦县"
          },
          {
            "countyCode": "540225000000",
            "countyName": "拉孜县"
          },
          {
            "countyCode": "540226000000",
            "countyName": "昂仁县"
          },
          {
            "countyCode": "540227000000",
            "countyName": "谢通门县"
          },
          {
            "countyCode": "540228000000",
            "countyName": "白朗县"
          },
          {
            "countyCode": "540229000000",
            "countyName": "仁布县"
          },
          {
            "countyCode": "540230000000",
            "countyName": "康马县"
          },
          {
            "countyCode": "540231000000",
            "countyName": "定结县"
          },
          {
            "countyCode": "540232000000",
            "countyName": "仲巴县"
          },
          {
            "countyCode": "540233000000",
            "countyName": "亚东县"
          },
          {
            "countyCode": "540234000000",
            "countyName": "吉隆县"
          },
          {
            "countyCode": "540235000000",
            "countyName": "聂拉木县"
          },
          {
            "countyCode": "540236000000",
            "countyName": "萨嘎县"
          },
          {
            "countyCode": "540237000000",
            "countyName": "岗巴县"
          }
        ]
      },
      {
        "cityName": "昌都市",
        "cityCode": "540300000000",
        "counties": [
          {
            "countyCode": "540302000000",
            "countyName": "卡若区"
          },
          {
            "countyCode": "540321000000",
            "countyName": "江达县"
          },
          {
            "countyCode": "540322000000",
            "countyName": "贡觉县"
          },
          {
            "countyCode": "540323000000",
            "countyName": "类乌齐县"
          },
          {
            "countyCode": "540324000000",
            "countyName": "丁青县"
          },
          {
            "countyCode": "540325000000",
            "countyName": "察雅县"
          },
          {
            "countyCode": "540326000000",
            "countyName": "八宿县"
          },
          {
            "countyCode": "540327000000",
            "countyName": "左贡县"
          },
          {
            "countyCode": "540328000000",
            "countyName": "芒康县"
          },
          {
            "countyCode": "540329000000",
            "countyName": "洛隆县"
          },
          {
            "countyCode": "540330000000",
            "countyName": "边坝县"
          }
        ]
      },
      {
        "cityName": "林芝市",
        "cityCode": "540400000000",
        "counties": [
          {
            "countyCode": "540402000000",
            "countyName": "巴宜区"
          },
          {
            "countyCode": "540421000000",
            "countyName": "工布江达县"
          },
          {
            "countyCode": "540422000000",
            "countyName": "米林县"
          },
          {
            "countyCode": "540423000000",
            "countyName": "墨脱县"
          },
          {
            "countyCode": "540424000000",
            "countyName": "波密县"
          },
          {
            "countyCode": "540425000000",
            "countyName": "察隅县"
          },
          {
            "countyCode": "540426000000",
            "countyName": "朗县"
          }
        ]
      },
      {
        "cityName": "山南市",
        "cityCode": "540500000000",
        "counties": [
          {
            "countyCode": "540501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "540502000000",
            "countyName": "乃东区"
          },
          {
            "countyCode": "540521000000",
            "countyName": "扎囊县"
          },
          {
            "countyCode": "540522000000",
            "countyName": "贡嘎县"
          },
          {
            "countyCode": "540523000000",
            "countyName": "桑日县"
          },
          {
            "countyCode": "540524000000",
            "countyName": "琼结县"
          },
          {
            "countyCode": "540525000000",
            "countyName": "曲松县"
          },
          {
            "countyCode": "540526000000",
            "countyName": "措美县"
          },
          {
            "countyCode": "540527000000",
            "countyName": "洛扎县"
          },
          {
            "countyCode": "540528000000",
            "countyName": "加查县"
          },
          {
            "countyCode": "540529000000",
            "countyName": "隆子县"
          },
          {
            "countyCode": "540530000000",
            "countyName": "错那县"
          },
          {
            "countyCode": "540531000000",
            "countyName": "浪卡子县"
          }
        ]
      },
      {
        "cityName": "那曲市",
        "cityCode": "540600000000",
        "counties": [
          {
            "countyCode": "540602000000",
            "countyName": "色尼区"
          },
          {
            "countyCode": "540621000000",
            "countyName": "嘉黎县"
          },
          {
            "countyCode": "540622000000",
            "countyName": "比如县"
          },
          {
            "countyCode": "540623000000",
            "countyName": "聂荣县"
          },
          {
            "countyCode": "540624000000",
            "countyName": "安多县"
          },
          {
            "countyCode": "540625000000",
            "countyName": "申扎县"
          },
          {
            "countyCode": "540626000000",
            "countyName": "索县"
          },
          {
            "countyCode": "540627000000",
            "countyName": "班戈县"
          },
          {
            "countyCode": "540628000000",
            "countyName": "巴青县"
          },
          {
            "countyCode": "540629000000",
            "countyName": "尼玛县"
          },
          {
            "countyCode": "540630000000",
            "countyName": "双湖县"
          }
        ]
      },
      {
        "cityName": "阿里地区",
        "cityCode": "542500000000",
        "counties": [
          {
            "countyCode": "542521000000",
            "countyName": "普兰县"
          },
          {
            "countyCode": "542522000000",
            "countyName": "札达县"
          },
          {
            "countyCode": "542523000000",
            "countyName": "噶尔县"
          },
          {
            "countyCode": "542524000000",
            "countyName": "日土县"
          },
          {
            "countyCode": "542525000000",
            "countyName": "革吉县"
          },
          {
            "countyCode": "542526000000",
            "countyName": "改则县"
          },
          {
            "countyCode": "542527000000",
            "countyName": "措勤县"
          }
        ]
      }
    ],
    "provinceCode": "540000000000",
    "provinceName": "西藏自治区"
  },
  {
    "cities": [
      {
        "cityName": "西安市",
        "cityCode": "610100000000",
        "counties": [
          {
            "countyCode": "610101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610102000000",
            "countyName": "新城区"
          },
          {
            "countyCode": "610103000000",
            "countyName": "碑林区"
          },
          {
            "countyCode": "610104000000",
            "countyName": "莲湖区"
          },
          {
            "countyCode": "610111000000",
            "countyName": "灞桥区"
          },
          {
            "countyCode": "610112000000",
            "countyName": "未央区"
          },
          {
            "countyCode": "610113000000",
            "countyName": "雁塔区"
          },
          {
            "countyCode": "610114000000",
            "countyName": "阎良区"
          },
          {
            "countyCode": "610115000000",
            "countyName": "临潼区"
          },
          {
            "countyCode": "610116000000",
            "countyName": "长安区"
          },
          {
            "countyCode": "610117000000",
            "countyName": "高陵区"
          },
          {
            "countyCode": "610118000000",
            "countyName": "鄠邑区"
          },
          {
            "countyCode": "610122000000",
            "countyName": "蓝田县"
          },
          {
            "countyCode": "610124000000",
            "countyName": "周至县"
          }
        ]
      },
      {
        "cityName": "铜川市",
        "cityCode": "610200000000",
        "counties": [
          {
            "countyCode": "610201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610202000000",
            "countyName": "王益区"
          },
          {
            "countyCode": "610203000000",
            "countyName": "印台区"
          },
          {
            "countyCode": "610204000000",
            "countyName": "耀州区"
          },
          {
            "countyCode": "610222000000",
            "countyName": "宜君县"
          }
        ]
      },
      {
        "cityName": "宝鸡市",
        "cityCode": "610300000000",
        "counties": [
          {
            "countyCode": "610301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610302000000",
            "countyName": "渭滨区"
          },
          {
            "countyCode": "610303000000",
            "countyName": "金台区"
          },
          {
            "countyCode": "610304000000",
            "countyName": "陈仓区"
          },
          {
            "countyCode": "610322000000",
            "countyName": "凤翔县"
          },
          {
            "countyCode": "610323000000",
            "countyName": "岐山县"
          },
          {
            "countyCode": "610324000000",
            "countyName": "扶风县"
          },
          {
            "countyCode": "610326000000",
            "countyName": "眉县"
          },
          {
            "countyCode": "610327000000",
            "countyName": "陇县"
          },
          {
            "countyCode": "610328000000",
            "countyName": "千阳县"
          },
          {
            "countyCode": "610329000000",
            "countyName": "麟游县"
          },
          {
            "countyCode": "610330000000",
            "countyName": "凤县"
          },
          {
            "countyCode": "610331000000",
            "countyName": "太白县"
          }
        ]
      },
      {
        "cityName": "咸阳市",
        "cityCode": "610400000000",
        "counties": [
          {
            "countyCode": "610401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610402000000",
            "countyName": "秦都区"
          },
          {
            "countyCode": "610403000000",
            "countyName": "杨陵区"
          },
          {
            "countyCode": "610404000000",
            "countyName": "渭城区"
          },
          {
            "countyCode": "610422000000",
            "countyName": "三原县"
          },
          {
            "countyCode": "610423000000",
            "countyName": "泾阳县"
          },
          {
            "countyCode": "610424000000",
            "countyName": "乾县"
          },
          {
            "countyCode": "610425000000",
            "countyName": "礼泉县"
          },
          {
            "countyCode": "610426000000",
            "countyName": "永寿县"
          },
          {
            "countyCode": "610428000000",
            "countyName": "长武县"
          },
          {
            "countyCode": "610429000000",
            "countyName": "旬邑县"
          },
          {
            "countyCode": "610430000000",
            "countyName": "淳化县"
          },
          {
            "countyCode": "610431000000",
            "countyName": "武功县"
          },
          {
            "countyCode": "610481000000",
            "countyName": "兴平市"
          },
          {
            "countyCode": "610482000000",
            "countyName": "彬州市"
          }
        ]
      },
      {
        "cityName": "渭南市",
        "cityCode": "610500000000",
        "counties": [
          {
            "countyCode": "610501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610502000000",
            "countyName": "临渭区"
          },
          {
            "countyCode": "610503000000",
            "countyName": "华州区"
          },
          {
            "countyCode": "610522000000",
            "countyName": "潼关县"
          },
          {
            "countyCode": "610523000000",
            "countyName": "大荔县"
          },
          {
            "countyCode": "610524000000",
            "countyName": "合阳县"
          },
          {
            "countyCode": "610525000000",
            "countyName": "澄城县"
          },
          {
            "countyCode": "610526000000",
            "countyName": "蒲城县"
          },
          {
            "countyCode": "610527000000",
            "countyName": "白水县"
          },
          {
            "countyCode": "610528000000",
            "countyName": "富平县"
          },
          {
            "countyCode": "610581000000",
            "countyName": "韩城市"
          },
          {
            "countyCode": "610582000000",
            "countyName": "华阴市"
          }
        ]
      },
      {
        "cityName": "延安市",
        "cityCode": "610600000000",
        "counties": [
          {
            "countyCode": "610601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610602000000",
            "countyName": "宝塔区"
          },
          {
            "countyCode": "610603000000",
            "countyName": "安塞区"
          },
          {
            "countyCode": "610621000000",
            "countyName": "延长县"
          },
          {
            "countyCode": "610622000000",
            "countyName": "延川县"
          },
          {
            "countyCode": "610623000000",
            "countyName": "子长县"
          },
          {
            "countyCode": "610625000000",
            "countyName": "志丹县"
          },
          {
            "countyCode": "610626000000",
            "countyName": "吴起县"
          },
          {
            "countyCode": "610627000000",
            "countyName": "甘泉县"
          },
          {
            "countyCode": "610628000000",
            "countyName": "富县"
          },
          {
            "countyCode": "610629000000",
            "countyName": "洛川县"
          },
          {
            "countyCode": "610630000000",
            "countyName": "宜川县"
          },
          {
            "countyCode": "610631000000",
            "countyName": "黄龙县"
          },
          {
            "countyCode": "610632000000",
            "countyName": "黄陵县"
          }
        ]
      },
      {
        "cityName": "汉中市",
        "cityCode": "610700000000",
        "counties": [
          {
            "countyCode": "610701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610702000000",
            "countyName": "汉台区"
          },
          {
            "countyCode": "610703000000",
            "countyName": "南郑区"
          },
          {
            "countyCode": "610722000000",
            "countyName": "城固县"
          },
          {
            "countyCode": "610723000000",
            "countyName": "洋县"
          },
          {
            "countyCode": "610724000000",
            "countyName": "西乡县"
          },
          {
            "countyCode": "610725000000",
            "countyName": "勉县"
          },
          {
            "countyCode": "610726000000",
            "countyName": "宁强县"
          },
          {
            "countyCode": "610727000000",
            "countyName": "略阳县"
          },
          {
            "countyCode": "610728000000",
            "countyName": "镇巴县"
          },
          {
            "countyCode": "610729000000",
            "countyName": "留坝县"
          },
          {
            "countyCode": "610730000000",
            "countyName": "佛坪县"
          }
        ]
      },
      {
        "cityName": "榆林市",
        "cityCode": "610800000000",
        "counties": [
          {
            "countyCode": "610801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610802000000",
            "countyName": "榆阳区"
          },
          {
            "countyCode": "610803000000",
            "countyName": "横山区"
          },
          {
            "countyCode": "610822000000",
            "countyName": "府谷县"
          },
          {
            "countyCode": "610824000000",
            "countyName": "靖边县"
          },
          {
            "countyCode": "610825000000",
            "countyName": "定边县"
          },
          {
            "countyCode": "610826000000",
            "countyName": "绥德县"
          },
          {
            "countyCode": "610827000000",
            "countyName": "米脂县"
          },
          {
            "countyCode": "610828000000",
            "countyName": "佳县"
          },
          {
            "countyCode": "610829000000",
            "countyName": "吴堡县"
          },
          {
            "countyCode": "610830000000",
            "countyName": "清涧县"
          },
          {
            "countyCode": "610831000000",
            "countyName": "子洲县"
          },
          {
            "countyCode": "610881000000",
            "countyName": "神木市"
          }
        ]
      },
      {
        "cityName": "安康市",
        "cityCode": "610900000000",
        "counties": [
          {
            "countyCode": "610901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "610902000000",
            "countyName": "汉滨区"
          },
          {
            "countyCode": "610921000000",
            "countyName": "汉阴县"
          },
          {
            "countyCode": "610922000000",
            "countyName": "石泉县"
          },
          {
            "countyCode": "610923000000",
            "countyName": "宁陕县"
          },
          {
            "countyCode": "610924000000",
            "countyName": "紫阳县"
          },
          {
            "countyCode": "610925000000",
            "countyName": "岚皋县"
          },
          {
            "countyCode": "610926000000",
            "countyName": "平利县"
          },
          {
            "countyCode": "610927000000",
            "countyName": "镇坪县"
          },
          {
            "countyCode": "610928000000",
            "countyName": "旬阳县"
          },
          {
            "countyCode": "610929000000",
            "countyName": "白河县"
          }
        ]
      },
      {
        "cityName": "商洛市",
        "cityCode": "611000000000",
        "counties": [
          {
            "countyCode": "611001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "611002000000",
            "countyName": "商州区"
          },
          {
            "countyCode": "611021000000",
            "countyName": "洛南县"
          },
          {
            "countyCode": "611022000000",
            "countyName": "丹凤县"
          },
          {
            "countyCode": "611023000000",
            "countyName": "商南县"
          },
          {
            "countyCode": "611024000000",
            "countyName": "山阳县"
          },
          {
            "countyCode": "611025000000",
            "countyName": "镇安县"
          },
          {
            "countyCode": "611026000000",
            "countyName": "柞水县"
          }
        ]
      }
    ],
    "provinceCode": "610000000000",
    "provinceName": "陕西省"
  },
  {
    "cities": [
      {
        "cityName": "兰州市",
        "cityCode": "620100000000",
        "counties": [
          {
            "countyCode": "620101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620102000000",
            "countyName": "城关区"
          },
          {
            "countyCode": "620103000000",
            "countyName": "七里河区"
          },
          {
            "countyCode": "620104000000",
            "countyName": "西固区"
          },
          {
            "countyCode": "620105000000",
            "countyName": "安宁区"
          },
          {
            "countyCode": "620111000000",
            "countyName": "红古区"
          },
          {
            "countyCode": "620121000000",
            "countyName": "永登县"
          },
          {
            "countyCode": "620122000000",
            "countyName": "皋兰县"
          },
          {
            "countyCode": "620123000000",
            "countyName": "榆中县"
          },
          {
            "countyCode": "620171000000",
            "countyName": "兰州新区"
          }
        ]
      },
      {
        "cityName": "嘉峪关市",
        "cityCode": "620200000000",
        "counties": [
          {
            "countyCode": "620201000000",
            "countyName": "市辖区"
          }
        ]
      },
      {
        "cityName": "金昌市",
        "cityCode": "620300000000",
        "counties": [
          {
            "countyCode": "620301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620302000000",
            "countyName": "金川区"
          },
          {
            "countyCode": "620321000000",
            "countyName": "永昌县"
          }
        ]
      },
      {
        "cityName": "白银市",
        "cityCode": "620400000000",
        "counties": [
          {
            "countyCode": "620401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620402000000",
            "countyName": "白银区"
          },
          {
            "countyCode": "620403000000",
            "countyName": "平川区"
          },
          {
            "countyCode": "620421000000",
            "countyName": "靖远县"
          },
          {
            "countyCode": "620422000000",
            "countyName": "会宁县"
          },
          {
            "countyCode": "620423000000",
            "countyName": "景泰县"
          }
        ]
      },
      {
        "cityName": "天水市",
        "cityCode": "620500000000",
        "counties": [
          {
            "countyCode": "620501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620502000000",
            "countyName": "秦州区"
          },
          {
            "countyCode": "620503000000",
            "countyName": "麦积区"
          },
          {
            "countyCode": "620521000000",
            "countyName": "清水县"
          },
          {
            "countyCode": "620522000000",
            "countyName": "秦安县"
          },
          {
            "countyCode": "620523000000",
            "countyName": "甘谷县"
          },
          {
            "countyCode": "620524000000",
            "countyName": "武山县"
          },
          {
            "countyCode": "620525000000",
            "countyName": "张家川回族自治县"
          }
        ]
      },
      {
        "cityName": "武威市",
        "cityCode": "620600000000",
        "counties": [
          {
            "countyCode": "620601000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620602000000",
            "countyName": "凉州区"
          },
          {
            "countyCode": "620621000000",
            "countyName": "民勤县"
          },
          {
            "countyCode": "620622000000",
            "countyName": "古浪县"
          },
          {
            "countyCode": "620623000000",
            "countyName": "天祝藏族自治县"
          }
        ]
      },
      {
        "cityName": "张掖市",
        "cityCode": "620700000000",
        "counties": [
          {
            "countyCode": "620701000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620702000000",
            "countyName": "甘州区"
          },
          {
            "countyCode": "620721000000",
            "countyName": "肃南裕固族自治县"
          },
          {
            "countyCode": "620722000000",
            "countyName": "民乐县"
          },
          {
            "countyCode": "620723000000",
            "countyName": "临泽县"
          },
          {
            "countyCode": "620724000000",
            "countyName": "高台县"
          },
          {
            "countyCode": "620725000000",
            "countyName": "山丹县"
          }
        ]
      },
      {
        "cityName": "平凉市",
        "cityCode": "620800000000",
        "counties": [
          {
            "countyCode": "620801000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620802000000",
            "countyName": "崆峒区"
          },
          {
            "countyCode": "620821000000",
            "countyName": "泾川县"
          },
          {
            "countyCode": "620822000000",
            "countyName": "灵台县"
          },
          {
            "countyCode": "620823000000",
            "countyName": "崇信县"
          },
          {
            "countyCode": "620825000000",
            "countyName": "庄浪县"
          },
          {
            "countyCode": "620826000000",
            "countyName": "静宁县"
          },
          {
            "countyCode": "620881000000",
            "countyName": "华亭市"
          }
        ]
      },
      {
        "cityName": "酒泉市",
        "cityCode": "620900000000",
        "counties": [
          {
            "countyCode": "620901000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "620902000000",
            "countyName": "肃州区"
          },
          {
            "countyCode": "620921000000",
            "countyName": "金塔县"
          },
          {
            "countyCode": "620922000000",
            "countyName": "瓜州县"
          },
          {
            "countyCode": "620923000000",
            "countyName": "肃北蒙古族自治县"
          },
          {
            "countyCode": "620924000000",
            "countyName": "阿克塞哈萨克族自治县"
          },
          {
            "countyCode": "620981000000",
            "countyName": "玉门市"
          },
          {
            "countyCode": "620982000000",
            "countyName": "敦煌市"
          }
        ]
      },
      {
        "cityName": "庆阳市",
        "cityCode": "621000000000",
        "counties": [
          {
            "countyCode": "621001000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "621002000000",
            "countyName": "西峰区"
          },
          {
            "countyCode": "621021000000",
            "countyName": "庆城县"
          },
          {
            "countyCode": "621022000000",
            "countyName": "环县"
          },
          {
            "countyCode": "621023000000",
            "countyName": "华池县"
          },
          {
            "countyCode": "621024000000",
            "countyName": "合水县"
          },
          {
            "countyCode": "621025000000",
            "countyName": "正宁县"
          },
          {
            "countyCode": "621026000000",
            "countyName": "宁县"
          },
          {
            "countyCode": "621027000000",
            "countyName": "镇原县"
          }
        ]
      },
      {
        "cityName": "定西市",
        "cityCode": "621100000000",
        "counties": [
          {
            "countyCode": "621101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "621102000000",
            "countyName": "安定区"
          },
          {
            "countyCode": "621121000000",
            "countyName": "通渭县"
          },
          {
            "countyCode": "621122000000",
            "countyName": "陇西县"
          },
          {
            "countyCode": "621123000000",
            "countyName": "渭源县"
          },
          {
            "countyCode": "621124000000",
            "countyName": "临洮县"
          },
          {
            "countyCode": "621125000000",
            "countyName": "漳县"
          },
          {
            "countyCode": "621126000000",
            "countyName": "岷县"
          }
        ]
      },
      {
        "cityName": "陇南市",
        "cityCode": "621200000000",
        "counties": [
          {
            "countyCode": "621201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "621202000000",
            "countyName": "武都区"
          },
          {
            "countyCode": "621221000000",
            "countyName": "成县"
          },
          {
            "countyCode": "621222000000",
            "countyName": "文县"
          },
          {
            "countyCode": "621223000000",
            "countyName": "宕昌县"
          },
          {
            "countyCode": "621224000000",
            "countyName": "康县"
          },
          {
            "countyCode": "621225000000",
            "countyName": "西和县"
          },
          {
            "countyCode": "621226000000",
            "countyName": "礼县"
          },
          {
            "countyCode": "621227000000",
            "countyName": "徽县"
          },
          {
            "countyCode": "621228000000",
            "countyName": "两当县"
          }
        ]
      },
      {
        "cityName": "临夏回族自治州",
        "cityCode": "622900000000",
        "counties": [
          {
            "countyCode": "622901000000",
            "countyName": "临夏市"
          },
          {
            "countyCode": "622921000000",
            "countyName": "临夏县"
          },
          {
            "countyCode": "622922000000",
            "countyName": "康乐县"
          },
          {
            "countyCode": "622923000000",
            "countyName": "永靖县"
          },
          {
            "countyCode": "622924000000",
            "countyName": "广河县"
          },
          {
            "countyCode": "622925000000",
            "countyName": "和政县"
          },
          {
            "countyCode": "622926000000",
            "countyName": "东乡族自治县"
          },
          {
            "countyCode": "622927000000",
            "countyName": "积石山保安族东乡族撒拉族自治县"
          }
        ]
      },
      {
        "cityName": "甘南藏族自治州",
        "cityCode": "623000000000",
        "counties": [
          {
            "countyCode": "623001000000",
            "countyName": "合作市"
          },
          {
            "countyCode": "623021000000",
            "countyName": "临潭县"
          },
          {
            "countyCode": "623022000000",
            "countyName": "卓尼县"
          },
          {
            "countyCode": "623023000000",
            "countyName": "舟曲县"
          },
          {
            "countyCode": "623024000000",
            "countyName": "迭部县"
          },
          {
            "countyCode": "623025000000",
            "countyName": "玛曲县"
          },
          {
            "countyCode": "623026000000",
            "countyName": "碌曲县"
          },
          {
            "countyCode": "623027000000",
            "countyName": "夏河县"
          }
        ]
      }
    ],
    "provinceCode": "620000000000",
    "provinceName": "甘肃省"
  },
  {
    "cities": [
      {
        "cityName": "西宁市",
        "cityCode": "630100000000",
        "counties": [
          {
            "countyCode": "630101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "630102000000",
            "countyName": "城东区"
          },
          {
            "countyCode": "630103000000",
            "countyName": "城中区"
          },
          {
            "countyCode": "630104000000",
            "countyName": "城西区"
          },
          {
            "countyCode": "630105000000",
            "countyName": "城北区"
          },
          {
            "countyCode": "630121000000",
            "countyName": "大通回族土族自治县"
          },
          {
            "countyCode": "630122000000",
            "countyName": "湟中县"
          },
          {
            "countyCode": "630123000000",
            "countyName": "湟源县"
          }
        ]
      },
      {
        "cityName": "海东市",
        "cityCode": "630200000000",
        "counties": [
          {
            "countyCode": "630202000000",
            "countyName": "乐都区"
          },
          {
            "countyCode": "630203000000",
            "countyName": "平安区"
          },
          {
            "countyCode": "630222000000",
            "countyName": "民和回族土族自治县"
          },
          {
            "countyCode": "630223000000",
            "countyName": "互助土族自治县"
          },
          {
            "countyCode": "630224000000",
            "countyName": "化隆回族自治县"
          },
          {
            "countyCode": "630225000000",
            "countyName": "循化撒拉族自治县"
          }
        ]
      },
      {
        "cityName": "海北藏族自治州",
        "cityCode": "632200000000",
        "counties": [
          {
            "countyCode": "632221000000",
            "countyName": "门源回族自治县"
          },
          {
            "countyCode": "632222000000",
            "countyName": "祁连县"
          },
          {
            "countyCode": "632223000000",
            "countyName": "海晏县"
          },
          {
            "countyCode": "632224000000",
            "countyName": "刚察县"
          }
        ]
      },
      {
        "cityName": "黄南藏族自治州",
        "cityCode": "632300000000",
        "counties": [
          {
            "countyCode": "632321000000",
            "countyName": "同仁县"
          },
          {
            "countyCode": "632322000000",
            "countyName": "尖扎县"
          },
          {
            "countyCode": "632323000000",
            "countyName": "泽库县"
          },
          {
            "countyCode": "632324000000",
            "countyName": "河南蒙古族自治县"
          }
        ]
      },
      {
        "cityName": "海南藏族自治州",
        "cityCode": "632500000000",
        "counties": [
          {
            "countyCode": "632521000000",
            "countyName": "共和县"
          },
          {
            "countyCode": "632522000000",
            "countyName": "同德县"
          },
          {
            "countyCode": "632523000000",
            "countyName": "贵德县"
          },
          {
            "countyCode": "632524000000",
            "countyName": "兴海县"
          },
          {
            "countyCode": "632525000000",
            "countyName": "贵南县"
          }
        ]
      },
      {
        "cityName": "果洛藏族自治州",
        "cityCode": "632600000000",
        "counties": [
          {
            "countyCode": "632621000000",
            "countyName": "玛沁县"
          },
          {
            "countyCode": "632622000000",
            "countyName": "班玛县"
          },
          {
            "countyCode": "632623000000",
            "countyName": "甘德县"
          },
          {
            "countyCode": "632624000000",
            "countyName": "达日县"
          },
          {
            "countyCode": "632625000000",
            "countyName": "久治县"
          },
          {
            "countyCode": "632626000000",
            "countyName": "玛多县"
          }
        ]
      },
      {
        "cityName": "玉树藏族自治州",
        "cityCode": "632700000000",
        "counties": [
          {
            "countyCode": "632701000000",
            "countyName": "玉树市"
          },
          {
            "countyCode": "632722000000",
            "countyName": "杂多县"
          },
          {
            "countyCode": "632723000000",
            "countyName": "称多县"
          },
          {
            "countyCode": "632724000000",
            "countyName": "治多县"
          },
          {
            "countyCode": "632725000000",
            "countyName": "囊谦县"
          },
          {
            "countyCode": "632726000000",
            "countyName": "曲麻莱县"
          }
        ]
      },
      {
        "cityName": "海西蒙古族藏族自治州",
        "cityCode": "632800000000",
        "counties": [
          {
            "countyCode": "632801000000",
            "countyName": "格尔木市"
          },
          {
            "countyCode": "632802000000",
            "countyName": "德令哈市"
          },
          {
            "countyCode": "632803000000",
            "countyName": "茫崖市"
          },
          {
            "countyCode": "632821000000",
            "countyName": "乌兰县"
          },
          {
            "countyCode": "632822000000",
            "countyName": "都兰县"
          },
          {
            "countyCode": "632823000000",
            "countyName": "天峻县"
          },
          {
            "countyCode": "632857000000",
            "countyName": "大柴旦行政委员会"
          }
        ]
      }
    ],
    "provinceCode": "630000000000",
    "provinceName": "青海省"
  },
  {
    "cities": [
      {
        "cityName": "银川市",
        "cityCode": "640100000000",
        "counties": [
          {
            "countyCode": "640101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "640104000000",
            "countyName": "兴庆区"
          },
          {
            "countyCode": "640105000000",
            "countyName": "西夏区"
          },
          {
            "countyCode": "640106000000",
            "countyName": "金凤区"
          },
          {
            "countyCode": "640121000000",
            "countyName": "永宁县"
          },
          {
            "countyCode": "640122000000",
            "countyName": "贺兰县"
          },
          {
            "countyCode": "640181000000",
            "countyName": "灵武市"
          }
        ]
      },
      {
        "cityName": "石嘴山市",
        "cityCode": "640200000000",
        "counties": [
          {
            "countyCode": "640201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "640202000000",
            "countyName": "大武口区"
          },
          {
            "countyCode": "640205000000",
            "countyName": "惠农区"
          },
          {
            "countyCode": "640221000000",
            "countyName": "平罗县"
          }
        ]
      },
      {
        "cityName": "吴忠市",
        "cityCode": "640300000000",
        "counties": [
          {
            "countyCode": "640301000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "640302000000",
            "countyName": "利通区"
          },
          {
            "countyCode": "640303000000",
            "countyName": "红寺堡区"
          },
          {
            "countyCode": "640323000000",
            "countyName": "盐池县"
          },
          {
            "countyCode": "640324000000",
            "countyName": "同心县"
          },
          {
            "countyCode": "640381000000",
            "countyName": "青铜峡市"
          }
        ]
      },
      {
        "cityName": "固原市",
        "cityCode": "640400000000",
        "counties": [
          {
            "countyCode": "640401000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "640402000000",
            "countyName": "原州区"
          },
          {
            "countyCode": "640422000000",
            "countyName": "西吉县"
          },
          {
            "countyCode": "640423000000",
            "countyName": "隆德县"
          },
          {
            "countyCode": "640424000000",
            "countyName": "泾源县"
          },
          {
            "countyCode": "640425000000",
            "countyName": "彭阳县"
          }
        ]
      },
      {
        "cityName": "中卫市",
        "cityCode": "640500000000",
        "counties": [
          {
            "countyCode": "640501000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "640502000000",
            "countyName": "沙坡头区"
          },
          {
            "countyCode": "640521000000",
            "countyName": "中宁县"
          },
          {
            "countyCode": "640522000000",
            "countyName": "海原县"
          }
        ]
      }
    ],
    "provinceCode": "640000000000",
    "provinceName": "宁夏回族自治区"
  },
  {
    "cities": [
      {
        "cityName": "乌鲁木齐市",
        "cityCode": "650100000000",
        "counties": [
          {
            "countyCode": "650101000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "650102000000",
            "countyName": "天山区"
          },
          {
            "countyCode": "650103000000",
            "countyName": "沙依巴克区"
          },
          {
            "countyCode": "650104000000",
            "countyName": "新市区"
          },
          {
            "countyCode": "650105000000",
            "countyName": "水磨沟区"
          },
          {
            "countyCode": "650106000000",
            "countyName": "头屯河区"
          },
          {
            "countyCode": "650107000000",
            "countyName": "达坂城区"
          },
          {
            "countyCode": "650109000000",
            "countyName": "米东区"
          },
          {
            "countyCode": "650121000000",
            "countyName": "乌鲁木齐县"
          },
          {
            "countyCode": "650171000000",
            "countyName": "乌鲁木齐经济技术开发区"
          },
          {
            "countyCode": "650172000000",
            "countyName": "乌鲁木齐高新技术产业开发区"
          }
        ]
      },
      {
        "cityName": "克拉玛依市",
        "cityCode": "650200000000",
        "counties": [
          {
            "countyCode": "650201000000",
            "countyName": "市辖区"
          },
          {
            "countyCode": "650202000000",
            "countyName": "独山子区"
          },
          {
            "countyCode": "650203000000",
            "countyName": "克拉玛依区"
          },
          {
            "countyCode": "650204000000",
            "countyName": "白碱滩区"
          },
          {
            "countyCode": "650205000000",
            "countyName": "乌尔禾区"
          }
        ]
      },
      {
        "cityName": "吐鲁番市",
        "cityCode": "650400000000",
        "counties": [
          {
            "countyCode": "650402000000",
            "countyName": "高昌区"
          },
          {
            "countyCode": "650421000000",
            "countyName": "鄯善县"
          },
          {
            "countyCode": "650422000000",
            "countyName": "托克逊县"
          }
        ]
      },
      {
        "cityName": "哈密市",
        "cityCode": "650500000000",
        "counties": [
          {
            "countyCode": "650502000000",
            "countyName": "伊州区"
          },
          {
            "countyCode": "650521000000",
            "countyName": "巴里坤哈萨克自治县"
          },
          {
            "countyCode": "650522000000",
            "countyName": "伊吾县"
          }
        ]
      },
      {
        "cityName": "昌吉回族自治州",
        "cityCode": "652300000000",
        "counties": [
          {
            "countyCode": "652301000000",
            "countyName": "昌吉市"
          },
          {
            "countyCode": "652302000000",
            "countyName": "阜康市"
          },
          {
            "countyCode": "652323000000",
            "countyName": "呼图壁县"
          },
          {
            "countyCode": "652324000000",
            "countyName": "玛纳斯县"
          },
          {
            "countyCode": "652325000000",
            "countyName": "奇台县"
          },
          {
            "countyCode": "652327000000",
            "countyName": "吉木萨尔县"
          },
          {
            "countyCode": "652328000000",
            "countyName": "木垒哈萨克自治县"
          }
        ]
      },
      {
        "cityName": "博尔塔拉蒙古自治州",
        "cityCode": "652700000000",
        "counties": [
          {
            "countyCode": "652701000000",
            "countyName": "博乐市"
          },
          {
            "countyCode": "652702000000",
            "countyName": "阿拉山口市"
          },
          {
            "countyCode": "652722000000",
            "countyName": "精河县"
          },
          {
            "countyCode": "652723000000",
            "countyName": "温泉县"
          }
        ]
      },
      {
        "cityName": "巴音郭楞蒙古自治州",
        "cityCode": "652800000000",
        "counties": [
          {
            "countyCode": "652801000000",
            "countyName": "库尔勒市"
          },
          {
            "countyCode": "652822000000",
            "countyName": "轮台县"
          },
          {
            "countyCode": "652823000000",
            "countyName": "尉犁县"
          },
          {
            "countyCode": "652824000000",
            "countyName": "若羌县"
          },
          {
            "countyCode": "652825000000",
            "countyName": "且末县"
          },
          {
            "countyCode": "652826000000",
            "countyName": "焉耆回族自治县"
          },
          {
            "countyCode": "652827000000",
            "countyName": "和静县"
          },
          {
            "countyCode": "652828000000",
            "countyName": "和硕县"
          },
          {
            "countyCode": "652829000000",
            "countyName": "博湖县"
          },
          {
            "countyCode": "652871000000",
            "countyName": "库尔勒经济技术开发区"
          }
        ]
      },
      {
        "cityName": "阿克苏地区",
        "cityCode": "652900000000",
        "counties": [
          {
            "countyCode": "652901000000",
            "countyName": "阿克苏市"
          },
          {
            "countyCode": "652922000000",
            "countyName": "温宿县"
          },
          {
            "countyCode": "652923000000",
            "countyName": "库车县"
          },
          {
            "countyCode": "652924000000",
            "countyName": "沙雅县"
          },
          {
            "countyCode": "652925000000",
            "countyName": "新和县"
          },
          {
            "countyCode": "652926000000",
            "countyName": "拜城县"
          },
          {
            "countyCode": "652927000000",
            "countyName": "乌什县"
          },
          {
            "countyCode": "652928000000",
            "countyName": "阿瓦提县"
          },
          {
            "countyCode": "652929000000",
            "countyName": "柯坪县"
          }
        ]
      },
      {
        "cityName": "克孜勒苏柯尔克孜自治州",
        "cityCode": "653000000000",
        "counties": [
          {
            "countyCode": "653001000000",
            "countyName": "阿图什市"
          },
          {
            "countyCode": "653022000000",
            "countyName": "阿克陶县"
          },
          {
            "countyCode": "653023000000",
            "countyName": "阿合奇县"
          },
          {
            "countyCode": "653024000000",
            "countyName": "乌恰县"
          }
        ]
      },
      {
        "cityName": "喀什地区",
        "cityCode": "653100000000",
        "counties": [
          {
            "countyCode": "653101000000",
            "countyName": "喀什市"
          },
          {
            "countyCode": "653121000000",
            "countyName": "疏附县"
          },
          {
            "countyCode": "653122000000",
            "countyName": "疏勒县"
          },
          {
            "countyCode": "653123000000",
            "countyName": "英吉沙县"
          },
          {
            "countyCode": "653124000000",
            "countyName": "泽普县"
          },
          {
            "countyCode": "653125000000",
            "countyName": "莎车县"
          },
          {
            "countyCode": "653126000000",
            "countyName": "叶城县"
          },
          {
            "countyCode": "653127000000",
            "countyName": "麦盖提县"
          },
          {
            "countyCode": "653128000000",
            "countyName": "岳普湖县"
          },
          {
            "countyCode": "653129000000",
            "countyName": "伽师县"
          },
          {
            "countyCode": "653130000000",
            "countyName": "巴楚县"
          },
          {
            "countyCode": "653131000000",
            "countyName": "塔什库尔干塔吉克自治县"
          }
        ]
      },
      {
        "cityName": "和田地区",
        "cityCode": "653200000000",
        "counties": [
          {
            "countyCode": "653201000000",
            "countyName": "和田市"
          },
          {
            "countyCode": "653221000000",
            "countyName": "和田县"
          },
          {
            "countyCode": "653222000000",
            "countyName": "墨玉县"
          },
          {
            "countyCode": "653223000000",
            "countyName": "皮山县"
          },
          {
            "countyCode": "653224000000",
            "countyName": "洛浦县"
          },
          {
            "countyCode": "653225000000",
            "countyName": "策勒县"
          },
          {
            "countyCode": "653226000000",
            "countyName": "于田县"
          },
          {
            "countyCode": "653227000000",
            "countyName": "民丰县"
          }
        ]
      },
      {
        "cityName": "伊犁哈萨克自治州",
        "cityCode": "654000000000",
        "counties": [
          {
            "countyCode": "654002000000",
            "countyName": "伊宁市"
          },
          {
            "countyCode": "654003000000",
            "countyName": "奎屯市"
          },
          {
            "countyCode": "654004000000",
            "countyName": "霍尔果斯市"
          },
          {
            "countyCode": "654021000000",
            "countyName": "伊宁县"
          },
          {
            "countyCode": "654022000000",
            "countyName": "察布查尔锡伯自治县"
          },
          {
            "countyCode": "654023000000",
            "countyName": "霍城县"
          },
          {
            "countyCode": "654024000000",
            "countyName": "巩留县"
          },
          {
            "countyCode": "654025000000",
            "countyName": "新源县"
          },
          {
            "countyCode": "654026000000",
            "countyName": "昭苏县"
          },
          {
            "countyCode": "654027000000",
            "countyName": "特克斯县"
          },
          {
            "countyCode": "654028000000",
            "countyName": "尼勒克县"
          }
        ]
      },
      {
        "cityName": "塔城地区",
        "cityCode": "654200000000",
        "counties": [
          {
            "countyCode": "654201000000",
            "countyName": "塔城市"
          },
          {
            "countyCode": "654202000000",
            "countyName": "乌苏市"
          },
          {
            "countyCode": "654221000000",
            "countyName": "额敏县"
          },
          {
            "countyCode": "654223000000",
            "countyName": "沙湾县"
          },
          {
            "countyCode": "654224000000",
            "countyName": "托里县"
          },
          {
            "countyCode": "654225000000",
            "countyName": "裕民县"
          },
          {
            "countyCode": "654226000000",
            "countyName": "和布克赛尔蒙古自治县"
          }
        ]
      },
      {
        "cityName": "阿勒泰地区",
        "cityCode": "654300000000",
        "counties": [
          {
            "countyCode": "654301000000",
            "countyName": "阿勒泰市"
          },
          {
            "countyCode": "654321000000",
            "countyName": "布尔津县"
          },
          {
            "countyCode": "654322000000",
            "countyName": "富蕴县"
          },
          {
            "countyCode": "654323000000",
            "countyName": "福海县"
          },
          {
            "countyCode": "654324000000",
            "countyName": "哈巴河县"
          },
          {
            "countyCode": "654325000000",
            "countyName": "青河县"
          },
          {
            "countyCode": "654326000000",
            "countyName": "吉木乃县"
          }
        ]
      },
      {
        "cityName": "自治区直辖县级行政区划",
        "cityCode": "659000000000",
        "counties": [
          {
            "countyCode": "659001000000",
            "countyName": "石河子市"
          },
          {
            "countyCode": "659002000000",
            "countyName": "阿拉尔市"
          },
          {
            "countyCode": "659003000000",
            "countyName": "图木舒克市"
          },
          {
            "countyCode": "659004000000",
            "countyName": "五家渠市"
          },
          {
            "countyCode": "659006000000",
            "countyName": "铁门关市"
          }
        ]
      }
    ],
    "provinceCode": "650000000000",
    "provinceName": "新疆维吾尔自治区"
  },
  {
    "cities": [
      {
        "cityName": "台湾",
        "cityCode": "970100000000",
        "counties": [
          {
            "countyCode": "970101000000",
            "countyName": "台湾市区内"
          }
        ]
      }
    ],
    "provinceCode": "970000000000",
    "provinceName": "台湾"
  },
  {
    "cities": [
      {
        "cityName": "澳门特别行政区",
        "cityCode": "980100000000",
        "counties": [
          {
            "countyCode": "980101000000",
            "countyName": "澳门市区内"
          }
        ]
      }
    ],
    "provinceCode": "980000000000",
    "provinceName": "澳门特别行政区"
  },
  {
    "cities": [
      {
        "cityName": "香港特别行政区",
        "cityCode": "990100000000",
        "counties": [
          {
            "countyCode": "990101000000",
            "countyName": "香港市区内"
          }
        ]
      }
    ],
    "provinceCode": "990000000000",
    "provinceName": "香港特别行政区"
  }
]
